/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useEffect, useState, useCallback, useRef } from "react";
import { useHistory } from "react-router-dom";
import { Accordion, Button, Container, Form, Grid, Icon, Loader, Image, SemanticWIDTHS, Transition, Message, Dropdown, Breadcrumb } from "semantic-ui-react";
import BCMessage from "../ui/BCMessage";
import BCTabMenuBar from "../ui/BCTabMenuBar";
import BCDashboard from "../ui/BCDashboard";
import BCContactUsInfo from "../ui/BCContactUsInfo";
import BCFormInput from "../ui/BCFormInput";
import BCTable from "../ui/BCTable";
import BCUploadBox from "../ui/BCUploadBox";
import BCEmptyState from "../ui/BCEmptyState";
import { deleteMockLoanUnit, deleteMockLoanProperty, addMockLoanUnits } from "../../api/mock/MockBrokerApi";
import { createMockLoanComment, createMockLoanDocument, deleteMockGuarantor, deleteMockGuarantorALSchedule, deleteMockLoanDocument, downloadMockLoanDocument, downloadMockPayeezyInvoice, exportMockGMRQuote, exportMockGMRQuotes, getMockApplicationInfo, getMockApplicationMetadata, getMockBorrowerEntity, getMockBrokerGuarantors, getMockInternalContacts, getMockGMRMetadata, getMockGmrScenarios, getMockGMRSummary, getMockGuarantorExists, getMockGuarantors, getMockLoanComments, getMockLoanDocuments, getMockLoanDocumentsMetadata, getMockPayeezyLoanInvoices, getMockPayeezyPaymentPage, patchMockLoanComments, pullMockCreditScore, requestMockApplicationRevision, resendMockGuarantorInvite, saveMockLoanDetails, saveMockProperties, sendMockApplicationToPrescreener, submitMockApplicationForReview, updateMockLoanDocument, upsertMockBorrowerEntity, upsertMockGuarantor, getMockLoanInfo, getMockBrokerBuilder, deleteMockLoanCostsPaids, getMockApplicationInfolist, getMockBorrowerApplicationEntities, patchMockBorrowerApplicationEntities } from "../../api/mock/MockBrokerApi";
import { createLoanDocument, deleteLoanALSchedules, deleteGuarantor, deleteLoanDocument, deleteLoanREO, deleteLoanUnit, downloadLoanDocument, exportGMRQuote, getApplicationMetadata, getBorrowerEntity, getGMRSummary, getGuarantors, getLoanDocuments, getLoanDocumentsMetadata, getLoanInfo, resendGuarantorInvite, saveLoanDetails, updateLoanDocument, upsertBorrowerEntity, upsertGuarantor, getBorrowerApplicationInfo, getGMRMetadata, sendApplicationToPrescreener, requestApplicationRevision, pullCreditScore, getGmrScenarios, exportGMRQuotes, submitApplicationForReview, getPayeezyLoanInvoices, getPayeezyPaymentPage, downloadPayeezyInvoice, getBrokerGuarantors, getGuarantorExists, deleteGuarantorALSchedule, getLoanComments, createLoanComment, patchLoanComments, getInternalContacts, patchLoanProjectSection, patchLoanProperties, patchLoanGuarantorSection, patchLoanBorrowerSection, getBrokerBuilder, deleteLoanCostsPaids, getApplicationInfoList, getBorrowerApplicationEntities, patchBorrowerApplicationEntities, postLoanReoSchedules, patchLoanReoSchedules, deleteLoanProperty, addLoanUnits } from "../../api/BrokerApi";
import { convertToDateString, convertToPercent, convertToYesNo, createFile, getDropdownOptions, getStateFullOptions, guid, handleFormChange, handleGetValueFromId, handleInputType, isApplicationGuarantor, isValidPermission, operationOfNumberArray, roundNumber, validateObj, formatPatch, handleAddressValue, deepCopy, handleGetIdFromValue, handleErrorResponse, setBackgroundColor, convertToMinFraction, formatDataProperties, formatLeadingNumber, validateEmails, setColor, combineAddresses, isValidGuarantorAccessLevel, filterOutCollateral, handleNestedValidation } from "../../Helpers";
import "../../styles/broker-application.scss";
import "../../styles/ui.scss";
import { css } from "@emotion/css";
import { BrokerConstants, ConfigDefaults } from "../constants/BrokerConstants";
import { GlobalConstants, Personas } from "../constants/GlobalConstants";
import BPPricingScenario from "./BPPricingScenario";
import BCValidationMessage from "../ui/BCValidationMessage";
import BPLoanDetailEditButtons from "./InteriorCard/BPLoanDetailEditButtons";
import BPLoanProjectContent from "./InteriorCard/BPLoanProjectContent";
import { addTimestamp, addNotValidProps, getGameChangerIframeSource } from "../../helpers/GlobalHelper";
import BPLoanPropertiesContent from "./InteriorCard/BPLoanPropertiesContent";
import BPLoanGuarantorListContent from "./InteriorCard/BPLoanGuarantorListContent";
import BPLoanGuarantorInfoContent from "./InteriorCard/BPLoanGuarantorInfoContent";
import BCModal from "../ui/BCModal";
import BCButtonDropdown from "../ui/BCButtonDropdown";
import BPLoanBorrowerContent from "./InteriorCard/BPLoanBorrowerContent";
import { getIsWhiteLabeled, whoAmI } from "../../helpers/PermissionHelper";
import { FeatureFlags } from "../constants/LocalServerConstants";
import { getAuthToken } from "../../api/GlobalApi";
import { BPQuestionLabels } from "./BPQuestionLabels";

interface ILoanDocumentInfo {
  "id": string;
  "organizationContactId": string;
  "display": string;
  "documentMasterId": string;
  "createdOn": string;
  "updatedOn": string;
  "createdBy": string;
  "description": string;
  "loanId": string;
  "metadata": string;
}

interface IFormattedApplicationCostPaid {
  "Cost": string;
  "Amount": string;
  "Description"?: string;
}

interface IFormattedApplicationUnitLoanTerm {
  "Property": string;
  "Unit": string;
  "Month of First Draw": string;
  "Months to Finish Construction": string;
  "Time Frame to Sell or Refinance": string;
  "Anticipated Payoff": string;
}

interface IFormattedBorrowerAL {
  "Type": string;
  "Institution": string;
  "Current balance": string;
  "Monthly Liability"?: string;
}

interface IFormattedBorrowerREO {
  "REO Type": string;
  "Status": string;
  "Mortgage Free": string;
  "Street": string;
  "City": string;
  "State": string;
  "Zip Code": string;
  "Market Value": string;
  "Monthly Tax": string;
}

interface IFormattedApplicationProperty {
  "Address": string;
  "Unit"?: string;
  "Property Type": string;
  "Current Value (AIV)"?: string;
  "Completed Value (ARV)"?: string;
  "Budget": string;
  "Bedrooms"?: number;
  "Bathrooms"?: number;
  "Car Garage"?: number;
  "Square Feet"?: string;
  "Plan"?: string;
}

interface IApplicationPlan {
  id: string;
  name: string;
  numberOfBedroom: number;
  numberOfBathroom: number;
  numberOfCarGarage: number;
  squareFootage: number;
  asIsValue: number;
  afterRepairValue: number;
}

interface IApplicationDocumentInfoView {
  id: string;
  "Document": string;
  "Uploaded By": string;
  "Uploaded On": string;
}

interface IApplicationDetailSectionInput {
  value: any;
  valueHidden?: any;
  sendBackValue?: any;
  label?: string;
  actionText?: string;
  actionLabel?: string;
  labelAction?: any;
  actionLabelClass?: string;
  size?: SemanticWIDTHS;
  unitType?: string;
  readonly?: boolean;
  field?: string;
  allowNegativeValue?: boolean;
  inputType?: string;
  condition?: boolean;
  dropdown?: any;
  address?: any;
  original?: any;
  originalIdValueFrom?: any;
  date?: any;
  calendar?: boolean;
  checkbox?: boolean;
}

interface IApplicationDetailSectionContentProps {
  isGreaterThanMobile: boolean;
  accordionObject: any;
  accordionObjectArray: any;
  setAccordionObject: (value: any) => any;
  isEditMode: boolean;
  handleFormChange: (value: string, field: string, obj: any, setObj: (value: any) => any, type: string, handleCustomFormChange?: any, charLimit?: number, index?: number, objArray?: any) => void;
  index?: number;
  inputs?: IApplicationDetailSectionInput[];
  isLoanApplication?: boolean;
  borrowerApplicationInfo?: any;
}

interface IApplicationDetailSectionProps {
  title: string;
  accordionId: string;
  isGreaterThanMobile: boolean;
  activeAccordions: string[];
  applicationInfo?: any;
  applicationMetadata?: any;
  pricingInfo?: any;
  handleActiveAccordions: (accordionId: string) => void;
  accordionObject: any;
  accordionObjectArray?: any;
  setAccordionObject: (value: any) => any;
  isEditMode: boolean;
  handleFormChange: (value: string, field: string, obj: any, setObj: (value: any) => any, type: string, handleCustomFormChange?: any, charLimit?: number, index?: number) => void;
  index?: number;
  handleEditApplication: any;
  inputs?: IApplicationDetailSectionInput[];
  table?: any;
  brokerButtonOverrideCSS: any;
  handleAdd?: any;
  dropdown?: any;
  permissions?: any[];
  isLoanApplication?: boolean;
  borrowerApplicationInfo?: any;
}

interface IApplicationBuilder {
  builderOrganizationId: string;
  name: string;
  entitySubTypeId: string;
  entitySubTypeName?: string;
  employerIdentificationNumber?: string;
  website?: string;
  street: string;
  cityName: string;
  stateName: string;
  zip: number;
}

interface IPayeezyLoanInvoice {
  id: string;
  name: string;
  description: string;
  fee: number;
  bankCharges: number;
  totalAmount: number;
  transactionStatus: string;
  paidBy: string;
  paidOn: string;
}

interface ICommentEmailToList {
  email: string;
  title: string;
}

interface ILoanComment {
  id: string;
  subject: string;
  category: string;
  description: string;
  isExternal: boolean;
  createdBy: string;
  createdOn: string;
  fullName: string;
  emailToList: ICommentEmailToList[];
}

interface IRecipientEntity {
  id: string;
  name: string;
  email: string;
  title: string;
  department: string;
}

const ApplicationDetailSectionContent = ({ ...props }: IApplicationDetailSectionContentProps) => {
  return (
    <Grid>
      <Grid.Row className="details-row">
        {props.inputs?.map((input, i) => {
          if (input && (input.label || input.actionLabel) && (input.value || (!input.readonly)) && input.condition !== false) {
            return (
              <Grid.Column key={`ApplicationDetailSectionInput-${i}`} className="primary-details" width={props.isGreaterThanMobile ? input.size : 16}>
                {input.dropdown ? <BCFormInput
                  labelClass="gmr-background-label"
                  type="dropdown"
                  label={input.label}
                  actionText={input.actionText}
                  actionLabel={input.actionLabel}
                  labelAction={input.labelAction}
                  actionLabelClass={input.actionLabelClass}
                  placeholder="Please Select..."
                  value={(input.field && props.accordionObject[input.field] && props.isEditMode === true) ? props.accordionObject[input.field] : input.value}
                  obj={props.accordionObject}
                  field={input.field}
                  dropdownOptions={input.dropdown}
                  handleFormChange={(value, field) => props.handleFormChange(
                    value,
                    field,
                    props.accordionObject,
                    props.setAccordionObject,
                    input.inputType ? input.inputType : input.unitType === "$" ? GlobalConstants.InputTypes.FLOAT : GlobalConstants.InputTypes.STRING,
                    undefined,
                    undefined,
                    props.index,
                    props.accordionObjectArray)
                  }
                  disabled={!props.isEditMode || input.readonly || !props.isLoanApplication}
                /> :
                  input.address ? input.address
                  : input.calendar ? <BCFormInput 
                    value={input.valueHidden ? "" : convertToDateString(input.value, "calendar")}
                    type="calendar"
                    labelClass="gmr-background-label"
                    label={input.label}
                    actionText={input.actionText}
                    actionLabel={input.actionLabel}
                    labelAction={input.labelAction}
                    actionLabelClass={input.actionLabelClass}
                    obj={props.accordionObject}
                    field={input.field}
                    handleFormChange={(value, field) => props.handleFormChange(
                      addTimestamp(value),
                      field,
                      props.accordionObject,
                      props.setAccordionObject,
                      GlobalConstants.InputTypes.STRING,
                      undefined,
                      undefined,
                      props.index,
                      props.accordionObjectArray
                    )}
                    disabled={!props.isEditMode || input.readonly || !props.isLoanApplication || input.valueHidden}
                  />
                  : input.checkbox ? <div className="interior-card-checkbox"><BCFormInput 
                    value={input.valueHidden ? "" : convertToDateString(input.value, "calendar")}
                    type="checkbox"
                    labelClass="gmr-background-label"
                    label={input.label}
                    obj={props.accordionObject}
                    field={input.field}
                    handleFormChange={(value, field) => props.handleFormChange(
                      value,
                      field,
                      props.accordionObject,
                      props.setAccordionObject,
                      GlobalConstants.InputTypes.STRING,
                      undefined,
                      undefined,
                      props.index,
                      props.accordionObjectArray
                    )}
                    disabled={!props.isEditMode || input.readonly || !props.isLoanApplication || input.valueHidden}
                  /></div>
                  : <BCFormInput
                    labelClass="gmr-background-label"
                    type="input"
                    label={input.label}
                    actionText={input.actionText}
                    actionLabel={input.actionLabel}
                    labelAction={input.labelAction}
                    actionLabelClass={input.actionLabelClass}
                    value={(input.field && props.accordionObject[input.field] && props.isEditMode === true) 
                      ? (input.valueHidden ? input.value : props.accordionObject[input.field]) 
                      : input.value}
                    field={input.field}
                    fieldType={input.inputType ? input.inputType : (input.unitType && input.unitType === "$") ? GlobalConstants.InputTypes.FLOAT :
                      (input.unitType && input.unitType === "%") ? "percent" : null}
                    obj={props.accordionObject}
                    handleFormChange={(value, field) => props.handleFormChange(
                      value,
                      field,
                      props.accordionObject,
                      props.setAccordionObject,
                      input.inputType ? input.inputType : input.unitType === "$" ? GlobalConstants.InputTypes.FLOAT : GlobalConstants.InputTypes.STRING,
                      undefined,
                      undefined,
                      props.index,
                      props.accordionObjectArray
                    )}
                    unitType={input.unitType}
                    disabled={!props.isEditMode || input.readonly || !props.isLoanApplication || input.valueHidden}
                    allowNegativeValue={input.allowNegativeValue}
                  />}
                {<div className="version-dropdown"> 
                  {(props.isLoanApplication && (input.original !== 0 && input.original) && input.value !== input.original) 
                    && (input.originalIdValueFrom ? `Original: ${handleGetValueFromId(input.originalIdValueFrom, input.original)}` : `Original: ${input.original}`)}
                </div>}
              </Grid.Column>
            );
          }
          else {
            return null;
          }
        })}
      </Grid.Row>
    </Grid>
  );
};

const ApplicationDetailSection = ({ ...props }: IApplicationDetailSectionProps) => {
  const handleApplicationDetailSectionEmpty = (inputs) => {
    let isSectionValid = false;
    if (((props.applicationInfo && props.applicationMetadata) || props.pricingInfo) && inputs && inputs.length > 0) {
      inputs.forEach(input => {
        if (input.value) {
          isSectionValid = true;
        }
      });
    }

    return isSectionValid;
  };

  const isInputsValid = handleApplicationDetailSectionEmpty(props.inputs);
  return (
    <Accordion className="accordion-details-title">
      <Accordion.Title
        className="summary-accordion-title"
        active={props.activeAccordions.includes(props.accordionId)}
        index={props.accordionId}
        onClick={() => props.handleActiveAccordions(props.accordionId)}
      >
        <BCFormInput
          labelClass={"secondary-title-label form-input-header-secondary form-input-border-secondary cursor-pointer"}
          label={props.title}
          labelIcon={<Icon name='dropdown' />}
        />
      </Accordion.Title>
      <Accordion.Content active={props.activeAccordions.includes(props.accordionId)}>
        {isInputsValid && <ApplicationDetailSectionContent
          isGreaterThanMobile={props.isGreaterThanMobile}
          inputs={props.inputs}
          accordionObject={props.accordionObject}
          accordionObjectArray={props.accordionObjectArray}
          setAccordionObject={props.setAccordionObject}
          isEditMode={props.isEditMode}
          handleFormChange={props.handleFormChange}
          isLoanApplication={props.isLoanApplication}
          borrowerApplicationInfo={props.borrowerApplicationInfo}
          index={props.index}
        />}
        {props.table}

        {(!isInputsValid && !props.table) && <Grid>
          <Grid.Row className="details-row">
            <Grid.Column width={16}>
              <BCEmptyState
                emptyStateClass="application-details-empty-state"
                icon="pencil"
                text={`Looks like there isn't any ${props.title.toLocaleLowerCase()}.`}
                button={(props.isEditMode && props.handleAdd) ? <Button
                  className={getIsWhiteLabeled() ? `details-button ${props.brokerButtonOverrideCSS}` : "bp-button details-button"}
                  icon
                  onClick={props.handleAdd}
                >Add {props.title}</Button> : null}
              />
            </Grid.Column>
          </Grid.Row>
        </Grid>}
      </Accordion.Content>
    </Accordion>
  );
};

const BPApplication = ({
  isGreaterThanMobile,
  isGreaterThanTablet,
  isSidebar,
  isMessage,
  setIsMessage,
  errorResponse,
  setErrorResponse,
  proxyUser,
  applicationId,
  isModalOpen,
  setIsModalOpen,
  user,
  permissions,
  setGmrEditData,
  brokerColor,
  setSuccessMessage,
  isPricing,
  organizationContactId
}) => {
  const brokerButtonOverrideCSS = css`
    background-color: ${brokerColor ? brokerColor : "black"} !important;
    color:#ffffff !important;
    font-family: $fontFamily !important;
    margin-top: 10px;
    width: 25%;
  `;

  const brokerIconColorOverride = css`
    color: ${brokerColor ? brokerColor : "black"} !important;
    font-family: $fontFamily !important;
    margin-top: 10px;
    width: 25%;
  `;

  const BPApplicationAccordions = {
    "PricingLoanSummary": {
      id: "9af9e600-dd0a-4d96-ac69-f40518116430",
      name: "Loan Summary"
    },
    "PricingLoanDetails": {
      id: "af9542f2-70ed-43c6-b840-ebe2fbd4ea69",
      name: "Loan Details"
    },
    "PricingProjectDetails": {
      id: "621c9840-9276-432a-842a-14a8a825f86a",
      name: "Project Details"
    },
    "PricingProjectBreakdown": {
      id: "98b01e61-3e62-4279-9ab4-9bd0a17277cf",
      name: "Project Breakdown"
    },
    "DetailsOverview": {
      id: "46c33d35-42ae-4754-8675-93efed0aff23",
      name: "Overview"
    },
    "DetailsFinancials": {
      id: "49184021-b280-49c2-97af-1b442e4aa41a",
      name: "Financials"
    },
    "DetailsSiteDevelopment": {
      id: "b07d6c26-7df0-496c-aba2-ce432f719285",
      name: "Site Development"
    },
    "DetailsConstruction": {
      id: "bbdbad43-e685-4e70-9d88-f7deebc46f63",
      name: "Construction"
    },
    "DetailsTerm": {
      id: "b1689955-2315-4415-a97a-77e5fa63b5df",
      name: "Construction Completion Schedule and Loan Term"
    },
    "BorrowerInformation": {
      id: "f337c056-9835-4934-96db-0ba797d6f81b",
      name: "Borrower Information"
    },
    "BorrowerExperience": {
      id: "6c04c3d8-09dd-4215-a8a0-27508902e4a8",
      name: "Borrower Experience"
    },
    "BorrowerAssets": {
      id: "11f0c238-ce76-4077-8fe1-eb30b652bb35",
      name: "Assets"
    },
    "BorrowerLiabilities": {
      id: "b4bc776c-cc08-4943-8749-564280cbbeb9",
      name: "Liabilities"
    },
    "BorrowerREO": {
      id: "047b0469-6bbe-448c-8416-3f9976e125bb",
      name: "Real Estate Owned"
    },
    "Properties": {
      id: "047b0469-6bbe-448c-8416-3f9976e125bb",
      name: "Properties"
    },
    "CollateralProperties": {
      id: "c4c4f05b-650b-4da7-abf6-cf52f852d8c8",
      name: "Collateral Properties"
    },
    "BuilderInfo": {
      id: "39cd8eea-2694-40ae-864b-e8711f2882a3",
      name: "Builder Information"
    },
  };

  const BPGuarantorAccordions = {
    "ContactInformation": {
      name: "Contact Information"
    },
    "PersonalDetails": {
      name: "Personal Details"
    },
    "CreditScore": {
      name: "Credit Score"
    },
    "Assets": {
      name: "Assets"
    },
    "Liabilities": {
      name: "Liabilities"
    },
    "ReoSchedules": {
      name: "Real Estate Owned Schedules"
    },
    "DisclosureStatuses": {
      name: "Authorizations and Disclosures:"
    },
  };

  const BPRevisionSubmitOptions = [
    { key: "Request Revision", icon: "arrow alternate circle left", text: "Request Revision", value: "Request Revision" },
    { key: "Send to Underwriting", icon: "arrow alternate circle right", text: "Send to Underwriting", value: "Send to Underwriting" },
  ];

  const versionOptions = [{ key: 0, text: "Original Version", value: "Original Version", icon: "history" }, { key: 1, text: "Current Version", value: "Current Version", icon: "bars" }];
  const [interiorCardSuccessMessage, setInteriorCardSuccessMessage] = useState("" as string);
  const [isGmrInteriorCardView, setIsGmrInteriorCardView] = useState(false as boolean);
  const [isLoading, setIsLoading] = useState(true as boolean);
  const [revisionObject, setRevisionObject] = useState({} as any);
  const [isInteriorCardLoading, setIsInteriorCardLoading] = useState(false as boolean);
  const [applicationMetadata, setApplicationMetadata] = useState(undefined as any);
  const [pricingInfo, setPricingInfo] = useState(undefined as any);
  const [borrowerApplicationInfo, setBorrowerApplicationInfo] = useState(undefined as any);
  const [borrowerApplicationBuilderInfo, setBorrowerApplicationBuilderInfo] = useState(undefined as any);
  const [borrowerApplicationProperties, setBorrowerApplicationProperties] = useState(undefined as any);
  const [isLoanApplication, setIsLoanApplication] = useState(false as boolean);
  const [isBorrowerLoaded, setIsBorrowerLoaded] = useState(false as boolean);
  const [borrowerInfo, setBorrowerInfo] = useState(undefined as any);
  const [isGuarantorsLoaded, setIsGuarantorsLoaded] = useState(false as boolean);
  const [guarantorsInfo, setGuarantorsInfo] = useState(undefined as any[] | undefined);
  const [isDocumentsLoaded, setIsDocumentsLoaded] = useState(false as boolean);
  const [documentsInfolist, setDocumentsInfolist] = useState(undefined as ILoanDocumentInfo[] | undefined);
  const [stagedDocumentFile, setStagedDocumentFile] = useState(undefined as any);
  const [stagedDocumentPreviewUrl, setStagedDocumentPreviewUrl] = useState(undefined as string | undefined);
  const [stagedDocumentObject, setStagedDocumentObject] = useState({} as any);
  const [documentModalObject, setDocumentModalObject] = useState({} as any);
  const [modalType, setModalType] = useState("" as string);
  const [documentInfo, setDocumentInfo] = useState({} as any);
  const [documentMetadata, setDocumentMetadata] = useState(undefined as any);
  const [documentDownloadUrl, setDocumentDownloadUrl] = useState(undefined as any);
  const [invalidProps, setInvalidProps] = useState([] as string[]);
  const [activeTab, setActiveTab] = useState(BrokerConstants.InteriorCardTabs.Pricing.name.toLocaleUpperCase());
  const [activeAccordions, setActiveAccordions] = useState(Array.from(Object.values(BPApplicationAccordions), x => x.id) as string[]);
  const [guarantorAccordions, setGuarantorAccordions] = useState([] as any[]);
  const documentDownloadRef = useRef<HTMLElement>(null as any);
  const [exportURL, setExportURL] = useState(undefined as any);
  const [originalScenarioURL, setOriginalScenarioURL] = useState(undefined as any);
  const [scenario1URL, setScenario1URL] = useState(undefined as any);
  const [scenario2URL, setScenario2URL] = useState(undefined as any);
  const exportRef = useRef<HTMLElement>(null);
  const unfocusRef = useRef<HTMLElement>(null);
  const newPropertyFocusRef = useRef<HTMLElement>(null);
  const originalScenarioRef = useRef<HTMLElement>(null);
  const scenario1Ref = useRef<HTMLElement>(null);
  const scenario2Ref = useRef<HTMLElement>(null);
  const [isEditMode, setIsEditMode] = useState(false as boolean);
  const [isProjectEditMode, setIsProjectEditMode] = useState(false as boolean);
  const [isPropertyEditMode, setIsPropertyEditMode] = useState(false as boolean);
  const [isBorrowerEditMode, setIsBorrowerEditMode] = useState(false as boolean);
  const [isGuarantorEditMode, setIsGuarantorEditMode] = useState(false as boolean);
  const [pricingEditObject, setPricingEditObject] = useState({} as any);
  const [loanProperties, setLoanProperties] = useState([] as any);
  const [initialloanProperties, setInitialLoanProperties] = useState([] as any);
  const [guarantorsEditArray, setGuarantorsEditArray] = useState([] as any);
  const [isUnitWarningMessage, setIsUnitWarningMessage] = useState(false as boolean);
  const [gmrScenarios, setGmrScenarios] = useState([] as any[]);
  const [gmrMetadata, setGmrMetadata] = useState({} as any);
  const [scenarioModalObj, setScenarioModalObj] = useState({} as any);
  const [isScenarioExportModal, setIsScenarioExportModal] = useState(false as any);
  const [guarantorSearch, setGuarantorSearch] = useState("" as string);
  const [isBrokerGuarantorSelected, setIsBrokerGuarantorSelected] = useState(true as boolean);
  const [isBrokerGuarantorsLoading, setIsBrokerGuarantorsLoading] = useState(true as boolean);
  const [brokerGuarantors, setBrokerGuarantors] = useState([] as any[]);
  const [selectedBrokerGuarantors, setSelectedBrokerGuarantors] = useState([] as any[]);
  const [isBrokerGuarantorInvited, setIsBrokerGuarantorInvited] = useState(false as boolean);
  const [brokerGuarantorInvitedName, setBrokerGuarantorInvitedName] = useState("" as string);
  const [newGuarantor, setNewGuarantor] = useState({ isMailingSameAsPhysical: true, isUSCitizen: true } as any);
  const [newAssetAndLiability, setNewAssetAndLiability] = useState({} as any);
  const [newReoSchedule, setNewReoSchedule] = useState({ isMortgageFree: true } as any);
  const [alType, setAlType] = useState("" as string);
  const [guarantorReviewIndex, setGuarantorReviewIndex] = useState(0 as number);
  const [isPayeezyModal, setIsPayeezyModal] = useState(false as any);
  const [isPayeezyLoaded, setIsPayeezyLoaded] = useState(false as boolean);
  const [payeezyLoanInvoices, setPayeezyLoanInvoices] = useState([] as IPayeezyLoanInvoice[]);
  const [payeezyObject, setPayeezyObject] = useState({} as any);
  const payeezySubmitRef = useRef<HTMLInputElement>(null as any);
  const payeezyFileRef = useRef<HTMLElement>(null);
  const payeezyIframeRef = useRef<HTMLIFrameElement>(null);
  const [payeezyFileUrl, setPayeezyFileUrl] = useState(undefined as any);
  const [isInvoiceModal, setIsInvoiceModal] = useState(false as any);
  const [isGuarantorModalOpen, setIsGuarantorModalOpen] = useState(false as boolean);
  const [loanComments, setLoanComments] = useState([] as ILoanComment[]);
  const [organizationContacts, setOrganizationContacts] = useState([] as IRecipientEntity[]);
  const [commentBreadcrumb, setCommentBreadcrumb] = useState("" as string);
  const [commentObj, setCommentObj] = useState({ id: guid() } as any);
  const [commentRecipientSearch, setCommentRecipientSearch] = useState("" as string);
  const [selectedCommentRecipients, setSelectedCommentRecipients] = useState([] as IRecipientEntity[]);
  const [filteredCommentRecipients, setFilteredCommentRecipients] = useState([] as IRecipientEntity[]);
  const [isRecipientSearchOpen, setIsRecipientSearchOpen] = useState(true as boolean);
  const [isCommentFormChanged, setIsCommentFormChanged] = useState(false as boolean);
  const [isRecipientModalOpen, setIsRecipientModalOpen] = useState(false as boolean);
  const [recipientInvalidProps, setRecipientInvalidProps] = useState([] as string[]);
  const [loanCommentSubmissionType, setLoanCommentSubmissionType] = useState("" as string);
  const [loanInfo, setLoanInfo] = useState(undefined as any);
  const [projectPatchObj, setProjectPatchObj] = useState({} as any);
  const [borrowerPatchObj, setBorrowerPatchObj] = useState({} as any);
  const [propertiesPatchArray, setPropertiesPatchArray] = useState([] as any);
  const [newLoanUnits, setNewLoanUnits] = useState([] as any);
  const [errorPropertyIds, setErrorPropertyIds] = useState({} as Set<string>);
  const [guarantorPatchObj, setGuarantorPatchObj] = useState({} as any);
  const [selectedGuarantorId, setSelectedGuarantorId] = useState("" as string);
  const [authToken, setAuthToken] = useState("" as string);
  const persona = whoAmI(user, proxyUser);
  const isAddPropertyButtonDisplay = FeatureFlags.IS_UNIT_PROPERTY_REDESIGN && loanInfo && [GlobalConstants.LoanProgramIds.FIX_AND_FLIP, GlobalConstants.LoanProgramIds.DEVELOPMENT, GlobalConstants.LoanProgramIds.BRIDGE].indexOf(loanInfo.loanProgramId) === -1;
  const nonCollateralProperties = [...loanProperties.filter(property => !property.collateralProperty)];
  const isAllPropertyAccordionExpanded = (nonCollateralProperties.every(property => activeAccordions.includes(property.id)));
  let minMandatoryBrokerFee = ConfigDefaults.MIN_MANDATORY_BROKER_FEE;
  if (applicationMetadata && applicationMetadata.configs) {
    minMandatoryBrokerFee = applicationMetadata.configs.minMandatoryBrokerFee;
  }

  const totalBrokerFee = (pricingInfo && pricingInfo.brokerFeeRate && pricingInfo.wlbrokerFeeRate) ? operationOfNumberArray("sum", [pricingInfo.brokerFeeRate, pricingInfo.wlbrokerFeeRate, minMandatoryBrokerFee]) : null;
  const isHandleInteriorCardEditPersona = [
    Personas.WL_GUARANTOR, 
    Personas.NWL_GUARANTOR,
    Personas.BROKER,
    Personas.LOAN_OFFICER,
    Personas.BRM
  ].indexOf(persona) > -1;
  
  const isAdminPersona = [
    Personas.SYSTEM_ADMIN,
    Personas.SALES_ADMIN,
    Personas.BROKER_ADMIN
  ].indexOf(persona) > -1;

  const RecipientValidationProps = {
    id: "id",
    borrowerOrganizationId: "borrowerOrganizationId",
    loanId: "loanId",
    commentCategoryId: "commentCategoryId",
    description: "description",
    commentSubjectId: "commentSubjectId",
    subject: "subject",
    isEmailed: "isEmailed",
    isExternal: "isExternal",
    emailToList: "custom-emailToList"
  };

  const payeezyRedirectToken = JSON.stringify({
    EPaymentSuccess: `${window.location.origin}/payeezy/success/${GlobalConstants.Payeezy.SUCCESS_ID}`,
    EPaymentFailed: `${window.location.origin}/payeezy/failed/${GlobalConstants.Payeezy.FAILED_ID}`
  });

  const ScenarioExportNames = {
    original: "original",
    scenario1: "scenario1",
    scenario2: "scenario2",
    scenario3: "scenario3"
  };

  const PayeezyForm = () => {
    return (
      <iframe
        ref={payeezyIframeRef}
        height="100%"
        width="100%"
        src={payeezyObject.payeezyGatewayPaymentUrl}
        name="payeezy-iframe"
        onLoad={() => handleListenToPayeezyRedirect()}
      />
    );
  };

  const InvoiceModalContent = () => {
    return (
      <div>InvoiceModalContent</div>
    );
  };

  const history = useHistory();
  const handleError = useCallback(() => {
    history.push("/error");
  }, [history]);

  const handleEditApplication = useCallback((applicationId) => {
    setGmrEditData({});
    history.push(`/application/borrower/${applicationId}`);
  }, [history, setGmrEditData]);

  const changeApplicationVersion = async (isLoan, activeTab, defaultTab) => {
    setIsLoading(true);
    if (!isLoan) {
      setIsProjectEditMode(false);
      setIsPropertyEditMode(false);
      setIsBorrowerEditMode(false);
      setIsGuarantorEditMode(false);
    }

    setIsLoanApplication(isLoan);
    resetApplication(activeTab, defaultTab);
    setIsLoading(false);
  };

  const resetApplication = async (activeTab, defaultTab) => {
    await handleActiveTabAsync(defaultTab);
    await handleActiveTabAsync(activeTab);
  };

  const resetIframe = (tab) => {
    const frame = document.getElementById(`${tab}-iframe`) as any;
    if (frame) {
      frame.src = "";
    }
  };

  const handleActiveTabAsync = async (newActiveTab) => {
    if (BrokerConstants.InteriorCardTabs.Tasks.name.toLocaleUpperCase() === newActiveTab) {
      resetIframe(BrokerConstants.InteriorCardTabs.Tasks.name);
    }
    else if (BrokerConstants.InteriorCardTabs.Milestones.name.toLocaleUpperCase() === newActiveTab) {
      resetIframe(BrokerConstants.InteriorCardTabs.Milestones.name);
    }

    if (isCommentFormChanged) {
      setIsRecipientModalOpen(true);
    }
    else {
      setIsInteriorCardLoading(true);
      if (newActiveTab === BrokerConstants.InteriorCardTabs.Borrower.name.toLocaleUpperCase() && isBorrowerLoaded === false && loanInfo && loanInfo.borrowerOrganizationId) {
        await getBorrowerEntityAsync(loanInfo.id, loanInfo.borrowerOrganizationId);
        setIsBorrowerLoaded(true);
      }
      else if (newActiveTab === BrokerConstants.InteriorCardTabs.Guarantors.name.toLocaleUpperCase() && isGuarantorsLoaded === false && loanInfo && loanInfo.id) {
        await getBorrowerEntityAsync(loanInfo.id, loanInfo.borrowerOrganizationId);
        await getGuarantorsAsync(loanInfo.id);
        setIsBorrowerLoaded(true);
        setIsGuarantorsLoaded(true);
      }
      else if (newActiveTab === BrokerConstants.InteriorCardTabs.Documents.name.toLocaleUpperCase() && isDocumentsLoaded === false && loanInfo && loanInfo.id) {
        await getApplicationDocuments(loanInfo.id);
        setIsDocumentsLoaded(true);
      }
      else if (newActiveTab === BrokerConstants.InteriorCardTabs.Payments.name.toLocaleUpperCase() && isPayeezyLoaded === false && loanInfo && loanInfo.id) {
        await getBorrowerEntityAsync(loanInfo.id, loanInfo.borrowerOrganizationId);
        await getPayeezyLoanInvoicesAsync(loanInfo.id);
        setIsBorrowerLoaded(true);
        setIsPayeezyLoaded(true);
      }

      if (window.location.pathname.includes("application")) {
        window.history.pushState({}, "", `/application/${newActiveTab.toLocaleLowerCase()}/${applicationId}`);
      }
      else {
        window.history.pushState({}, "", `/processing/${newActiveTab.toLocaleLowerCase()}/${applicationId}`);
      }

      setActiveTab(newActiveTab);
      setIsRecipientModalOpen(false);
      setIsInteriorCardLoading(false);
    }
  };

  const handleFocusNewProperty = () => {
    if (propertiesPatchArray.length) {
      setActiveAccordions([...activeAccordions, propertiesPatchArray[propertiesPatchArray.length - 1].id]);
    }

    let totalOffset = -960;
    loanProperties.forEach(property => {
      totalOffset += 960;
      if (property.loanPropertyUnitReconveyances) {
        totalOffset += ((property.loanPropertyUnitReconveyances.length - 1) * 60);
      }
    });
    
    setTimeout(() => {
      window.scrollTo({
        top: 400 + totalOffset,
        behavior: "smooth"
      });
    }, 60);
  };

  const handleDisplayErrorProperties = () => {
    let errorProperties = <></> as JSX.Element;
    loanProperties.forEach((property, i) => { 
      if (errorPropertyIds instanceof Set && errorPropertyIds.has(property.id)) {
        errorProperties = <>{errorProperties}<a className="interior-card-property-link" onClick={() => {
          setActiveAccordions([...activeAccordions, property.id]);
          setTimeout(() => {
              window.scrollTo({
              top: 200 + (960*(i)) + ((property.loanPropertyUnitReconveyances.length - 1) * 60),
              behavior: "smooth"
            });
          }, 60);
        }}>Property: {property.street}</a></>;
      }
    });

    errorProperties = <>{errorProperties}</>;
    return errorProperties;
  };

  const handlePropertyValidation = () => {
    const missingInformationPropertyIds = new Set() as Set<string>;
    let requiredFields = ["street", "cityName", "stateName", "zip", "existingStructurePropertyTypeId", 
    "newStructurePropertyTypeId", "parcelNumber",];
    if ([GlobalConstants.LoanProgramIds.DEVELOPMENT, GlobalConstants.LoanProgramIds.BRIDGE].indexOf(loanInfo.loanProgramId) === -1) {
      requiredFields = [...requiredFields,  "buildTimeInMonths", "monthOfFirstDraw", "timeFrameToSellOrRefinanceInMonths"];
    }

    let notValidProps = handleNestedValidation(nonCollateralProperties, [...requiredFields], "property", missingInformationPropertyIds);
    loanProperties.forEach(loanProperty => {
      if (!loanProperty.collateralProperty) {
        if (loanProperty.newStructurePropertyTypeId === GlobalConstants.PropertyTypeIds.LAND_UNDEVELOPED || loanProperty.newStructurePropertyTypeId === GlobalConstants.PropertyTypeIds.NO_STRUCTURE_LAND) {
          notValidProps = notValidProps.filter(prop => !prop.includes("parcelNumber"));
          missingInformationPropertyIds.delete(loanProperty.id);
          notValidProps.forEach(prop => {
            if (prop.includes(loanProperty.id)) {
              missingInformationPropertyIds.add(loanProperty.id);
            }
          });
        }

        checkDuplicatedStreet(notValidProps, missingInformationPropertyIds);
        if ([GlobalConstants.LoanProgramIds.BRIDGE, GlobalConstants.LoanProgramIds.DEVELOPMENT].indexOf(loanInfo.loanProgramId) === -1 && 
        loanProperty.newStructurePropertyTypeId !== GlobalConstants.PropertyTypeIds.APARTMENT && loanProperty.loanPropertyUnitReconveyances) {
          const notValidUnitProps = handleNestedValidation(loanProperty.loanPropertyUnitReconveyances, ["estimatedSalesPrice", "unitNumber"], "custom-unit");
          if (notValidUnitProps.length && !missingInformationPropertyIds.has(loanProperty.id)) {
            missingInformationPropertyIds.add(loanProperty.id);
          }
          
          notValidProps = notValidProps.concat(notValidUnitProps);
        }

        checkRedesignedDuplicatedUnitNumber(loanProperty, notValidProps, missingInformationPropertyIds);
      }
    });

    setErrorPropertyIds(missingInformationPropertyIds);
    setActiveAccordions([...activeAccordions].concat(Array.from(missingInformationPropertyIds))); 
    return notValidProps;
  };

  const handleAddNewProperty = (property?) => {
    const propertyId = guid();
    let newProperty = {
      "id": propertyId, 
      "sortOrder": loanProperties.length, 
      "street": "", 
      "isNewProperty": true,
      "collateralProperty": false,
    } as any;
    if (property) {
      const newUnits = [] as any;
      if (property.loanPropertyUnitReconveyances && property.loanPropertyUnitReconveyances.length) {
        property.loanPropertyUnitReconveyances.forEach((unit, i) => {
          newUnits.push({...unit, 
            "id": guid(), 
            "sortOrder": i,
            "loanPropertyId": propertyId
          });
        });
      }

      newProperty = {...property, 
        ...newProperty,
        "loanPropertyUnitReconveyances": newUnits
      };
    }
    else {
      newProperty = { 
        ...newProperty,
        "numberOfUnits" : 1, 
        "existingStructurePropertyTypeId": loanInfo.existingStructurePropertyTypeId,
        "newStructurePropertyTypeId": "",
        "borrowerApplicationId": loanInfo.id,
        "loanPropertyUnitReconveyances": [{ "id": guid(), "unitNumber": "1", "sortOrder": 0, "loanPropertyId": propertyId}]
      };
    }

    setInvalidProps([]);
    loanProperties.push(newProperty);
    nonCollateralProperties.push(newProperty);
    setLoanProperties([...loanProperties]);
    propertiesPatchArray.push(newProperty);
    handleFocusNewProperty();
    
    const notValidPropertiesAndUnits = handlePropertyValidation();
    if (notValidPropertiesAndUnits.length > 0) {
      setTimeout(() => {
        setInvalidProps(notValidPropertiesAndUnits);
      }, 50);
    }
  };

  const handleExpandAllPropertyAccordions = (tab) => {
    const accordionIds = [] as string[];
    if (tab === BrokerConstants.InteriorCardTabs.Properties) {
      const allProperties = isLoanApplication ? loanProperties : borrowerApplicationProperties;
      allProperties.filter(property => property.collateralProperty === false).map(property => {
        accordionIds.push(`${property.id}`);
      });
    }

    setActiveAccordions([...accordionIds]);
  };

  const handleCollapseAllPropertyAccordions = (tab) => {
    let openedAccordions = [...activeAccordions];
    if (tab === BrokerConstants.InteriorCardTabs.Properties) {
      const allProperties = isLoanApplication ? loanProperties : borrowerApplicationProperties;
      const allPropertyIds = new Set(allProperties.map(x => x.id));
      openedAccordions = openedAccordions.filter(id => allPropertyIds.has(id) === false);
    }

    setActiveAccordions([...openedAccordions]);
  };

  const handleActiveAccordions = (accordionId) => {
    const foundAccordionId = activeAccordions.indexOf(accordionId);
    if (accordionId && foundAccordionId > -1) {
      activeAccordions.splice(foundAccordionId, 1);
    }
    else if (accordionId) {
      activeAccordions.push(accordionId);
    }

    setActiveAccordions([...activeAccordions]);
  };

  const handleStageUpload = (files) => {
    if (files && files.length > 0) {
      setStagedDocumentFile(files[0]);
      if (files[0].type === "image/jpeg" || files[0].type === "image/png") {
        setStagedDocumentPreviewUrl(URL.createObjectURL(files[0]));
      }
    }
  };

  const handleResetStageUpload = () => {
    setStagedDocumentFile(undefined);
    setStagedDocumentPreviewUrl(undefined);
    setStagedDocumentObject({});
  };

  const handleStageUploadSubmit = async () => {
    setInvalidProps([]);
    const notValidProps = validateObj(stagedDocumentObject, ["documentMasterId"]);
    if (notValidProps.length === 0) {
      const documentObj = {
        id: guid(),
        borrowerApplicationId: borrowerApplicationInfo.id,
        documentMasterId: stagedDocumentObject.documentMasterId,
        description: stagedDocumentObject.description
      };

      setIsInteriorCardLoading(true);
      await createLoanDocumentAsync(stagedDocumentFile, documentObj);
    }
    else {
      setTimeout(() => {
        setInvalidProps(notValidProps);
      }, 50);
    }
  };

  const handleDocumentModalClose = () => {
    setDocumentModalObject({});
    setIsModalOpen(false);
  };

  const handleRevisionModalClose = () => {
    setRevisionObject({});
    setIsModalOpen(false);
  };

  const handleRevisionModalSend = async () => {
    await requestApplicationRevisionAsync();
  };

  const handleDocumentModalOpenAsync = async (modalType, document, documentType, applicationName) => {
    const downloadedFile = await getLoanDocumentAsync(document.id);
    let downloadedFileUrl = undefined as string | undefined;
    if (downloadedFile) {
      downloadedFileUrl = URL.createObjectURL(downloadedFile);
    }

    setDocumentInfo({
      document: document,
      documentType: documentType,
      downloadedFile: downloadedFile,
      downloadedFileUrl: downloadedFileUrl,
      applicationName: applicationName
    });

    setDocumentModalObject({ id: document.id, documentMasterId: document.documentMasterId, description: document.description });
    setModalType(modalType);
    setIsModalOpen(true);
  };

  const handleUpdateLoanDocument = async (documentModalObject) => {
    setInvalidProps([]);
    const notValidProps = validateObj(documentModalObject, ["documentMasterId"]);
    if (notValidProps.length === 0) {
      const documentObj = {
        id: documentModalObject.id,
        borrowerApplicationId: borrowerApplicationInfo.id,
        documentMasterId: documentModalObject.documentMasterId,
        description: documentModalObject.description
      };

      setIsInteriorCardLoading(true);
      await updateLoanDocumentAsync(documentObj);
    }
    else {
      setTimeout(() => {
        setInvalidProps(notValidProps);
      }, 50);
    }
  };

  const handleApplicationDetailModal = (modalType) => {
    const applicationDetailModal = [] as any;
    if (modalType === "documentInfo" && documentInfo) {
      applicationDetailModal.header = <div>{documentInfo.documentType ? `${documentInfo.documentType} - ` : ""}{documentInfo.applicationName}</div>;
      applicationDetailModal.content = <Form className="primary-form" autoComplete="off">
        <Grid>
          <Grid.Row className="details-row">
            <Grid.Column width={16}>
              <Button
                className={getIsWhiteLabeled() ? `details-button ${brokerButtonOverrideCSS}` : "bp-button details-button"}
                icon
                onClick={() => getLoanDocumentAsync(documentInfo.document.id, true)}
              >
                <div className="gmr-button-container">
                  <Icon name='download' size="large" />
                  <div className="gmr-button-icon-text">Download</div>
                </div>
              </Button>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row className="details-row">
            <Grid.Column width={16}>
              {documentInfo.downloadedFileUrl ? <div className="modal-preview-container">
                <Image
                  className="modal-image-preview"
                  src={documentInfo.downloadedFileUrl}
                />
              </div> : <BCEmptyState
                emptyStateClass="application-details-empty-state"
                icon="file alternate"
                brokerColor={getIsWhiteLabeled() ? brokerColor : void 0}
                className={getIsWhiteLabeled() ? brokerIconColorOverride : ""}
                text="Preview not available"
              />}
            </Grid.Column>
          </Grid.Row>
          <Grid.Row className="details-row">
            <Grid.Column width={16}>
              <BCFormInput
                labelClass="gmr-background-label"
                type="input"
                label="Document Name:"
                value={documentInfo.document.display}
                disabled
              />
            </Grid.Column>
            <Grid.Column width={16}>
              <BCFormInput
                labelClass="gmr-background-label"
                type="dropdown"
                label="Document Type:"
                placeholder="Please Select"
                obj={documentModalObject}
                field="documentMasterId"
                dropdownOptions={getDropdownOptions(documentMetadata.documentMaster, ["id"], "name")}
                handleFormChange={(value, field) => handleFormChange(value, field, documentModalObject, setDocumentModalObject)}
                required
              />
              {applicationValidationMessage("documentMasterId")}
            </Grid.Column>
            <Grid.Column width={16}>
              <BCFormInput
                labelClass="gmr-background-label"
                type="textarea"
                label="Description"
                placeholder="Write your description here..."
                obj={documentModalObject}
                field="description"
                handleFormChange={(value, field) => handleFormChange(value, field, documentModalObject, setDocumentModalObject)}
              />
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Form>;
      applicationDetailModal.actions = <Grid>
        <Grid.Row>
          <Grid.Column width={8}>
            <Button
              fluid
              onClick={() => handleDocumentModalClose()}
            >
              <div className="gmr-button-container">
                <div className="gmr-button-text">Cancel</div>
              </div>
            </Button>
          </Grid.Column>
          <Grid.Column width={8}>
            <Button
              className="bp-button"
              fluid
              onClick={() => handleUpdateLoanDocument(documentModalObject)}
            >
              <div className="gmr-button-container">
                <div className="gmr-button-text">Update</div>
              </div>
            </Button>
          </Grid.Column>
        </Grid.Row>
      </Grid>;
    }
    else if (modalType === "revision") {
      applicationDetailModal.header = <div>What would you like the Broker to Revise</div>;
      applicationDetailModal.content = <Form className="primary-form" autoComplete="off">
        <Grid>
          <Grid.Row className="details-row">
            <Grid.Column width={16}>
              <BCFormInput
                labelClass="gmr-background-label"
                type="textarea"
                placeholder="Write your description here..."
                obj={revisionObject}
                field="description"
                handleFormChange={(value, field) => handleFormChange(value, field, revisionObject, setRevisionObject)}
              />
            </Grid.Column>
            <Grid.Column width={16}>
              Max 255 characters
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Form>;
      applicationDetailModal.actions = <Grid>
        <Grid.Row>
          <Grid.Column width={8}>
            <Button
              fluid
              onClick={() => handleRevisionModalClose()}
            >
              <div className="gmr-button-container">
                <div className="gmr-button-text">Cancel</div>
              </div>
            </Button>
          </Grid.Column>
          <Grid.Column width={8}>
            <Button
              className="bp-button"
              fluid
              onClick={() => handleRevisionModalSend()}
            >
              <div className="gmr-button-container">
                <div className="gmr-button-text">Send Email</div>
              </div>
            </Button>
          </Grid.Column>
        </Grid.Row>
      </Grid>;
    }

    return applicationDetailModal;
  };

  const handleEstimatedMaturityDate = (closingDate, requestedLoanTermInMonths) => {
    if (closingDate && requestedLoanTermInMonths) {
      const formattedClosingDate = new Date(closingDate);
      const estimatedMaturityDate = new Date(formattedClosingDate.setMonth(formattedClosingDate.getMonth() + pricingInfo.requestedLoanTermInMonths)).toLocaleDateString();
      return estimatedMaturityDate;
    }
    else {
      return null;
    }
  };

  const handleEstimatedNetSaleProceeds = (afterRepairValue, realEstateCostsFeePercentage) => {
    if (afterRepairValue && realEstateCostsFeePercentage) {
      return roundNumber(operationOfNumberArray("product", [pricingInfo.afterRepairValue, (1 - pricingInfo.realEstateCostsFeePercentage)]));
    }
    else {
      return null;
    }
  };

  const handleEstimatedTotalCosts = (loanCommitment, interestPaidByBorrower, requiredCashDown, totalCostsPaidToDate, subordinatedDebtAmount) => {
    return roundNumber(operationOfNumberArray("sum", [loanCommitment, interestPaidByBorrower, requiredCashDown, totalCostsPaidToDate, subordinatedDebtAmount]));
  };

  const handleEstimatedBorrowerProfit = (pricingInfo) => {
    return roundNumber(operationOfNumberArray("difference",
      [
        handleEstimatedNetSaleProceeds(pricingInfo.afterRepairValue, pricingInfo.realEstateCostsFeePercentage),
        handleEstimatedTotalCosts(pricingInfo.loanCommitment, pricingInfo.interestPaidByBorrower, pricingInfo.requiredCashDown, pricingInfo.totalCostsPaidToDate, pricingInfo.subordinatedDebtAmount)
      ]));
  };

  const handleUnfocus = () => {
    if (unfocusRef.current) {
      unfocusRef.current.focus();
    }
  };

  const handleEditMode = (setEdit) => {
    handleUnfocus();
    setEdit(true);
  };

  const handleSavePricingChanges = () => {
    handleUnfocus();
    setIsEditMode(false);
  };

  const handleSaveLoanProjectChanges = async () => {
    setInvalidProps([]);
    const notValidProperties = [] as any;
    for (const [key, value] of Object.entries(GlobalConstants.projectInfoValidationTypes)) {
      addNotValidProps(notValidProperties, projectPatchObj, key, "project", value);
    }

    if (projectPatchObj.totalCostsPaidToDate) {
      for (const costsPaid of projectPatchObj.totalCostsPaidToDate) {
        if (costsPaid.loanId && !costsPaid.gmrprojectCostId && !costsPaid.description && !costsPaid.amount) {
          projectPatchObj.totalCostsPaidToDate = projectPatchObj.totalCostsPaidToDate.filter(x => x.id !== costsPaid.id);
          setProjectPatchObj({...projectPatchObj});
          break;
        }

        for (const [key, value] of Object.entries(GlobalConstants.projectCostsPaidValidationTypes)) {
          addNotValidProps(notValidProperties, costsPaid, key, `costsPaid-${costsPaid.id}`, value);
        }
      }
    }

    if (!FeatureFlags.IS_UNIT_PROPERTY_REDESIGN && projectPatchObj.termSchedule) {
      for (const property of projectPatchObj.termSchedule) {
        for (const [key, value] of Object.entries(GlobalConstants.projectTermScheduleValidationTypes)) {
          addNotValidProps(notValidProperties, property, key, `termSchedule-${property.id}`, value);
        }
      }
    }

    if (FeatureFlags.IS_UNIT_PROPERTY_REDESIGN && propertiesPatchArray && propertiesPatchArray.length) {
      propertiesPatchArray.forEach(property => {
        for (const field in property) {
          if (property[field] === "") {
            notValidProperties.push(`custom-properties-${field}-${property.id}`);
          }
        }
      });
    }
    
    if (notValidProperties.length === 0) {
      setIsLoading(true);
      await handleSaveLoanProjectChangesAsync();
      if (FeatureFlags.IS_UNIT_PROPERTY_REDESIGN && propertiesPatchArray && propertiesPatchArray.length) {
        await handleSaveLoanPropertiesChangesAsync(propertiesPatchArray, false);
      }

      setIsBorrowerEditMode(false);
    }
    else {
      setTimeout(() => { 
        setInvalidProps(notValidProperties);
      }, 50);
    }

    setIsLoading(false);
  };

  const handleSaveLoanProjectChangesAsync = async () => {
    try {
      setIsLoading(true);
      const response = FeatureFlags.IS_MOCK ? await saveMockLoanDetails(projectPatchObj) : await patchLoanProjectSection(loanInfo.id, projectPatchObj);
      if (response && response.ok) {
        setIsMessage(false);
        setProjectPatchObj({});
        await getBorrowerApplicationInfoAsync(borrowerApplicationInfo.id);
        await getLoanInfoAsync(loanInfo.id);
        handleUnfocus();
        setIsProjectEditMode(false);
      }
      else {
        await handleErrorResponse(response, setIsMessage, setErrorResponse);
        setIsMessage(true);
      }
    }
    catch (error) {
      setIsMessage(false);
    }

    setIsLoading(false);
  };

  const checkLoanPropertiesDuplicatedUnitNumber = (oldPropertyArray, newProperty, notValidProperties) => {
    const selectedProperty = oldPropertyArray.find(p => p.id === newProperty.id);
    if (selectedProperty && selectedProperty.loanPropertyUnitReconveyances) {
      newProperty.loanPropertyUnitReconveyances.forEach(editUnit => {
        selectedProperty.loanPropertyUnitReconveyances.forEach(oldUnit => {
          if (editUnit.unitNumber && oldUnit.unitNumber && editUnit.unitNumber === oldUnit.unitNumber && editUnit.id !== oldUnit.id) {
            notValidProperties.push(`custom-unit-duplicated-${editUnit.id}`);
          }
        });
      });
    }

    newProperty.loanPropertyUnitReconveyances.forEach(baseUnit => {
      newProperty.loanPropertyUnitReconveyances.forEach(revolvingUnit => {
        if (baseUnit.unitNumber && revolvingUnit.unitNumber && baseUnit.unitNumber === revolvingUnit.unitNumber && revolvingUnit.id !== baseUnit.id) {
          notValidProperties.push(`custom-unit-duplicated-${revolvingUnit.id}`);
        }
      });
    });
  };

  const checkRedesignedDuplicatedUnitNumber = (property, notValidProperties, errorPropertyIds) => {
    const propertyUnits = [...property.loanPropertyUnitReconveyances];
    if (property && propertyUnits && propertyUnits.length) {
      propertyUnits.forEach(unit => {
        const otherUnitNumbers = new Set(propertyUnits.filter(x => x.id !== unit.id).map(x => x.unitNumber));
        if (otherUnitNumbers.has(unit.unitNumber)) {
          notValidProperties.push(`custom-unit-duplicated-${unit.id}`);
          if (errorPropertyIds && !errorPropertyIds.has(property.id)) {
            errorPropertyIds.add(property.id);
          }
        }
      });
    }
  };

  const checkDuplicatedStreet = (notValidProperties, errorPropertyIds) => {
    nonCollateralProperties.map(thisProperty => {
      const otherStreetName = new Set(nonCollateralProperties.filter(otherProperty => otherProperty.id !== thisProperty.id).map(otherProperty => `${otherProperty.street.toLowerCase()}${otherProperty.cityName}`));
      if (thisProperty.street && thisProperty.cityName && otherStreetName.has(`${thisProperty.street.toLowerCase()}${thisProperty.cityName}`)) {
        notValidProperties.push(`custom-duplicated-property-${thisProperty.id}`);
        if (errorPropertyIds && !errorPropertyIds.has(thisProperty.id)) {
          errorPropertyIds.add(thisProperty.id);
        }
      }
    });
  };

  const handleSaveLoanPropertiesChanges = async () => {
    setInvalidProps([]);
    let notValidProperties = [] as any;
    const propertiesInfoValidationTypes = FeatureFlags.IS_UNIT_PROPERTY_REDESIGN ? GlobalConstants.propertiesInfoRedesignValidationTypes : GlobalConstants.propertiesInfoValidationTypes;
    const propertyUnitsValidationTypes = FeatureFlags.IS_UNIT_PROPERTY_REDESIGN ? GlobalConstants.propertyUnitsRedesignValidationTypes : GlobalConstants.propertyUnitsValidationTypes;
    const newProperties = [] as any;
    const oldProperties = [] as any;
    for(const property of propertiesPatchArray) {
      for(const [fieldName, inputType] of Object.entries(propertiesInfoValidationTypes)) {
        addNotValidProps(notValidProperties, property, fieldName, `property-${property.id}`, inputType);
      }

      if (property.loanPropertyUnitReconveyances) {
        for(const unit of property.loanPropertyUnitReconveyances) {
          for(const [fieldName, inputType] of Object.entries(propertyUnitsValidationTypes)) {
            addNotValidProps(notValidProperties, unit, fieldName, `property-unit-${unit.id}`, inputType, FeatureFlags.IS_UNIT_PROPERTY_REDESIGN);
          }
        }

        checkLoanPropertiesDuplicatedUnitNumber(nonCollateralProperties, property, notValidProperties);
      }

      if (property.isNewProperty) {
        newProperties.push(property);
      }
      else {
        oldProperties.push(property);
      }
    }

    if (FeatureFlags.IS_UNIT_PROPERTY_REDESIGN) {
      const notValidRequiredPropertiesAndUnits = handlePropertyValidation();
      notValidProperties = notValidProperties.concat(notValidRequiredPropertiesAndUnits);
    }
    
    if (notValidProperties.length === 0) {
      setIsLoading(true);
      if (newProperties.length) {
        await handleSaveLoanPropertiesChangesAsync(newProperties, true);
      }

      if (oldProperties.length) {
        await handleSaveLoanPropertiesChangesAsync(oldProperties, false);
      }

      if (newLoanUnits.length) {
        await handleAddNewLoanUnitsAsync(newLoanUnits);
      }

      setIsPropertyEditMode(false);
    }
    else {
      setTimeout(() => { 
        setInvalidProps(notValidProperties);
      }, 50);
    }

    setIsLoading(false);
  };

  const handleSaveLoanPropertiesChangesAsync = async (properties, isInsert) => {
    try {
      setIsLoading(true);
      const response = FeatureFlags.IS_MOCK ? await saveMockProperties(properties[0]) : await patchLoanProperties(properties, proxyUser.id, isInsert);
      if (response && response.ok) {
        setIsMessage(false);
        await getBorrowerApplicationInfoAsync(borrowerApplicationInfo.id);
        await getLoanInfoAsync(loanInfo.id);
        setPropertiesPatchArray([]);
        handleUnfocus();
        setIsPropertyEditMode(false);
      }
      else {
        await handleErrorResponse(response, setIsMessage, setErrorResponse);
        setIsMessage(true);
      }
    }
    catch (error) {
      setIsMessage(false);
    }

    setIsLoading(false);
  };

  const handleAddNewLoanUnitsAsync = async (units) => {
    try {
      setIsLoading(true);
      const response = FeatureFlags.IS_MOCK ? await addMockLoanUnits(units) : await addLoanUnits(units, proxyUser.id);
      if (response && response.ok) {
        setIsMessage(false);
        await getBorrowerApplicationInfoAsync(borrowerApplicationInfo.id);
        await getLoanInfoAsync(loanInfo.id);
        setNewLoanUnits([]);
        handleUnfocus();
        setIsPropertyEditMode(false);
      }
      else {
        await handleErrorResponse(response, setIsMessage, setErrorResponse);
        setIsMessage(true);
      }
    }
    catch (error) {
      setIsMessage(false);
    }

    setIsLoading(false);
  };

  const handleDeletePropertyAsync = async (propertyId) => {
    try {
      setIsLoading(true);
      const response = FeatureFlags.IS_MOCK ? await deleteMockLoanProperty(propertyId) : await deleteLoanProperty(propertyId, proxyUser.id);
      if (response && response.ok) {
        setIsMessage(false);
        await getBorrowerApplicationInfoAsync(borrowerApplicationInfo.id);
        await getLoanInfoAsync(loanInfo.id);
        resetApplication("PROPERTIES", "PROJECT");
      }
      else {
        await handleErrorResponse(response, setIsMessage, setErrorResponse);
      }
    }
    catch (error) {
      setIsMessage(false);
    }

    setIsLoading(false);
  };

  const handleUnitDeleteAsync = async (unitId) => {
    try {
      setIsLoading(true);
      const response = FeatureFlags.IS_MOCK ? await deleteMockLoanUnit(loanProperties) : await deleteLoanUnit(unitId, proxyUser.id);
      if (response && response.ok) {
        setIsMessage(false);
        await getBorrowerApplicationInfoAsync(borrowerApplicationInfo.id);
        await getLoanInfoAsync(loanInfo.id);
        resetApplication("PROPERTIES", "PROJECT");
      }
      else {
        await handleErrorResponse(response, setIsMessage, setErrorResponse);
      }
    }
    catch (error) {
      setIsMessage(false);
    }

    setIsLoading(false);
  };

  const filterReoSchedules = (patchObj: any, originalReoSchedules: any[]) => {
    if ("reoSchedule" in patchObj) {
      const { reoSchedule, ...parsedPatchObj } = patchObj;
      return [
        ...reoSchedule.reduce(
          ([updatedReoSchedules, newReoSchedules], currentReoSchedule) => {
            if (currentReoSchedule.isNew) {
              const { isNew: _, ...parsedNewReoSchedule } = currentReoSchedule;
              newReoSchedules.push(parsedNewReoSchedule);
            } else {
              if (currentReoSchedule.additionalCollateral) {
                const currentOriginalReoSchedule = originalReoSchedules.find(
                  (originalReo) => originalReo.id === currentReoSchedule.id
                );
                [
                  "cityName",
                  "stateName",
                  "marketValue",
                  "street",
                  "countyName",
                  "zipCode",
                  "reotypeId"
                ].forEach((field) => {
                  if (!(field in currentReoSchedule)) {
                    currentReoSchedule[field] = currentOriginalReoSchedule[field];
                  }
                });
                currentReoSchedule.loanId = loanInfo.id;
              }
              updatedReoSchedules.push(currentReoSchedule);
            }
            return [
              [...updatedReoSchedules],
              [...newReoSchedules],
            ];
          },
          [[], []]
        ),
        parsedPatchObj,
      ];
    }
    
    return [[], [], patchObj];
  };

  const handleSaveUpdatedReoSchedules = async (updatedReoSchedules: any[]): Promise<void> => {
    {FeatureFlags.IS_MOCK && console.log({updatedReoSchedules});}
    try {
      const response = FeatureFlags.IS_MOCK ? await upsertMockBorrowerEntity(updatedReoSchedules) : await patchLoanReoSchedules(updatedReoSchedules, proxyUser.id);
      if (response && response.ok) {
        setIsMessage(false);
      }
      else {
        await handleErrorResponse(response, setIsMessage, setErrorResponse);
        setIsMessage(true);
      }
    }
    catch (error) {
      setIsMessage(false);
    }
  };

  const handleSaveNewReoSchedules = async (newReoSchedules: any[]): Promise<void> => {
    {FeatureFlags.IS_MOCK && console.log({updatedReoSchedules: newReoSchedules});}
    try {
      const response = FeatureFlags.IS_MOCK ? await upsertMockBorrowerEntity(newReoSchedules) : await postLoanReoSchedules(applicationId, newReoSchedules, proxyUser.id);
      if (response && response.ok) {
        setIsMessage(false);
      }
      else {
        await handleErrorResponse(response, setIsMessage, setErrorResponse);
        setIsMessage(true);
      }
    }
    catch (error) {
      setIsMessage(false);
    }
  };

  const handleSaveReoSchedules = async (updatedReoSchedules: any[], newReoSchedules: any[]): Promise<void> => {
    if (updatedReoSchedules.length > 0) {
      await handleSaveUpdatedReoSchedules(updatedReoSchedules);
    }
    if (newReoSchedules.length > 0) {
      await handleSaveNewReoSchedules(newReoSchedules);
    }
  };

  const handleSaveGuarantorChanges = async () => {
    setInvalidProps([]);
    let notValidProperties = [] as any;
    handleALValidation(guarantorPatchObj, setGuarantorPatchObj, notValidProperties);
    handleREOValidation(guarantorPatchObj, setGuarantorPatchObj, notValidProperties);
    const guarantorId = selectedGuarantorId || guarantorsEditArray[0].id;
    if (guarantorPatchObj.contactInformation) {
      for (const [key, value] of Object.entries(GlobalConstants.guarantorInfoValidationTypes)) {
        addNotValidProps(notValidProperties, guarantorPatchObj.contactInformation, key, `guarantor-${guarantorId}`, value);
      }
      
      if (guarantorPatchObj.contactInformation.zip === undefined && !Object.keys(guarantorPatchObj.contactInformation).includes("physicalZip")) {
        addNotValidProps(notValidProperties, guarantorPatchObj.contactInformation, "physicalZip", `guarantor-${guarantorId}`, "string");
      }
      else if (guarantorPatchObj.contactInformation.zip === undefined && Object.keys(guarantorPatchObj.contactInformation).includes("physicalZip")) {
        notValidProperties = notValidProperties.filter(x => x !== `guarantor-${guarantorId}-zip`);
      }
    }

    if (guarantorPatchObj.additionalInformation) {
      for (const [key, value] of Object.entries(GlobalConstants.guarantorCreditScoreValidationTypes)) {
        addNotValidProps(notValidProperties, guarantorPatchObj.additionalInformation, key, `guarantor-${guarantorId}-creditScore`, value);
      }
    }
    const guarantor = guarantorsEditArray.find(guarantor => guarantor.id === guarantorId);
    if (notValidProperties.length === 0) {
      const [
        updatedReoSchedules,
        newReoSchedules,
        parsedPatchObj
      ] = filterReoSchedules(guarantorPatchObj, guarantor.reoschedules);
      setIsLoading(true);
      await Promise.all([
        handleSaveLoanGuarantorChangesAsync(guarantorId, parsedPatchObj),
        handleSaveReoSchedules(updatedReoSchedules, newReoSchedules),
      ]);
      await Promise.all([
        getBorrowerEntityAsync(loanInfo.id, loanInfo.borrowerOrganizationId),
        getLoanInfoAsync(loanInfo.id),
        getGuarantorsAsync(loanInfo.id),
      ]);
      setIsGuarantorEditMode(false);
      handleUnfocus();
      setGuarantorPatchObj({});
    }
    else {
      setTimeout(() => { 
        setInvalidProps(notValidProperties);
      }, 50);
    }
  };

  const handleSaveLoanGuarantorChangesAsync = async (organizationContactId: string, patchObj: any) => {
    {FeatureFlags.IS_MOCK && console.log({guarantorPatchObj: patchObj});}
    try {
      setIsLoading(true);
      const response = FeatureFlags.IS_MOCK ? await upsertMockGuarantor() : await patchLoanGuarantorSection(organizationContactId, patchObj, proxyUser.id);
      if (response && response.ok) {
        setIsMessage(false);
      }
      else {
        await handleErrorResponse(response, setIsMessage, setErrorResponse);
        setIsMessage(true);
      }
    }
    catch (error) {
      setIsMessage(false);
    }

    setIsLoading(false);
  };

  const handleALValidation = (obj, setObj, notValidProperties) => {
    if (obj.alSchedule) {
      for (const al of obj.alSchedule) {
        if (al.alclassName === GlobalConstants.Altype.ASSET || al.alclassId === GlobalConstants.AlClassId.ASSET) {
          if (al.borrowerOrganizationId && !al.altypeId && !al.institution && al.value === 0) {
            obj.alSchedule = obj.alSchedule.filter(asset => asset.id !== al.id);
            setObj({...obj});
            break;
          }
        }

        if (al.alclassName === GlobalConstants.Altype.LIABILITY || al.alclassId === GlobalConstants.AlClassId.LIABILITY) {
          if (al.borrowerOrganizationId && !al.altypeId && !al.institution && al.value === 0 && !al.monthlyLiability) {
            obj.alSchedule = obj.alSchedule.filter(liability => liability.id !== al.id);
            setObj({...obj});
            break;
          }
        }

        for (const [key, value] of Object.entries(GlobalConstants.ALValidationTypes)) {
          addNotValidProps(notValidProperties, al, key, `al-${al.id}`, value);
        }
      }
    }
  };

  const handleREOValidation = (obj, setObj, notValidProperties) => {
    if (obj.reoSchedule) {
      for(const reo of obj.reoSchedule) {
        if (reo.borrowerOrganizationId && !reo.reotypeId && !reo.reostatusId && reo.marketValue === 0 && !reo.street) {
          obj.reoSchedule = obj.reoSchedule.filter(x => x.id !== reo.id);
          setObj({...obj});
          break;
        }

        for (const [key, value] of Object.entries(GlobalConstants.ReoValidationTypes)) {
          addNotValidProps(notValidProperties, reo, key, `reo-${reo.id}`, value);
        }

        if (reo.street && !reo.cityName) {
          notValidProperties.push(`reo-${reo.id}-cityName`);
        } 
        else if (reo.street && reo.cityName && !reo.stateName) {
          notValidProperties.push(`reo-${reo.id}-stateName`);
        }
      } 
    }
  };

  const handleSaveBorrowerChanges = async () => {
    setInvalidProps([]);
    let notValidProperties = [] as any;
    for (const [key, value] of Object.entries(GlobalConstants.borrowerInfoValidationTypes)) {
      addNotValidProps(notValidProperties, borrowerPatchObj, key, "borrower", value);
    }

    if (Object.keys(borrowerPatchObj).includes("employerIdentificationNumber") && borrowerPatchObj.employerIdentificationNumber.length !== 9) {
      notValidProperties.push("borrower-invalidLength-employerIdentificationNumber");
    }

    if (borrowerPatchObj.zip === undefined && !Object.keys(borrowerPatchObj).includes("physicalZipCode")) {
      addNotValidProps(notValidProperties, borrowerPatchObj, "physicalZipCode", "borrower", "string");
    }
    else if (borrowerPatchObj.zip === undefined && Object.keys(borrowerPatchObj).includes("physicalZipCode")) {
      notValidProperties = notValidProperties.filter(x => x !== "borrower-zip");
    }

    handleALValidation(borrowerPatchObj, setBorrowerPatchObj, notValidProperties);
    handleREOValidation(borrowerPatchObj, setBorrowerPatchObj, notValidProperties);
    if (!borrowerPatchObj.id){
      borrowerPatchObj.id = borrowerInfo.id;
    }

    if (notValidProperties.length === 0) {
      const [
        updatedReoSchedules,
        newReoSchedules,
        parsedPatchObj
      ] = filterReoSchedules(borrowerPatchObj, borrowerInfo.reoschedules);
      setIsLoading(true);
      await Promise.all([
        handleSaveLoanBorrowerChangesAsync(parsedPatchObj),
        handleSaveReoSchedules(updatedReoSchedules, newReoSchedules),
      ]);
      await getBorrowerEntityAsync(loanInfo.id, loanInfo.borrowerOrganizationId);
      setIsBorrowerEditMode(false);
      handleUnfocus();
      setBorrowerPatchObj({});
    }
    else {
      setTimeout(() => { 
        setInvalidProps(notValidProperties);
      }, 50);
    }

    setIsLoading(false);
  };

  const handleSaveLoanBorrowerChangesAsync = async (patchObj: any): Promise<void> => {
    {FeatureFlags.IS_MOCK && console.log({borrowerPatchObj: patchObj});}
    try {
      const response = FeatureFlags.IS_MOCK ? await upsertMockBorrowerEntity(patchObj) : await patchLoanBorrowerSection(patchObj, proxyUser.id);
      if (response && response.ok) {
        setIsMessage(false);
      }
      else {
        await handleErrorResponse(response, setIsMessage, setErrorResponse);
        setIsMessage(true);
      }
    }
    catch (error) {
      setIsMessage(false);
    }
  };

  const handleDiscardChanges = (editObject, setEditObject, setEditMode) => {
    handleUnfocus();
    setInvalidProps([]);
    setEditObject(editObject);
    setEditMode(false);
  };

  const handleDiscardLoanProjectChanges = () => {
    handleDiscardChanges({}, setProjectPatchObj, setIsProjectEditMode);
  };

  const handleDiscardLoanPropertiesChanges = () => {
    setErrorPropertyIds({} as Set<string>);
    handleDiscardChanges([], setPropertiesPatchArray, setIsPropertyEditMode);
    handleDiscardChanges(deepCopy([...initialloanProperties]), setLoanProperties, setIsPropertyEditMode);
  };

  const handleDiscardBorrower = () => {
    handleDiscardChanges({}, setBorrowerPatchObj, setIsBorrowerEditMode);
  };

  const handleDiscardGuarantor = () => {
    handleDiscardChanges({}, setGuarantorPatchObj, setIsGuarantorEditMode);
  };

  const handleInfoTitle = (pricingInfo, loanInfo) => {
    if (loanInfo) {
      return `${borrowerInfo.name ? `${borrowerInfo.name} - ` : ""}${loanInfo.name ? loanInfo.name : ""}${(loanInfo.cityName && loanInfo.stateName) ? ` - ${loanInfo.cityName}, ${loanInfo.stateName}` : ""}`;
    }
    else {
      return `${pricingInfo.name ? pricingInfo.name : ""} - ${pricingInfo.projectZipCode ? pricingInfo.projectZipCode : ""}`;
    }
  };

  const handleInfoSubtitle = (pricingInfo, loanInfo) => {
    if (isGmrInteriorCardView) {
      return `${pricingInfo && pricingInfo.gmrNumber ? `GMR Number: ${pricingInfo.gmrNumber} ` : ""} Status: ${pricingInfo.statusLookupName ? pricingInfo.statusLookupName : ""}`;
    }
    else if (loanInfo && borrowerApplicationInfo) {
      return <span>{`${pricingInfo && pricingInfo.gmrNumber ? `GMR Number: ${pricingInfo.gmrNumber} ` : ""}Application Number: ${borrowerApplicationInfo.applicationNumber ? borrowerApplicationInfo.applicationNumber : ""}`}
      {loanInfo.statusLookupName ? <span> Status: <b>{loanInfo.statusLookupName}</b></span> : ""}</span>;
    }
    else {
      return "";
    }
  };

  const handleFormatContactPhone = (phone) => {
    return `(${phone.substring(0, 3)}) ${phone.substring(3, 6)}-${phone.substring(6, 10)}`;
  };

  const applicationValidationMessage = (prop) => {
    return (
      <Transition
        animation={invalidProps.length === 0 ? "scale" : "shake"}
        duration={{ hide: 10, show: 500 }}
        visible={invalidProps.includes(prop)}
      >
        {invalidProps.includes(prop) ? <Message className="gmr-message" negative color="red">This field is required.</Message> : <div />}
      </Transition>
    );
  };

  const handleDeleteCostsPaidsAsync = async (costPaidId) => {
    try {
      setIsLoading(true);
      const response = FeatureFlags.IS_MOCK ? await deleteMockLoanCostsPaids(costPaidId) : await deleteLoanCostsPaids(costPaidId, proxyUser.id);
      if (response && response.ok) {
        setIsMessage(false);
      }
      else {
        await handleErrorResponse(response, setIsMessage, setErrorResponse);
      }
    }
    catch (error) {
      setIsMessage(false);
    }

    setIsLoading(false);
  };

  const handleALDeleteAsync = async (id) => {
    try {
      setIsLoading(true);
      const response = FeatureFlags.IS_MOCK ? await saveMockProperties(loanProperties) : await deleteLoanALSchedules(id, proxyUser.id);
      if (response && response.ok) {
        setIsMessage(false);
        setInvalidProps([]);
      }
      else {
        await handleErrorResponse(response, setIsMessage, setErrorResponse);
      }
    }
    catch (error) {
      setIsMessage(false);
    }

    setIsLoading(false);
  };

  const handleREODeleteAsync = async (reoId) => {
    try {
      setIsLoading(true);
      const response = FeatureFlags.IS_MOCK ? await saveMockProperties(loanProperties) : await deleteLoanREO(reoId, proxyUser.id);
      if (response && response.ok) {
        setIsMessage(false);
        setInvalidProps([]);
      }
      else {
        await handleErrorResponse(response, setIsMessage, setErrorResponse);
      }
    }
    catch (error) {
      setIsMessage(false);
    }

    setIsLoading(false);
  };

  const formatApplicationDocumentInfoList = (documentsInfolist) => {
    const formattedDocuments = [] as IApplicationDocumentInfoView[];
    documentsInfolist.forEach(documentsInfo => {
      formattedDocuments.push({
        id: documentsInfo.id,
        "Document": documentsInfo.display,
        "Uploaded By": documentsInfo.createdBy,
        "Uploaded On": convertToDateString(documentsInfo.createdOn)
      });
    });

    return formattedDocuments;
  };

  const formatOldProjectInfo = () => {
    const oldProjectInfo = deepCopy({...borrowerApplicationInfo});
    oldProjectInfo["loanCostPaids"] = [...borrowerApplicationInfo.borrowerApplicationCostPaids];
    oldProjectInfo["loanProperties"] = [...borrowerApplicationInfo.borrowerApplicationProperties];
    oldProjectInfo.builder = {
      builderOrganizationId: borrowerApplicationBuilderInfo.id,
      cityName: borrowerApplicationBuilderInfo.physicalCityName,
      entitySubTypeId: borrowerApplicationBuilderInfo.entitySubTypeId,
      name: borrowerApplicationBuilderInfo.name,
      stateName: borrowerApplicationBuilderInfo.physicalStateName,
      street: borrowerApplicationBuilderInfo.physicalStreet,
      zip: borrowerApplicationBuilderInfo.physicalZipCode,
    };

    if (oldProjectInfo.loanProperties && oldProjectInfo.loanProperties.length >= 1) {
      oldProjectInfo.loanProperties.map((property) => {
        property["loanPropertyUnitReconveyances"] = property.borrowerApplicationPropertyUnits;
      });
    }
    
    return oldProjectInfo;
  };

  const isShowGuarantorSection = (guarantor) => {
    if (loanInfo && isApplicationGuarantor(permissions, "GuarantorWhiteLabeledApplication", "read", loanInfo.guarantors, user.organizationContactId) && guarantor.email !== user.email) {
      return false;
    }

    return true;
  };

  const handleSubmitOptionsChange = async (index) => {
    if (BPRevisionSubmitOptions[index].value === "Request Revision" && loanInfo) {
      setModalType("revision");
      setIsModalOpen(true);
      setRevisionObject({
        id: applicationId,
        name: loanInfo.name
      });
    }
    else {
      await sendApplicationToPrescreenerAsync();
    }
  };

  const handleScenarioModalClose = () => {
    setIsScenarioExportModal(false);
    setScenarioModalObj({});
  };

  const handleScenarioModalExportIndividually = async () => {
    setIsLoading(true);
    handleScenarioModalClose();
    const isSuccess = true;
    if (scenarioModalObj.isScenarioOriginal && isSuccess) {
      await handleExportIndividualAsync(pricingInfo.id, ScenarioExportNames.original);
    }

    if (scenarioModalObj.isScenario1 && gmrScenarios[0] && isSuccess) {
      await handleExportIndividualAsync(gmrScenarios[0].id, ScenarioExportNames.scenario1);
    }

    if (scenarioModalObj.isScenario2 && gmrScenarios[1] && isSuccess) {
      await handleExportIndividualAsync(gmrScenarios[1].id, ScenarioExportNames.scenario2);
    }

    setIsLoading(false);
  };

  const handleScenarioModalExportComparison = async () => {
    setIsLoading(true);
    handleScenarioModalClose();
    const scenariosToExport = [] as any[];
    const isSuccess = true;
    if (scenarioModalObj.isScenarioOriginal) {
      scenariosToExport.push(pricingInfo);
    }

    if (scenarioModalObj.isScenario1 && gmrScenarios[0]) {
      scenariosToExport.push(gmrScenarios[0]);
    }

    if (scenarioModalObj.isScenario2 && gmrScenarios[1]) {
      scenariosToExport.push(gmrScenarios[1]);
    }

    if (isSuccess) {
      await handleExportComparisonAsync(scenariosToExport);
    }

    setIsLoading(false);
  };

  const handleExportComparisonDisabled = () => {
    let scnearioCount = 0;
    if (scenarioModalObj.isScenarioOriginal) {
      scnearioCount++;
    }

    if (scenarioModalObj.isScenario1 && gmrScenarios[0]) {
      scnearioCount++;
    }

    if (scenarioModalObj.isScenario2 && gmrScenarios[1]) {
      scnearioCount++;
    }

    if (scenarioModalObj.isScenario3 && gmrScenarios[2]) {
      scnearioCount++;
    }

    return scnearioCount > 1 ? false : true;
  };

  const handleScenarioModalChange = (value, field, obj, setObj, type = "string", handleCustomFormChange = undefined as any, charLimit = undefined as number | undefined) => {
    handleFormChange(value, field, obj, setObj, type, handleCustomFormChange, charLimit);
  };

  const handleExportOnClick = async () => {
    if (gmrScenarios && gmrScenarios.length > 0) {
      setIsScenarioExportModal(true);
    }
    else {
      await handleExportIndividualAsync(pricingInfo.id, ScenarioExportNames.original);
    }
  };

  const formatScenarios = (scenarios) => {
    const newScenarios = [] as any[];
    if (scenarios) {
      scenarios.forEach(scenario => {
        newScenarios.push({
          id: scenario.id,
          name: scenario.name
        });
      });
    }

    return newScenarios;
  };

  const handleOpenPayeezyModal = async (invoiceId) => {
    const isPayeezyPageSuccess = await getPayeezyPaymentPageAsync(invoiceId);
    if (isPayeezyPageSuccess) {
      setIsPayeezyModal(true);
      if (payeezySubmitRef.current) {
        payeezySubmitRef.current.click();
      }
    }
  };

  const formatPayeezyLoanInvoices = (loanInvoices) => {
    const formattedLoanInvoices = [] as any[];
    if (borrowerApplicationInfo && borrowerApplicationInfo.applicationNumber && borrowerInfo && borrowerInfo.name) {
      loanInvoices.forEach(loanInvoice => {
        const formattedLoanInvoice = {} as any;
        formattedLoanInvoice["Invoice"] = `${borrowerApplicationInfo.applicationNumber}-I${formatLeadingNumber(loanInvoice.name, 5)} ${borrowerInfo.name.substring(0, 20)}`;
        formattedLoanInvoice["Description"] = loanInvoice.description;
        formattedLoanInvoice["Amount"] = loanInvoice.totalAmount;
        formattedLoanInvoice["Status"] = loanInvoice.transactionStatus;
        formattedLoanInvoice["Paid By"] = loanInvoice.paidBy;
        formattedLoanInvoice["Paid Date"] = (loanInvoice.paidBy && loanInvoice.paidOn) ? convertToDateString(new Date(loanInvoice.paidOn)) : <Button
          className="table-button"
          icon
          color="green"
          inverted
          onClick={() => handleOpenPayeezyModal(loanInvoice.id)}
        >
          <div className="gmr-button-container">
            Pay Now
          </div>
        </Button>;

        formattedLoanInvoices.push(formattedLoanInvoice);
      });
    }

    return formattedLoanInvoices;
  };

  const handleListenToPayeezyRedirect = async () => {
    const payeezyIframeCurrent = payeezyIframeRef.current;
    try {
      if (payeezyIframeCurrent?.contentDocument || payeezyIframeCurrent?.contentWindow?.document) {
        setIsPayeezyModal(false);
        setIsInteriorCardLoading(true);
        await getPayeezyLoanInvoicesAsync(loanInfo.id);
        setIsInteriorCardLoading(false);
      }
    } catch (err) {
      return;
    }
  };

  const handleExportIndividualAsync = async (scenarioId, scenarioToExport) => {
    try {
      const response = FeatureFlags.IS_MOCK ? await exportMockGMRQuote(scenarioId) : await exportGMRQuote(scenarioId, proxyUser.id);
      if (response && response.ok) {
        const data = await response.blob();
        const exportQuote = await createFile(data, "gmr-quote", data.type);
        if (scenarioToExport === ScenarioExportNames.original) {
          setOriginalScenarioURL(URL.createObjectURL(exportQuote));
          if (originalScenarioRef.current) {
            originalScenarioRef.current.click();
          }
        }
        else if (scenarioToExport === ScenarioExportNames.scenario1) {
          setScenario1URL(URL.createObjectURL(exportQuote));
          if (scenario1Ref.current) {
            scenario1Ref.current.click();
          }
        }
        else if (scenarioToExport === ScenarioExportNames.scenario2) {
          setScenario2URL(URL.createObjectURL(exportQuote));
          if (scenario2Ref.current) {
            scenario2Ref.current.click();
          }
        }
      }
      else {
        await handleErrorResponse(response, setIsMessage, setErrorResponse);
      }
    }
    catch (error) {
      handleError();
    }
  };

  const handleExportComparisonAsync = async (scenarios) => {
    const formattedScenarios = formatScenarios(scenarios);
    try {
      const response = FeatureFlags.IS_MOCK ? await exportMockGMRQuotes(formattedScenarios) : await exportGMRQuotes(formattedScenarios, proxyUser.id);
      if (response && response.ok) {
        const data = await response.blob();
        const exportQuote = await createFile(data, "gmr-quote", data.type);
        setExportURL(URL.createObjectURL(exportQuote));
        if (exportRef.current) {
          exportRef.current.click();
        }
      }
      else {
        await handleErrorResponse(response, setIsMessage, setErrorResponse);
      }
    }
    catch (error) {
      handleError();
    }
  };

  const handleSubmitForReview = async () => {
    await submitForReviewAsync();
  };

  const handleBrokerGuarantorModal = async () => {
    const newGuarantor = { id: guid(), email: guarantorSearch, isMailingSameAsPhysical: true, isUSCitizen: true };
    const notValidEmails = validateEmails(newGuarantor, ["email"]);
    if (notValidEmails.length === 0) {
      setInvalidProps([]);
      setIsInteriorCardLoading(true);
      const guarantorExistsObj = await handleGetGuarantorExistsAsync(guarantorSearch);
      if (!guarantorExistsObj) {
        setNewGuarantor(newGuarantor);
        handleModal("new guarantor");
      }

      setIsInteriorCardLoading(false);
    }
    else {
      setTimeout(() => {
        invalidProps.push("custom-broker-guarantor-email");
        setInvalidProps([...invalidProps]);
      }, 50);
    }

    setIsBrokerGuarantorSelected(true);
    setGuarantorSearch("");
  };

  const handleBrokerGuarantorInvite = async (id) => {
    setInvalidProps([]);
    if (borrowerInfo && borrowerInfo.name) {
      const selectedGuarantor = selectedBrokerGuarantors.find(guarantor => guarantor.id === id);
      if (selectedGuarantor) {
        const guarantorInviteObj = {
          borrowerApplicationId: borrowerApplicationInfo.id,
          borrowerApplicationName: borrowerApplicationInfo.name,
          firstName: selectedGuarantor.firstName,
          lastName: selectedGuarantor.lastName,
          email: selectedGuarantor.email,
          borrowerName: (borrowerInfo && borrowerInfo.name) ? borrowerInfo.name : ""
        };

        const isGuarantorInvited = await handleBrokerGuarantorInviteAsync(guarantorInviteObj);
        if (isGuarantorInvited) {
          setIsBrokerGuarantorInvited(true);
          selectedGuarantor.status = BrokerConstants.GuarantorInviteStatus.PENDING;
          setSelectedBrokerGuarantors([...selectedBrokerGuarantors]);
          setBrokerGuarantorInvitedName(`${selectedGuarantor.firstName} ${selectedGuarantor.lastName}`);
          setTimeout(() => {
            setIsBrokerGuarantorInvited(false);
            setBrokerGuarantorInvitedName("");
          }, 3000);
        }
      }
    }
    else {
      setTimeout(() => {
        setInvalidProps(["custom-invite-broker-guarantor"]);
      }, 50);
    }
  };

  const handleModalClose = () => {
    setNewAssetAndLiability({});
    setNewReoSchedule({ isMortgageFree: true });
    setIsGuarantorModalOpen(false);
    setInvalidProps([]);
  };

  const handleGuarantorModalCancel = async () => {
    newGuarantor.assetsAndLiabilities = [];
    setNewGuarantor({ ...newGuarantor });
    handleModalClose();
  };

  const handleModal = (type, isPrev = false) => {
    if (type === "guarantor additional" && isPrev) {
      setModalType(type);
      setIsGuarantorModalOpen(true);
    }
    else if (type === "guarantor additional") {
      setInvalidProps([]);
      let notValidProps = [] as string[];
      let validatingProps = ["firstName", "lastName", "email"];
      if (newGuarantor.isMailingSameAsPhysical === false) {
        validatingProps = validatingProps.concat(["mailingAddress", "mailingZip", "mailingCity", "mailingCounty", "mailingState"]);
      }
      notValidProps = validateObj(newGuarantor, validatingProps);
      if (applicationMetadata && applicationMetadata.guarantors && applicationMetadata.guarantors.length > 0) {
        const foundMetaGuarantor = applicationMetadata.guarantors.find(x => x.email === newGuarantor.email);
        if (foundMetaGuarantor) {
          notValidProps.push("custom-guarantor-email");
        }
      }

      const notValidEmails = validateEmails(newGuarantor, ["email"]);
      if (notValidEmails && notValidEmails.length > 0 && notValidProps && !notValidProps.includes("email")) {
        notValidProps.push("custom-guarantor-invalid-email");
      }

      if (notValidProps.length === 0) {
        setModalType(type);
        setIsGuarantorModalOpen(true);
      }
      else {
        setTimeout(() => {
          setInvalidProps(notValidProps);
        }, 50);
      }
    }
    else {
      setModalType(type);
      setIsGuarantorModalOpen(true);
    }
  };

  const handleModalPrevNext = (prevModal, nextModal) => {
    return (
      <Grid>
        <Grid.Row columns={3}>
          <Grid.Column>
            {prevModal && <Button
              fluid
              onClick={() => handleModal(prevModal, true)}
            >
              <div className="gmr-button-container">
                <div className="gmr-button-text">Previous</div>
              </div>
            </Button>}
          </Grid.Column>
          <Grid.Column>
            <Button
              fluid
              onClick={() => handleGuarantorModalCancel()}
            >
              <div className="gmr-button-container">
                <div className="gmr-button-text">Cancel</div>
              </div>
            </Button>
          </Grid.Column>
          <Grid.Column>
            {nextModal && <Button
              className="bp-button"
              style={getIsWhiteLabeled() ? setBackgroundColor(brokerColor ? brokerColor : "#000000") : void 0}
              fluid
              onClick={() => handleModal(nextModal)}
            >
              <div className="gmr-button-container">
                <div className="gmr-button-text">Next</div>
              </div>
            </Button>}
          </Grid.Column>
        </Grid.Row>
      </Grid>
    );
  };

  const handleApplicationFormChange = (value, field, obj, setObj, type = "string", handleCustomFormChange = undefined as any, charLimit = undefined as number | undefined) => {
    handleFormChange(value, field, obj, setObj, type, handleCustomFormChange, charLimit);
  };

  const handleAlReoFormChange = (value, field, array, obj, setObj, index, type = "string", charLimit = undefined as number | undefined) => {
    obj[array][index][field] = handleInputType(type, value, undefined, undefined, charLimit);
    setObj({ ...obj });
  };

  const handleGuarantorModalHeader = (modal, subModal) => {
    return (
      <Breadcrumb size={"huge"}>
        {!subModal && <Breadcrumb.Section className="primary-breadcrumb" active>{modal}</Breadcrumb.Section>}
        {subModal && <React.Fragment>
          <Breadcrumb.Section className="primary-breadcrumb"
            link
            onClick={() => setModalType(modal === "New Borrower Entity" ? "new organization" : "new guarantor")}
          >
            {modal}
          </Breadcrumb.Section>
          <Breadcrumb.Divider icon='right chevron' />
        </React.Fragment>}
        {subModal && <Breadcrumb.Section active>{subModal}</Breadcrumb.Section>}
      </Breadcrumb>
    );
  };

  const getFilteredAL = (array, alType) => {
    const filteredAL = [] as string[];
    if (array) {
      array.forEach((item) => {
        if (item && item.Class === alType) {
          filteredAL.push(item);
        }
      });
    }

    return filteredAL;
  };

  const filterDefaultLiabilities = (liabilityTypes, isDeleteHide) => {
    if (!liabilityTypes) {
      return [];
    }

    return isDeleteHide ? liabilityTypes : liabilityTypes.filter(x => x.isBuiltIn === true);
  };

  const handleTableRemove = (array, index = 0, type = "borrower entity", alType = undefined as string | undefined) => {
    if (array === "guarantorAssetsAndLiabilities") {
      if (newGuarantor.assetsAndLiabilities && newGuarantor.assetsAndLiabilities.length > 0 && alType) {
        const guarantorAlTypes = newGuarantor.assetsAndLiabilities.filter(x => x.alOption === alType);
        if (guarantorAlTypes[index]) {
          const indexOfNewGuarantorAl = newGuarantor.assetsAndLiabilities.findIndex(x => x.id === guarantorAlTypes[index].id);
          newGuarantor.assetsAndLiabilities.splice(indexOfNewGuarantorAl, 1);
          setNewGuarantor({ ...newGuarantor });
        }
      }
    }
    else if (array === "guarantorReoSchedules") {
      if (newGuarantor.reoschedules && newGuarantor.reoschedules.length > 0) {
        newGuarantor.reoschedules.splice(index, 1);
        setNewGuarantor({ ...newGuarantor });
      }
    }
  };

  const addAL = (obj, setObj, alType) => {
    obj.isREOChanged = true;
    const newAssetAndLiabilityObj = {
      id: guid(),
      alOption: alType,
    };

    obj.assetsAndLiabilities.push(newAssetAndLiabilityObj);
    setObj({ ...obj });
  };

  const handleAddGuarantorReoSchedule = () => {
    if (!newGuarantor.reoschedules) {
      newGuarantor.reoschedules = [];
    }

    newGuarantor.reoschedules.push({ id: guid() });
    setNewGuarantor({ ...newGuarantor });
  };

  const formatAssets = (editMode, obj, setObj, isGuarantor = false) => {
    const formattedAssets = [] as any[];
    if (!obj.assetsAndLiabilities) {
      obj.assetsAndLiabilities = [] as any[];
    }

    if (obj.assetsAndLiabilities) {
      const assets = obj.assetsAndLiabilities.filter(x => x.alOption === "Asset");
      if (assets.length === 0) {
        const newAssetAndLiabilityObj = {
          id: guid(),
          alOption: "Asset"
        };

        obj.assetsAndLiabilities.push(newAssetAndLiabilityObj);
      }
    }

    obj.assetsAndLiabilities.forEach((alschedule, i) => {
      if (alschedule.alOption === "Asset") {
        const alObj = {
          "Type": <BCFormInput
            labelClass="gmr-background-label"
            type="dropdown"
            placeholder="Please Select"
            obj={newAssetAndLiability}
            field="alType"
            fluid={false}
            value={alschedule.alType}
            dropdownOptions={getDropdownOptions(applicationMetadata.assetTypes, ["id"], "name")}
            handleFormChange={(value, field) => handleAlReoFormChange(value, field, "assetsAndLiabilities", obj, setObj, i, "string")}
          // disabled={(!editMode || isNonGuarantorDisabled) && !isGuarantor}
          />,
          "Institution": <BCFormInput
            labelClass="gmr-background-label"
            type="input"
            placeholder="Construction Loan Services II"
            value={alschedule.institutionName}
            inputType="text"
            // disabled={(!editMode || isNonGuarantorDisabled) && !isGuarantor}
            field="institutionName"
            handleFormChange={(value, field) => handleAlReoFormChange(value, field, "assetsAndLiabilities", obj, setObj, i, "string")}
          />,
          "Current balance": <BCFormInput
            labelClass="gmr-background-label"
            type="input"
            placeholder="10000"
            fieldType="dollar"
            inputType="number"
            value={alschedule.currentBalance}
            field="currentBalance"
            handleFormChange={(value, field) => handleAlReoFormChange(value, field, "assetsAndLiabilities", obj, setObj, i, "string")}
          // disabled={(!editMode || isNonGuarantorDisabled) && !isGuarantor}
          />
        };

        formattedAssets.push(alObj);
      }
    });

    return formattedAssets;
  };

  const formatLiabilities = (editMode, obj, setObj, isGuarantor = false) => {
    const formattedLiabilities = [] as any[];
    if (obj.assetsAndLiabilities) {
      const liabilities = obj.assetsAndLiabilities.filter(x => x.alOption === "Liability");
      if (liabilities.length === 0) {
        const newAssetAndLiabilityObj = {
          id: guid(),
          alOption: "Liability"
        };

        obj.assetsAndLiabilities.push(newAssetAndLiabilityObj);
      }
    }

    obj.assetsAndLiabilities.forEach((alschedule, i) => {
      if (alschedule.alOption === "Liability") {
        const alObj = {
          "Type": <BCFormInput
            labelClass="gmr-background-label"
            type="dropdown"
            placeholder="Please Select"
            obj={newAssetAndLiability}
            field="alType"
            fluid={false}
            value={alschedule.alType}
            dropdownOptions={alType === "Asset" ? getDropdownOptions(applicationMetadata.assetTypes, ["id"], "name") :
              getDropdownOptions(filterDefaultLiabilities(applicationMetadata.liabilityTypes, alschedule.isDeleteHide), ["id"], "name")}
            handleFormChange={(value, field) => handleAlReoFormChange(value, field, "assetsAndLiabilities", obj, setObj, i, "string")}
          // disabled={(!editMode || isNonGuarantorDisabled) && !isGuarantor}
          />,
          "Institution": <BCFormInput
            labelClass="gmr-background-label"
            type="input"
            placeholder="Construction Loan Services II"
            value={alschedule.institutionName}
            inputType="text"
            // disabled={(!editMode || isNonGuarantorDisabled) && !isGuarantor}
            field="institutionName"
            handleFormChange={(value, field) => handleAlReoFormChange(value, field, "assetsAndLiabilities", obj, setObj, i, "string")}
          />,
          "Current balance": <BCFormInput
            labelClass="gmr-background-label"
            type="input"
            placeholder="10000"
            fieldType="dollar"
            inputType="number"
            value={alschedule.currentBalance}
            field="currentBalance"
            handleFormChange={(value, field) => handleAlReoFormChange(value, field, "assetsAndLiabilities", obj, setObj, i, "string")}
          // disabled={(!editMode || isNonGuarantorDisabled) && !isGuarantor}
          />,
          "Liability": <BCFormInput
            labelClass="gmr-background-label"
            type="input"
            placeholder="10000"
            fieldType="dollar"
            inputType="number"
            value={alschedule.monthlyLiability}
            field="monthlyLiability"
            handleFormChange={(value, field) => handleAlReoFormChange(value, field, "assetsAndLiabilities", obj, setObj, i, "string")}
          // disabled={(!editMode || isNonGuarantorDisabled) && !isGuarantor}
          />
        };

        formattedLiabilities.push(alObj);
      }
    });

    return formattedLiabilities;

  };

  const formatReos = (obj, setObj, isGuarantor = false) => {
    const formattedReos = [] as any[];
    if (!obj.reoschedules) {
      obj.reoschedules = [];
    }

    if (obj.reoschedules) {
      if (obj.reoschedules.length === 0) {
        obj.reoschedules.push({ id: guid() });
      }

      obj.reoschedules.forEach((reoSchedule, i) => {
        // TODO: Renable if needed
        // const guarantorAdditionalCollateralFullIds = Array.from(guarantorAdditionalCollateralFull, x => x.id);
        // const entityAdditionalCollateralIds = Array.from(entityAdditionalCollateral, x => x.id);
        // let isDeleteHide = false;
        // if (guarantorAdditionalCollateralFullIds.concat(entityAdditionalCollateralIds).includes(reoSchedule.id) && reoSchedule.additionalCollateral) {
        //   isDeleteHide = true;
        // }

        const reoObj = {
          "Institution": <BCFormInput
            labelClass="gmr-background-label"
            type="input"
            placeholder="Construction Loan Services II"
            obj={reoSchedule}
            value={reoSchedule.holder1}
            field="holder1"
            inputType="text"
            handleFormChange={(value, field) => handleAlReoFormChange(value, field, "reoschedules", obj, setObj, i, "string")}
          // disabled={isNonGuarantorDisabled && !isGuarantor}
          />,
          "Total Mortgage Amount": <BCFormInput
            labelClass="gmr-background-label"
            type="input"
            placeholder="1000"
            obj={reoSchedule}
            field="mortgageAmount1"
            value={(reoSchedule.mortgageAmount1 ? reoSchedule.mortgageAmount1 : 0) +
              (reoSchedule.mortgageAmount2 ? reoSchedule.mortgageAmount2 : 0) + (reoSchedule.mortgageAmount3 ? newReoSchedule.mortgageAmount3 : 0)}
            fieldType="dollar"
            inputType="number"
            handleFormChange={(value, field) => handleAlReoFormChange(value, field, "reoschedules", obj, setObj, i, "string")}
          // disabled={isNonGuarantorDisabled && !isGuarantor}
          />,
          "Mortgage Status": <BCFormInput
            labelClass="gmr-background-label"
            type="dropdown"
            placeholder="Please Select"
            obj={reoSchedule}
            field="reoStatus"
            fluid={false}
            value={reoSchedule.reoStatus}
            dropdownOptions={getDropdownOptions(applicationMetadata.reoStatuses, ["id"], "name")}
            handleFormChange={(value, field) => handleAlReoFormChange(value, field, "reoschedules", obj, setObj, i, "string")}
          // disabled={isNonGuarantorDisabled && !isGuarantor}
          />,
          "Address": <BCFormInput
            labelClass="gmr-background-label"
            type={GlobalConstants.FormInputTypes.PLACES}
            placeDetailsObject={reoSchedule}
            setPlaceDetailsObject={setNewReoSchedule}
            placeholder="1234 Main Street, Seattle, WA 98052, USA"
            defaultValue={handleAddressValue({
              address: reoSchedule.street,
              city: reoSchedule.city,
              state: reoSchedule.state,
              zip: reoSchedule.zip
            })}
            placeFields={["address", "city", "state", "county", "zip"]}
            placeFieldsNameOverrides={[
              {
                addressComponent: "address",
                field: "street"
              },
            ]}
          // disabled={isNonGuarantorDisabled && !isGuarantor}
          // handleCustomFormChange={() => handleREODuplicateAddresses(obj, setObj, i)}
          // handleIsDuplicate={() => handleIsDuplicateREOAddresses()}
          />,
          "Market Value": <BCFormInput
            labelClass="gmr-background-label"
            type="input"
            placeholder="10000"
            obj={reoSchedule}
            field="marketValue"
            value={reoSchedule.marketValue}
            fieldType="dollar"
            inputType="number"
            handleFormChange={(value, field) => handleAlReoFormChange(value, field, "reoschedules", obj, setObj, i, "string")}
          // disabled={isNonGuarantorDisabled && !isGuarantor}
          />,
          "Include as Additional Collateral?": <BCFormInput
            labelClass="gmr-background-label"
            type="checkbox"
            obj={reoSchedule}
            field="additionalCollateral"
            value={reoSchedule.additionalCollateral}
            handleFormChange={(value, field) => handleAlReoFormChange(value, field, "reoschedules", obj, setObj, i)}
          // disabled={isNonGuarantorDisabled && !isGuarantor}
          />
        };

        formattedReos.push(reoObj);
      });
    }

    return formattedReos;
  };

  const handleAlForm = (alType) => {
    newAssetAndLiability.alOption = alType;
    return (
      <React.Fragment>
        <Grid.Row className="application-row">
          {alType === "Asset" ? <Grid.Column width={16}>
            <BCTable
              data={getFilteredAL(newGuarantor.assetsAndLiabilities, alType) && getFilteredAL(newGuarantor.assetsAndLiabilities, alType).length > -1 ? formatAssets(true, newGuarantor, setNewGuarantor) : [
                {
                  "Class": undefined,
                  "Type": undefined,
                  "Name of Institution": undefined,
                  "Current Balance": undefined,
                  "Monthly Liability": undefined,
                  "Status": undefined
                }
              ]}
              dataRules={[
                { field: "Class", rule: "hide" },
                { field: "Status", rule: "hide" },
                { field: "id", rule: "hide" },
                { field: "Current Balance", rule: "format", display: "dollar" },
                { field: "Monthly Liability", rule: alType === "Asset" ? "hide" : "format", display: "dollar" }
              ]}
              thin
              dataSingleLine
              actions={newGuarantor.assetsAndLiabilities && newGuarantor.assetsAndLiabilities.filter((x) => x.alOption === "Asset").length !== 1 && ["delete"]}
              handleTableDelete={(index) => handleTableRemove("guarantorAssetsAndLiabilities", index, "guarantor", alType)}
              overflowX
              unstackable
              brokerColor={getIsWhiteLabeled() ? brokerColor : void 0}
            />
          </Grid.Column>
            : <Grid.Column width={16}>
              <BCTable
                data={getFilteredAL(newGuarantor.assetsAndLiabilities, alType) && getFilteredAL(newGuarantor.assetsAndLiabilities, alType).length > -1 ? formatLiabilities(true, newGuarantor, setNewGuarantor) : [
                  {
                    "Class": undefined,
                    "Type": undefined,
                    "Name of Institution": undefined,
                    "Current Balance": undefined,
                    "Monthly Liability": undefined,
                    "Status": undefined
                  }
                ]}
                dataRules={[
                  { field: "Class", rule: "hide" },
                  { field: "Status", rule: "hide" },
                  { field: "id", rule: "hide" },
                  { field: "Current Balance", rule: "format", display: "dollar" },
                  { field: "Monthly Liability", rule: alType === "Asset" ? "hide" : "format", display: "dollar" }
                ]}
                thin
                dataSingleLine
                actions={newGuarantor.assetsAndLiabilities && newGuarantor.assetsAndLiabilities.filter((x) => x.alOption === "Liability").length !== 1 && ["delete"]}
                handleTableDelete={(index) => handleTableRemove("guarantorAssetsAndLiabilities", index, "guarantor", alType)}
                overflowX
                unstackable
                brokerColor={getIsWhiteLabeled() ? brokerColor : void 0}
              />
            </Grid.Column>}
        </Grid.Row>
        <Grid.Row className="application-row">
          <Grid.Column width={16}>
            <Button
              className="bp-button application-button"
              fluid
              onClick={() => addAL(newGuarantor, setNewGuarantor, alType)}
            >
              <div className="gmr-button-container">
                <div className="gmr-button-text">{alType === "Asset" ? "Add Asset" : "Add Liability"}</div>
              </div>
            </Button>
          </Grid.Column>
        </Grid.Row>
      </React.Fragment>
    );
  };

  const handleReoForm = (type) => {
    const assetsAndLiabilities = newGuarantor.assetsAndLiabilities;
    return (
      <React.Fragment>
        <Grid.Row className="application-row">
          {type === "guarantor reo" && <Grid.Column width={16}>
            <BCTable
              data={formatReos(newGuarantor, setNewGuarantor)}
              dataRules={[
                { field: "id", rule: "hide" },
                { field: "Total Mortgage Payment", rule: "format", display: "dollar" },
                { field: "isDeleteHide", rule: "hide" }
              ]}
              thin
              actions={(newGuarantor.reoSchedules && newGuarantor.reoSchedules !== 1) && ["delete"]}
              handleTableDelete={(index) => handleTableRemove("guarantorReoSchedules", index, "guarantor")}
              overflowX
              unstackable
              columns={6}
              brokerColor={getIsWhiteLabeled() ? brokerColor : void 0}
            />
          </Grid.Column>}
        </Grid.Row>
        {type !== "guarantor reo" && <React.Fragment>
          <Grid.Row className="application-row">
            <Grid.Column width={isGreaterThanMobile ? 8 : 16}>
              <BCFormInput
                labelClass="gmr-background-label"
                type="dropdown"
                label="REO Type"
                placeholder="Please Select"
                obj={newReoSchedule}
                field="reoType"
                dropdownOptions={getDropdownOptions(applicationMetadata.reoTypes, ["id"], "name")}
                handleFormChange={(value, field) => handleApplicationFormChange(value, field, newReoSchedule, setNewReoSchedule)}
              />
              <BCValidationMessage invalidProps={invalidProps} prop="reoType" />
            </Grid.Column>
            <Grid.Column width={isGreaterThanMobile ? 8 : 16}>
              <BCFormInput
                labelClass="gmr-background-label"
                type="dropdown"
                label="REO Status"
                placeholder="Please Select"
                obj={newReoSchedule}
                field="reoStatus"
                dropdownOptions={getDropdownOptions(applicationMetadata.reoStatuses, ["id"], "name")}
                handleFormChange={(value, field) => handleApplicationFormChange(value, field, newReoSchedule, setNewReoSchedule)}
              />
              <BCValidationMessage invalidProps={invalidProps} prop="reoStatus" />
            </Grid.Column>
            <Grid.Column width={16}>
              <BCFormInput
                label="Address"
                labelClass="gmr-background-label"
                type={GlobalConstants.FormInputTypes.PLACES}
                placeDetailsObject={newReoSchedule}
                setPlaceDetailsObject={setNewReoSchedule}
                placeholder="1234 Main Street, Seattle, WA 98052, USA"
                defaultValue={handleAddressValue({
                  address: newReoSchedule.street,
                  city: newReoSchedule.city,
                  state: newReoSchedule.state,
                  zip: newReoSchedule.zip
                })}
                placeFields={["address", "city", "state", "county", "zip"]}
                placeFieldsNameOverrides={[
                  {
                    addressComponent: "address",
                    field: "street"
                  },
                ]}
                required
              />
              {invalidProps.includes("city") ? <BCValidationMessage
                invalidProps={invalidProps}
                prop="city"
                propText="This city is invalid."
              /> : invalidProps.includes("state") ? <BCValidationMessage
                invalidProps={invalidProps}
                prop="state"
                propText="This state is invalid."
              /> : invalidProps.includes("zip") ? <BCValidationMessage
                invalidProps={invalidProps}
                prop="zip"
                propText="This zip code is invalid."
              /> : invalidProps.includes("county") ? <BCValidationMessage
                invalidProps={invalidProps}
                prop="county"
                propText="This county is invalid."
              /> : <BCValidationMessage
                invalidProps={invalidProps}
                prop="street"
                propText="This address is invalid." />
              }
            </Grid.Column>
            <Grid.Column width={16}>
              <BCFormInput
                labelClass="gmr-background-label"
                type="input"
                label="Address Line 2"
                placeholder="Apartment, suite, unit, building, floor, etc."
                obj={newReoSchedule}
                field="addressLine2"
                inputType="text"
                handleFormChange={(value, field) => handleApplicationFormChange(value, field, newReoSchedule, setNewReoSchedule)}
              />
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column width={isGreaterThanMobile ? 8 : 16}>
              <BCFormInput
                labelClass="gmr-background-label"
                type="input"
                label="Market Value"
                placeholder="10000"
                obj={newReoSchedule}
                field="marketValue"
                fieldType="dollar"
                inputType="number"
                handleFormChange={(value, field) => handleApplicationFormChange(value, field, newReoSchedule, setNewReoSchedule)}
              />
              <BCValidationMessage invalidProps={invalidProps} prop="marketValue" />
            </Grid.Column>
            <Grid.Column width={isGreaterThanMobile ? 8 : 16}>
              <BCFormInput
                labelClass="gmr-background-label"
                type="input"
                label="Monthly Tax Insurance and Maintenance"
                placeholder="1000"
                obj={newReoSchedule}
                field="maintenance"
                fieldType="dollar"
                inputType="number"
                handleFormChange={(value, field) => handleApplicationFormChange(value, field, newReoSchedule, setNewReoSchedule)}
              />
            </Grid.Column>
          </Grid.Row>
          <Grid.Row className="application-row">
            {type === "borrower entity" && <Grid.Column width={16}>
              <BCFormInput
                labelClass="gmr-background-label"
                type="input"
                label="How much is owed?"
                placeholder="1000"
                obj={newReoSchedule}
                field="amountOwed"
                fieldType="dollar"
                inputType="number"
                handleFormChange={(value, field) => handleApplicationFormChange(value, field, newReoSchedule, setNewReoSchedule)}
              />
              <BCValidationMessage invalidProps={invalidProps} prop="mortgageAmount1" />
            </Grid.Column>}
            {(type === "guarantor wizard" || type === "guarantor reo" || type === "guarantor reo wizard") && <Grid.Column width={16}>
              <BCFormInput
                labelClass="gmr-background-label"
                type="checkbox"
                checkboxText="Mortgage Free"
                obj={newReoSchedule}
                field="isMortgageFree"
                value={newReoSchedule.isMortgageFree}
                handleFormChange={(value, field) => assetsAndLiabilities && assetsAndLiabilities.length > 0 ? handleFormChange(value, field, undefined, undefined, newReoSchedule, setNewReoSchedule) : void 0}
              />
            </Grid.Column>}
            {(newReoSchedule.isMortgageFree === false && type.includes("guarantor")) && <React.Fragment>
              <Grid.Column width={isGreaterThanMobile ? 4 : 16}>
                <BCFormInput
                  labelClass="gmr-background-label"
                  type="dropdown"
                  label="AL Schedule 1"
                  placeholder="Please Select"
                  obj={newReoSchedule}
                  field="alSchedule1"
                  dropdownOptions={getDropdownOptions(assetsAndLiabilities, ["Name of Institution"], "Name of Institution")}
                  handleFormChange={(value, field) => handleApplicationFormChange(value, field, newReoSchedule, setNewReoSchedule)}
                />
                <BCValidationMessage invalidProps={invalidProps} prop="alSchedule1" />
              </Grid.Column>
              <Grid.Column width={isGreaterThanMobile ? 4 : 16}>
                <BCFormInput
                  labelClass="gmr-background-label"
                  type="input"
                  label="Amount 1"
                  placeholder="1000"
                  obj={newReoSchedule}
                  field="mortgageAmount1"
                  fieldType="dollar"
                  inputType="number"
                  handleFormChange={(value, field) => handleApplicationFormChange(value, field, newReoSchedule, setNewReoSchedule, GlobalConstants.InputTypes.DOLLAR)}
                />
                <BCValidationMessage invalidProps={invalidProps} prop="mortgageAmount1" />
              </Grid.Column>
              <Grid.Column width={isGreaterThanMobile ? 4 : 16}>
                <BCFormInput
                  labelClass="gmr-background-label"
                  type="input"
                  label="Payment 1"
                  placeholder="1000"
                  obj={newReoSchedule}
                  field="mortgagePayment1"
                  fieldType="dollar"
                  inputType="number"
                  handleFormChange={(value, field) => handleApplicationFormChange(value, field, newReoSchedule, setNewReoSchedule, GlobalConstants.InputTypes.DOLLAR)}
                />
                <BCValidationMessage invalidProps={invalidProps} prop="mortgagePayment1" />
              </Grid.Column>
              <Grid.Column width={isGreaterThanMobile ? 4 : 16}>
                <BCFormInput
                  labelClass="gmr-background-label"
                  type="input"
                  label="Holder 1"
                  placeholder="Construction Loan Services II"
                  obj={newReoSchedule}
                  field="holder1"
                  inputType="text"
                  handleFormChange={(value, field) => handleApplicationFormChange(value, field, newReoSchedule, setNewReoSchedule, undefined, undefined, 50)}
                />
              </Grid.Column>
              <Grid.Column width={isGreaterThanMobile ? 4 : 16}>
                <BCFormInput
                  labelClass="gmr-background-label"
                  type="dropdown"
                  label="AL Schedule 2"
                  placeholder="Please Select"
                  obj={newReoSchedule}
                  field="alSchedule2"
                  dropdownOptions={getDropdownOptions(assetsAndLiabilities, ["Name of Institution"], "Name of Institution")}
                  handleFormChange={(value, field) => handleApplicationFormChange(value, field, newReoSchedule, setNewReoSchedule)}
                />
                <BCValidationMessage invalidProps={invalidProps} prop="alSchedule2" />
              </Grid.Column>
              <Grid.Column width={isGreaterThanMobile ? 4 : 16}>
                <BCFormInput
                  labelClass="gmr-background-label"
                  type="input"
                  label="Amount 2"
                  placeholder="1000"
                  obj={newReoSchedule}
                  field="mortgageAmount2"
                  fieldType="dollar"
                  inputType="number"
                  handleFormChange={(value, field) => handleApplicationFormChange(value, field, newReoSchedule, setNewReoSchedule, GlobalConstants.InputTypes.DOLLAR)}
                />
                <BCValidationMessage invalidProps={invalidProps} prop="mortgageAmount2" />
              </Grid.Column>
              <Grid.Column width={isGreaterThanMobile ? 4 : 16}>
                <BCFormInput
                  labelClass="gmr-background-label"
                  type="input"
                  label="Payment 2"
                  placeholder="1000"
                  obj={newReoSchedule}
                  field="mortgagePayment2"
                  fieldType="dollar"
                  inputType="number"
                  handleFormChange={(value, field) => handleApplicationFormChange(value, field, newReoSchedule, setNewReoSchedule, GlobalConstants.InputTypes.DOLLAR)}
                />
                <BCValidationMessage invalidProps={invalidProps} prop="mortgagePayment2" />
              </Grid.Column>
              <Grid.Column width={isGreaterThanMobile ? 4 : 16}>
                <BCFormInput
                  labelClass="gmr-background-label"
                  type="input"
                  label="Holder 2"
                  placeholder="Construction Loan Services II"
                  obj={newReoSchedule}
                  field="holder2"
                  inputType="text"
                  handleFormChange={(value, field) => handleApplicationFormChange(value, field, newReoSchedule, setNewReoSchedule, undefined, undefined, 50)}
                />
              </Grid.Column>
              <Grid.Column width={isGreaterThanMobile ? 4 : 16}>
                <BCFormInput
                  labelClass="gmr-background-label"
                  type="dropdown"
                  label="AL Schedule 3"
                  placeholder="Please Select"
                  obj={newReoSchedule}
                  field="alSchedule3"
                  dropdownOptions={getDropdownOptions(assetsAndLiabilities, ["Name of Institution"], "Name of Institution")}
                  handleFormChange={(value, field) => handleApplicationFormChange(value, field, newReoSchedule, setNewReoSchedule)}
                />
                <BCValidationMessage invalidProps={invalidProps} prop="alSchedule3" />
              </Grid.Column>
              <Grid.Column width={isGreaterThanMobile ? 4 : 16}>
                <BCFormInput
                  labelClass="gmr-background-label"
                  type="input"
                  label="Amount 3"
                  placeholder="1000"
                  obj={newReoSchedule}
                  field="mortgageAmount3"
                  inputType="number"
                  fieldType="dollar"
                  handleFormChange={(value, field) => handleApplicationFormChange(value, field, newReoSchedule, setNewReoSchedule, GlobalConstants.InputTypes.DOLLAR)}
                />
                <BCValidationMessage invalidProps={invalidProps} prop="mortgageAmount3" />
              </Grid.Column>
              <Grid.Column width={isGreaterThanMobile ? 4 : 16}>
                <BCFormInput
                  labelClass="gmr-background-label"
                  type="input"
                  label="Payment 3"
                  placeholder="1000"
                  obj={newReoSchedule}
                  field="mortgagePayment3"
                  fieldType="dollar"
                  inputType="number"
                  handleFormChange={(value, field) => handleApplicationFormChange(value, field, newReoSchedule, setNewReoSchedule, GlobalConstants.InputTypes.DOLLAR)}
                />
                <BCValidationMessage invalidProps={invalidProps} prop="mortgagePayment3" />
              </Grid.Column>
              <Grid.Column width={isGreaterThanMobile ? 4 : 16}>
                <BCFormInput
                  labelClass="gmr-background-label"
                  type="input"
                  label="Holder 3"
                  placeholder="Construction Loan Services II"
                  obj={newReoSchedule}
                  field="holder3"
                  inputType="text"
                  handleFormChange={(value, field) => handleApplicationFormChange(value, field, newReoSchedule, setNewReoSchedule, undefined, undefined, 50)}
                />
              </Grid.Column>
            </React.Fragment>}
            <Grid.Column width={16}>
              <BCFormInput
                labelClass="gmr-background-label"
                type="textarea"
                label="Description"
                placeholder="Write your description here..."
                obj={newReoSchedule}
                field="reoScheduleDescription"
                value={newReoSchedule.reoScheduleDescription}
                handleFormChange={(value, field) => handleApplicationFormChange(value, field, newReoSchedule, setNewReoSchedule)}
              />
            </Grid.Column>
          </Grid.Row></React.Fragment>}
        {type === "guarantor reo" && <Grid.Row className="application-row">
          <Grid.Column width={16}>
            <Button
              className="bp-button application-button"
              fluid
              style={getIsWhiteLabeled() ? setBackgroundColor(brokerColor ? brokerColor : "#000000") : void 0}
              onClick={() => handleAddGuarantorReoSchedule()}
            >
              <div className="gmr-button-container">
                <div className="gmr-button-text">Add REO Schedule</div>
              </div>
            </Button>
          </Grid.Column>
        </Grid.Row>}
      </React.Fragment>
    );
  };

  const handleGuarantorModalSubmit = async () => {
    if (!newGuarantor.id) {
      newGuarantor.id = guid();
    }

    setIsInteriorCardLoading(true);
    handlePatchApplicationGuarantor();
    const guarantorFull = await handleUpsertGuarantorAsync(convertGuarantor(newGuarantor));
    if (guarantorFull) {
      selectedBrokerGuarantors.push({
        id: guarantorFull.id,
        firstName: guarantorFull.firstName,
        lastName: guarantorFull.lastName,
        email: guarantorFull.email,
        accessLevelId: null,
        status: null
      });

      setSelectedBrokerGuarantors([...selectedBrokerGuarantors]);
    }
    
    setNewGuarantor({ isMailingSameAsPhysical: true, isUSCitizen: true });
    setIsInteriorCardLoading(false);
    handleModalClose();
  };

  const handleGuarantorModal = (type) => {
    const guarantorModal = [] as any;
    if (type === "new guarantor") {
      guarantorModal.header = <div>New Guarantor</div>;
      guarantorModal.content = <Form className="primary-form">
        <Grid>
          <Grid.Row className="application-row">
            <Grid.Column width={isGreaterThanMobile ? 8 : 16}>
              <BCFormInput
                labelClass="gmr-background-label"
                type="input"
                label="First Name"
                placeholder="John"
                obj={newGuarantor}
                field="firstName"
                inputType="text"
                handleFormChange={(value, field) => handleApplicationFormChange(value, field, newGuarantor, setNewGuarantor, GlobalConstants.InputTypes.STRING, undefined, 25)}
                required
              />
              <BCValidationMessage invalidProps={invalidProps} prop="firstName" />
            </Grid.Column>
            <Grid.Column width={isGreaterThanMobile ? 8 : 16}>
              <BCFormInput
                labelClass="gmr-background-label"
                type="input"
                label="Last Name"
                placeholder="Smith"
                obj={newGuarantor}
                field="lastName"
                inputType="text"
                handleFormChange={(value, field) => handleApplicationFormChange(value, field, newGuarantor, setNewGuarantor, GlobalConstants.InputTypes.STRING, undefined, 25)}
                required
              />
              <BCValidationMessage invalidProps={invalidProps} prop="lastName" />
            </Grid.Column>
          </Grid.Row>
          <Grid.Row className="application-row">
            <Grid.Column width={isGreaterThanMobile ? 8 : 16}>
              <BCFormInput
                labelClass="gmr-background-label"
                type="input"
                label="Email"
                placeholder="john.smith@gmail.com"
                obj={newGuarantor}
                field="email"
                inputType="text"
                handleFormChange={(value, field) => handleApplicationFormChange(value, field, newGuarantor, setNewGuarantor, undefined, undefined, 100)}
                required
                disabled
              />
              <BCValidationMessage invalidProps={invalidProps} prop="email" />
              <BCValidationMessage
                invalidProps={invalidProps}
                prop="custom-guarantor-invalid-email"
                propText="This email is invalid.."
              />
              <BCValidationMessage
                invalidProps={invalidProps}
                prop="custom-guarantor-email"
                propText="You have already added a guarantor with this email."
              />
            </Grid.Column>
            <Grid.Column width={isGreaterThanMobile ? 8 : 16}>
              <BCFormInput
                labelClass="gmr-background-label"
                type="input"
                label="Mobile Phone"
                placeholder="2061234567"
                obj={newGuarantor}
                field="mobilePhone"
                fieldType="phone"
                inputType="text"
                handleFormChange={(value, field) => handleApplicationFormChange(value, field, newGuarantor, setNewGuarantor, GlobalConstants.InputTypes.MASKED)}
              />
            </Grid.Column>
            <Grid.Column width={16}>
              <BCFormInput
                labelClass="gmr-background-label"
                type="checkbox"
                checkboxText="Mailing Same As Physical"
                obj={newGuarantor}
                field="isMailingSameAsPhysical"
                value={newGuarantor.isMailingSameAsPhysical}
                handleFormChange={(value, field) => handleApplicationFormChange(value, field, newGuarantor, setNewGuarantor)}
              />
            </Grid.Column>
            <Grid.Column width={16}>
              <BCFormInput
                label="Address"
                labelClass="gmr-background-label"
                type={GlobalConstants.FormInputTypes.PLACES}
                placeDetailsObject={newGuarantor}
                setPlaceDetailsObject={setNewGuarantor}
                placeholder="1234 Main Street, Seattle, WA 98052, USA"
                defaultValue={handleAddressValue({
                  address: newGuarantor.physicalAddress,
                  city: newGuarantor.physicalCity,
                  state: newGuarantor.physicalState,
                  zip: newGuarantor.physicalZip
                })}
                placeFields={["address", "city", "state", "county", "zip"]}
                placeFieldsNameOverrides={[
                  {
                    addressComponent: "address",
                    field: "physicalAddress"
                  },
                  {
                    addressComponent: "city",
                    field: "physicalCity"
                  },
                  {
                    addressComponent: "state",
                    field: "physicalState"
                  },
                  {
                    addressComponent: "county",
                    field: "physicalCounty"
                  },
                  {
                    addressComponent: "zip",
                    field: "physicalZip"
                  },
                ]}
              />
            </Grid.Column>
            <Grid.Column width={16}>
              <BCFormInput
                labelClass="gmr-background-label"
                type="input"
                label="Address Line 2"
                placeholder="Apartment, suite, unit, building, floor, etc."
                obj={newGuarantor}
                field="physicalAddressLine2"
                inputType="text"
                handleFormChange={(value, field) => handleApplicationFormChange(value, field, newGuarantor, setNewGuarantor)}
              />
            </Grid.Column>
          </Grid.Row>
          {newGuarantor.isMailingSameAsPhysical === false && <React.Fragment>
            <Grid.Row className="application-row">
              <Grid.Column width={16}>
                <BCFormInput
                  label="Address"
                  labelClass="gmr-background-label"
                  type={GlobalConstants.FormInputTypes.PLACES}
                  placeDetailsObject={newGuarantor}
                  setPlaceDetailsObject={setNewGuarantor}
                  placeholder="1234 Main Street, Seattle, WA 98052, USA"
                  defaultValue={handleAddressValue({
                    address: newGuarantor.mailingAddress,
                    city: newGuarantor.mailingCity,
                    state: newGuarantor.mailingState,
                    zip: newGuarantor.mailingZip
                  })}
                  placeFields={["address", "city", "state", "county", "zip"]}
                  placeFieldsNameOverrides={[
                    {
                      addressComponent: "address",
                      field: "mailingAddress"
                    },
                    {
                      addressComponent: "city",
                      field: "mailingCity"
                    },
                    {
                      addressComponent: "state",
                      field: "mailingState"
                    },
                    {
                      addressComponent: "county",
                      field: "mailingCounty"
                    },
                    {
                      addressComponent: "zip",
                      field: "mailingZip"
                    },
                  ]}
                />
              </Grid.Column>
              <Grid.Column width={16}>
                <BCFormInput
                  labelClass="gmr-background-label"
                  type="input"
                  label="Address Line 2"
                  placeholder="Apartment, suite, unit, building, floor, etc."
                  obj={newGuarantor}
                  field="mailingAddressLine2"
                  inputType="text"
                  handleFormChange={(value, field) => handleApplicationFormChange(value, field, newGuarantor, setNewGuarantor)}
                />
              </Grid.Column>
            </Grid.Row>
          </React.Fragment>}
          <Grid.Row className="application-row">
            <Grid.Column width={isGreaterThanMobile ? 8 : 16}>
              <BCFormInput
                labelClass="gmr-background-label"
                type="input"
                label="Home Phone"
                placeholder="2061234567"
                obj={newGuarantor}
                field="homePhone"
                fieldType="phone"
                inputType="text"
                handleFormChange={(value, field) => handleApplicationFormChange(value, field, newGuarantor, setNewGuarantor, GlobalConstants.InputTypes.MASKED)}
              />
            </Grid.Column>
            <Grid.Column width={isGreaterThanMobile ? 8 : 16}>
              <BCFormInput
                labelClass="gmr-background-label"
                type="input"
                label="Business Phone"
                placeholder="2061234567"
                obj={newGuarantor}
                field="businessPhone"
                fieldType="phone"
                inputType="text"
                handleFormChange={(value, field) => handleApplicationFormChange(value, field, newGuarantor, setNewGuarantor, GlobalConstants.InputTypes.MASKED)}
              />
            </Grid.Column>
            <Grid.Column width={isGreaterThanMobile ? 4 : 8}>
              <BCFormInput
                labelClass="gmr-background-label"
                type="input"
                label="Extension"
                placeholder="3"
                obj={newGuarantor}
                field="extension"
                inputType="text"
                handleFormChange={(value, field) => handleApplicationFormChange(value, field, newGuarantor, setNewGuarantor)}
              />
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Form>;
      guarantorModal.actions = <React.Fragment>{handleModalPrevNext(undefined, "guarantor additional")}</React.Fragment>;
    }
    else if (type === "guarantor additional") {
      guarantorModal.header = <div>{handleGuarantorModalHeader("New Guarantor", "Additonal Information")}</div>;
      guarantorModal.content = <Form className="primary-form">
        <Grid>
          <Grid.Row className="application-row">
            <Grid.Column width={isGreaterThanMobile ? 8 : 16}>
              <BCFormInput
                labelClass="gmr-background-label"
                type="input"
                label="Social Security Number"
                placeholder="123-45-6789"
                obj={newGuarantor}
                field="socialSecurityNumber"
                fieldType="socialSecurity"
                inputType="text"
                handleFormChange={(value, field) => handleApplicationFormChange(value, field, newGuarantor, setNewGuarantor, GlobalConstants.InputTypes.MASKED)}
                setColor={getIsWhiteLabeled() ? setColor(brokerColor ? brokerColor : "#000000") : void 0}
              />
            </Grid.Column>
            <Grid.Column width={isGreaterThanMobile ? 8 : 16}>
              <BCFormInput
                labelClass="gmr-background-label"
                type="input"
                label="Credit Score"
                placeholder="600"
                obj={newGuarantor}
                field="estimatedCreditScore"
                inputType="text"
                handleFormChange={(value, field) => handleApplicationFormChange(value, field, newGuarantor, setNewGuarantor, GlobalConstants.InputTypes.CREDIT)}
              />
            </Grid.Column>
          </Grid.Row>
          <Grid.Row className="application-row" columns={isGreaterThanMobile ? 3 : 1}>
            <Grid.Column>
              <BCFormInput
                labelClass="gmr-background-label"
                type="calendar"
                label="Date Of Birth"
                obj={newGuarantor}
                field="dateOfBirth"
                handleFormChange={(value, field) => handleApplicationFormChange(value, field, newGuarantor, setNewGuarantor)}
              />
            </Grid.Column>
            <Grid.Column>
              <BCFormInput
                labelClass="gmr-background-label"
                type="dropdown"
                label="Marital Status"
                obj={newGuarantor}
                field="maritalStatus"
                dropdownOptions={getDropdownOptions(applicationMetadata.maritalStatuses, ["id"], "name")}
                handleFormChange={(value, field) => handleApplicationFormChange(value, field, newGuarantor, setNewGuarantor)}
              />
            </Grid.Column>
            <Grid.Column>
              <BCFormInput
                labelClass="gmr-background-label"
                type="input"
                label="Spouse Name"
                placeholder="Jane Doe"
                obj={newGuarantor}
                field="spouseName"
                inputType="text"
                handleFormChange={(value, field) => handleApplicationFormChange(value, field, newGuarantor, setNewGuarantor)}
              />
            </Grid.Column>
          </Grid.Row>
          <Grid.Row className="application-row">
            <Grid.Column width={16}>
              <BCFormInput
                labelClass="gmr-background-label"
                type="checkbox"
                checkboxText="Self Employed"
                obj={newGuarantor}
                field="isSelfEmployed"
                value={newGuarantor.isSelfEmployed}
                handleFormChange={(value, field) => handleApplicationFormChange(value, field, newGuarantor, setNewGuarantor)}
              />
            </Grid.Column>
            <Grid.Column width={isGreaterThanMobile ? 8 : 16}>
              <BCFormInput
                labelClass="gmr-background-label"
                type="input"
                label="Employer Name"
                placeholder="Construction Loan Services II, LLC"
                obj={newGuarantor}
                field="employerName"
                inputType="text"
                handleFormChange={(value, field) => handleApplicationFormChange(value, field, newGuarantor, setNewGuarantor, undefined, undefined, 200)}
              />
            </Grid.Column>
            <Grid.Column width={isGreaterThanMobile ? 8 : 16}>
              <BCFormInput
                labelClass="gmr-background-label"
                type="input"
                label="Position"
                placeholder="Owner"
                obj={newGuarantor}
                field="position"
                inputType="text"
                handleFormChange={(value, field) => handleApplicationFormChange(value, field, newGuarantor, setNewGuarantor, undefined, undefined, 50)}
              />
            </Grid.Column>
            <Grid.Column width={isGreaterThanMobile ? 8 : 16}>
              <BCFormInput
                labelClass="gmr-background-label"
                type="input"
                label="Gross Revenue (Two Year Average)"
                placeholder="$100,000"
                obj={newGuarantor}
                field="grossRevenue"
                fieldType="dollar"
                inputType="number"
                handleFormChange={(value, field) => handleApplicationFormChange(value, field, newGuarantor, setNewGuarantor, GlobalConstants.InputTypes.DOLLAR)}
              />
            </Grid.Column>
            <Grid.Column width={isGreaterThanMobile ? 8 : 16}>
              <BCFormInput
                labelClass="gmr-background-label"
                type="input"
                label="Net Income (Two Year Average)"
                placeholder="$100,000"
                obj={newGuarantor}
                field="netIncome"
                fieldType="dollar"
                inputType="number"
                handleFormChange={(value, field) => handleApplicationFormChange(value, field, newGuarantor, setNewGuarantor, GlobalConstants.InputTypes.DOLLAR)}
              />
            </Grid.Column>
          </Grid.Row>
          <Grid.Row className="application-row" columns={isGreaterThanMobile ? 3 : 1}>
            <Grid.Column>
              <BCFormInput
                labelClass="gmr-background-label"
                type="input"
                label="Years In Industry"
                placeholder="3"
                obj={newGuarantor}
                field="yearsInIndustry"
                inputType="text"
                handleFormChange={(value, field) => handleApplicationFormChange(value, field, newGuarantor, setNewGuarantor, GlobalConstants.InputTypes.INT)}
              />
            </Grid.Column>
            <Grid.Column>
              <BCFormInput
                labelClass="gmr-background-label"
                type="input"
                label="Years In Job"
                placeholder="3"
                obj={newGuarantor}
                field="yearsInJob"
                inputType="text"
                handleFormChange={(value, field) => handleApplicationFormChange(value, field, newGuarantor, setNewGuarantor, GlobalConstants.InputTypes.INT)}
              />
            </Grid.Column>
            <Grid.Column>
              <BCFormInput
                labelClass="gmr-background-label"
                type="input"
                label="Years In Business"
                placeholder="3"
                obj={newGuarantor}
                field="yearsInBusiness"
                inputType="text"
                handleFormChange={(value, field) => handleApplicationFormChange(value, field, newGuarantor, setNewGuarantor, GlobalConstants.InputTypes.INT)}
              />
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column width={isGreaterThanMobile ? 6 : 16}>
              <BCFormInput
                labelClass="gmr-background-label"
                type="checkbox"
                checkboxText="US Citizen"
                obj={newGuarantor}
                field="isUSCitizen"
                value={newGuarantor.isUSCitizen}
                handleFormChange={(value, field) => handleApplicationFormChange(value, field, newGuarantor, setNewGuarantor)}
              />
            </Grid.Column>
            <Grid.Column width={isGreaterThanMobile ? 10 : 16}>
              <BCFormInput
                labelClass="gmr-background-label"
                type="input"
                label="Status"
                obj={newGuarantor}
                field="citizenStatus"
                inputType="text"
                handleFormChange={(value, field) => handleApplicationFormChange(value, field, newGuarantor, setNewGuarantor, undefined, undefined, 255)}
              />
            </Grid.Column>
            <Grid.Column width={isGreaterThanMobile ? 6 : 16}>
              <BCFormInput
                labelClass="gmr-background-label"
                type="checkbox"
                checkboxText="Pending Legal Action"
                obj={newGuarantor}
                field="isPendingLegalAction"
                value={newGuarantor.isPendingLegalAction}
                handleFormChange={(value, field) => handleApplicationFormChange(value, field, newGuarantor, setNewGuarantor)}
              />
            </Grid.Column>
            <Grid.Column width={isGreaterThanMobile ? 10 : 16}>
              <BCFormInput
                labelClass="gmr-background-label"
                type="input"
                label="Legal Action Description"
                obj={newGuarantor}
                field="legalActionDescription"
                inputType="text"
                handleFormChange={(value, field) => handleApplicationFormChange(value, field, newGuarantor, setNewGuarantor, undefined, undefined, 1000)}
              />
            </Grid.Column>
            <Grid.Column width={isGreaterThanMobile ? 6 : 16}>
              <BCFormInput
                labelClass="gmr-background-label"
                type="checkbox"
                checkboxText="Is Foreclosure Initiated"
                obj={newGuarantor}
                field="isForeclosureInitiated"
                value={newGuarantor.isForeclosureInitiated}
                handleFormChange={(value, field) => handleApplicationFormChange(value, field, newGuarantor, setNewGuarantor)}
              />
            </Grid.Column>
            <Grid.Column width={isGreaterThanMobile ? 10 : 16}>
              <BCFormInput
                labelClass="gmr-background-label"
                type="input"
                label="Foreclosure Description"
                obj={newGuarantor}
                field="forclosureDescription"
                inputType="text"
                handleFormChange={(value, field) => handleApplicationFormChange(value, field, newGuarantor, setNewGuarantor, undefined, undefined, 1000)}
              />
            </Grid.Column>
            <Grid.Column width={16}>
              <BCFormInput
                labelClass="gmr-background-label"
                type="input"
                label="Any other names in which you've been granted credit?"
                obj={newGuarantor}
                field="otherCreditNames"
                inputType="text"
                handleFormChange={(value, field) => handleApplicationFormChange(value, field, newGuarantor, setNewGuarantor)}
              />
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Form>;
      guarantorModal.actions = <React.Fragment>{handleModalPrevNext("new guarantor", "guarantor wizard assets")}</React.Fragment>;
    }
    else if (type === "guarantor wizard assets") {
      guarantorModal.header = <div>{handleGuarantorModalHeader("New Guarantor", "Assets")}</div>;
      guarantorModal.content = <Form className="primary-form">
        <Grid>
          {handleAlForm("Asset")}
          {/* <button onClick={() => console.log(newGuarantor)}>newGuarantor</button> */}
        </Grid>
      </Form>;
      guarantorModal.actions = <React.Fragment>{handleModalPrevNext("guarantor additional", "guarantor wizard liabilites")}</React.Fragment>;
    }
    else if (type === "guarantor wizard liabilites") {
      guarantorModal.header = <div>{handleGuarantorModalHeader("New Guarantor", "Liabilities")}</div>;
      guarantorModal.content = <Form className="primary-form">
        <Grid>
          {handleAlForm("Liability")}
        </Grid>
      </Form>;
      guarantorModal.actions = <React.Fragment>{handleModalPrevNext("guarantor wizard assets", "guarantor wizard reo")}</React.Fragment>;
    }
    else if (type === "guarantor wizard reo") {
      guarantorModal.header = <div>{handleGuarantorModalHeader("New Guarantor", "REO Schedule")}</div>;
      guarantorModal.content = <Form className="primary-form">
        <Grid>
          {handleReoForm("guarantor reo")}
        </Grid>
      </Form>;
      guarantorModal.actions = <Grid>
        <Grid.Row columns={3}>
          <Grid.Column>
            <Button
              fluid
              onClick={() => handleModal("guarantor wizard liabilites")}
            >
              <div className="gmr-button-container">
                <div className="gmr-button-text">Previous</div>
              </div>
            </Button>
          </Grid.Column>
          <Grid.Column>
            <Button
              fluid
              onClick={() => handleGuarantorModalCancel()}
            >
              <div className="gmr-button-container">
                <div className="gmr-button-text">Cancel</div>
              </div>
            </Button>
          </Grid.Column>
          <Grid.Column>
            <Button
              className="bp-button"
              style={getIsWhiteLabeled() ? setBackgroundColor(brokerColor ? brokerColor : "#000000") : void 0}
              fluid
              onClick={() => handleGuarantorModalSubmit()}
            >
              <div className="gmr-button-container">
                <div className="gmr-button-text">Save Guarantor</div>
              </div>
            </Button>
          </Grid.Column>
        </Grid.Row>
      </Grid>;
    }

    return guarantorModal;
  };

  const buildGuarantorAccordions = (guarantors) => {
    if (guarantors && guarantors.length > 0) {
      guarantors.forEach((guarantor, i) => {
        const newGuarantorContactInformationAccordionGuid = guid();
        const newGuarantorPersonalDetailsAccordionGuid = guid();
        const newGuarantorCreditScoreAccordionGuid = guid();
        const newGuarantorAssetsAccordionGuid = guid();
        const newGuarantorLiabilityAccordionGuid = guid();
        const newGuarantorREOAccordionGuid = guid();
        const newGuarantorDisclosureStatusAccordionGuid = guid();
        guarantorAccordions.push(
          {
            id: newGuarantorContactInformationAccordionGuid,
            guarantorId: guarantor.id,
            name: BPGuarantorAccordions.ContactInformation.name
          }
        );
        
        guarantorAccordions.push(
          {
            id: newGuarantorPersonalDetailsAccordionGuid,
            guarantorId: guarantor.id,
            name: BPGuarantorAccordions.PersonalDetails.name
          }
        );

        guarantorAccordions.push(
          {
            id: newGuarantorCreditScoreAccordionGuid,
            guarantorId: guarantor.id,
            name: BPGuarantorAccordions.CreditScore.name
          }
        );

        guarantorAccordions.push(
          {
            id: newGuarantorAssetsAccordionGuid,
            guarantorId: guarantor.id,
            name: BPGuarantorAccordions.Assets.name
          }
        );

        guarantorAccordions.push(
          {
            id: newGuarantorLiabilityAccordionGuid,
            guarantorId: guarantor.id,
            name: BPGuarantorAccordions.Liabilities.name
          }
        );

        guarantorAccordions.push(
          {
            id: newGuarantorREOAccordionGuid,
            guarantorId: guarantor.id,
            name: BPGuarantorAccordions.ReoSchedules.name
          }
        );

        guarantorAccordions.push(
          {
            id: newGuarantorDisclosureStatusAccordionGuid,
            guarantorId: guarantor.id,
            name: BPGuarantorAccordions.DisclosureStatuses.name
          }
        );
      });

      setGuarantorAccordions([...guarantorAccordions]);
    }
  };

  const convertAlandReo = (obj) => {
    const publishAssetsAndLiabilities = [] as any[];
    if (obj && obj.assetsAndLiabilities) {
      obj.assetsAndLiabilities.forEach(al => {
        let isLiabilityValid = false;
        if ((al.alOption === "Liability" && al.monthlyLiability) || al.alOption === "Asset") {
          isLiabilityValid = true;
        }

        if (al.id && al.alType && al.alOption && al.institutionName && al.currentBalance && isLiabilityValid) {
          const publishAssetOrLiability = {
            id: al.id ? al.id : undefined,
            "alclassName": al.alOption,
            "altypeId": al.alType,
            "institution": al.institutionName,
            "value": al.currentBalance,
            "monthlyLiability": al.monthlyLiability,
            "alstatusId": al.status
          };

          publishAssetsAndLiabilities.push(publishAssetOrLiability);
        }
      });
    }

    const publishReoSchedules = [] as any[];
    if (obj && obj.reoSchedules) {
      obj.reoSchedules.forEach(reoSchedule => {
        if (reoSchedule.id && reoSchedule.reoStatus && reoSchedule.street && reoSchedule.zip && reoSchedule.state && reoSchedule.city && reoSchedule.marketValue && reoSchedule.holder1) {
          const publishReoSchedule = {
            id: reoSchedule.id ? reoSchedule.id : undefined,
            "reotypeId": "14b34581-1e60-4484-9624-a811010d8b88",
            "reostatusId": reoSchedule.reoStatus,
            "amountOwed": reoSchedule.amountOwed,
            "mortgageFree": reoSchedule.isMortgageFree,
            "street": combineAddresses(reoSchedule.street, reoSchedule.addressLine2),
            "zipCode": reoSchedule.zip,
            "stateName": reoSchedule.state,
            "cityName": reoSchedule.city,
            "countyName": reoSchedule.county,
            "marketValue": reoSchedule.marketValue,
            "monthlyTaxInsuranceAndMaintenance": reoSchedule.maintenance,
            "mortgage1AlscheduleName": reoSchedule.alSchedule1,
            "mortgage2ALScheduleName": reoSchedule.alSchedule2,
            "mortgage3ALScheduleName": reoSchedule.alSchedule3,
            "mortgageAmount1": reoSchedule.mortgageAmount1,
            "mortgageAmount2": reoSchedule.mortgageAmount2,
            "mortgageAmount3": reoSchedule.mortgageAmount3,
            "mortgagePayment1": reoSchedule.mortgagePayment1,
            "mortgagePayment2": reoSchedule.mortgagePayment2,
            "mortgagePayment3": reoSchedule.mortgagePayment3,
            "mortgageHolder1": reoSchedule.holder1,
            "mortgageHolder2": reoSchedule.holder2,
            "mortgageHolder3": reoSchedule.holder3,
            "description": reoSchedule.reoScheduleDescription,
            "additionalCollateral": reoSchedule.additionalCollateral
          };

          publishReoSchedules.push(publishReoSchedule);
        }
      });
    }

    return {
      publishAssetsAndLiabilities: publishAssetsAndLiabilities,
      publishReoSchedules: publishReoSchedules
    };
  };

  const convertGuarantor = (guarantor) => {
    const alAndReoObj = convertAlandReo(guarantor) as any;
    const guarantorPhysicalStreet = combineAddresses(guarantor.physicalAddress, guarantor.physicalAddressLine2);
    const guarantorMailingStreet = combineAddresses(guarantor.mailingAddress, guarantor.mailingAddressLine2);
    const publishGuarantor = {
      id: guarantor.id ? guarantor.id : undefined,
      borrowerApplicationId: borrowerApplicationInfo.id,
      firstName: guarantor.firstName,
      lastName: guarantor.lastName,
      email: guarantor.email,
      mobilePhone: guarantor.mobilePhone,
      physicalStreet: guarantorPhysicalStreet,
      physicalZipCode: guarantor.physicalZip,
      physicalCityName: guarantor.physicalCity,
      physicalStateName: guarantor.physicalState,
      physicalCountyName: guarantor.physicalCounty,
      mailingStreet: guarantor.isMailingSameAsPhysical ? guarantorPhysicalStreet : guarantorMailingStreet,
      mailingZipCode: guarantor.isMailingSameAsPhysical ? guarantor.physicalZip : guarantor.mailingZip,
      mailingCityName: guarantor.isMailingSameAsPhysical ? guarantor.physicalCity : guarantor.mailingCity,
      mailingStateName: guarantor.isMailingSameAsPhysical ? guarantor.physicalState : guarantor.mailingState,
      mailingCountyName: guarantor.isMailingSameAsPhysical ? guarantor.physicalCounty : guarantor.mailingCounty,
      positionInCompany: guarantor.position,
      homePhone: guarantor.homePhone,
      officePhone: guarantor.businessPhone,
      officePhoneExtension: guarantor.extension,
      "socialSecurityNumber": guarantor.socialSecurityNumber,
      "creditScore": guarantor.creditScore,
      "estimatedCreditScore": guarantor.estimatedCreditScore,
      "dateOfBirth": guarantor.dateOfBirth,
      "maritalStatusId": guarantor.maritalStatus,
      "spouseName": guarantor.spouseName,
      "selfEmployed": guarantor.isSelfEmployed,
      "employerName": guarantor.employerName,
      "employerPosition": guarantor.position,
      "monthlyIncome": guarantor.netIncome,
      "monthlyRevenue": guarantor.grossRevenue,
      "yearsInIndustry": guarantor.yearsInIndustry,
      "yearsInBusiness": guarantor.yearsInBusiness,
      "yearsInJob": guarantor.yearsInJob,
      "uscitizen": guarantor.isUSCitizen,
      "citizenshipStatus": guarantor.citizenStatus,
      "pendingLegalAction": guarantor.isPendingLegalAction,
      "legalActionDescription": guarantor.legalActionDescription,
      "isForeclosureInitiated": guarantor.isForeclosureInitiated,
      "foreclosureDescription": guarantor.forclosureDescription,
      "otherCreditName": guarantor.otherCreditNames,
      alschedules: alAndReoObj && alAndReoObj.publishAssetsAndLiabilities,
      reoschedules: alAndReoObj && alAndReoObj.publishReoSchedules,
      hasALChanged: guarantor.hasALChanged ? guarantor.hasALChanged : false,
      hasReoChanged: guarantor.hasReoChanged ? guarantor.hasReoChanged : false,
      accessLevelId: guarantor.accessLevelId,
      submittedOn: guarantor.submittedOn
    };

    return publishGuarantor;
  };

  const handleBrokerGuarantorDelete = async (guarantorId) => {
    setIsInteriorCardLoading(true);
    const selectedGuarantor = selectedBrokerGuarantors.find(guarantor => guarantor.id === guarantorId);
    if (selectedGuarantor) {
      const guarantorDeleteObj = {
        borrowerApplicationId: borrowerApplicationInfo.id,
        organizationContactId: selectedGuarantor.id
      };

      setSelectedBrokerGuarantors(selectedBrokerGuarantors.filter(guarantor => guarantor.id !== guarantorId));
      setGuarantorsEditArray(guarantorsEditArray.filter(guarantor => guarantor.id !== guarantorId));
      setGuarantorReviewIndex(0);

      const isGuarantorDeleted = await deleteGuarantorAsync(guarantorDeleteObj);
      if (isGuarantorDeleted) {
        setSelectedBrokerGuarantors(selectedBrokerGuarantors.filter(guarantor => guarantor.id !== guarantorId));
        setGuarantorsEditArray(guarantorsEditArray.filter(guarantor => guarantor.id !== guarantorId));
        setGuarantorReviewIndex(0);
      }
    }

    setIsInteriorCardLoading(false);
  };

  const handleIsChangeInteriorCard = (guarantor = undefined) => {
    if (window.location.pathname.includes("application")) {
      const isRevisionPermission = isHandleInteriorCardEditPersona && !isAdminPersona && borrowerApplicationInfo && borrowerApplicationInfo.statusLookupName === BrokerConstants.BorrowerApplicationStatusLookupName.REVISION;
      const isAdminPermission = isAdminPersona && borrowerApplicationInfo && borrowerApplicationInfo.statusLookupName === BrokerConstants.BorrowerApplicationStatusLookupName.SUBMITTED;
      if (isLoanApplication && (isRevisionPermission || isAdminPermission)) {
        return true;
      }
    }

    return false;
  };

  const handleCommentClick = (index) => { 
    if (loanComments[index]) {
      const isEmailed = loanComments[index].emailToList && loanComments[index].emailToList.length > 0 && loanInfo &&
        loanInfo.entities && loanInfo.entities.length > 0;
      if (isEmailed) {
        const recipients = [] as IRecipientEntity[];
        loanComments[index].emailToList.map(recipient => {
          const foundRecipient = loanInfo.entities.find(x => (x.email === recipient.email && x.title === recipient.title));
          if (foundRecipient) {
            recipients.push(foundRecipient);
          }
          else {
            const foundInternalContact = organizationContacts.find(x => (x.email === recipient.email && x.title === recipient.title));
            if (foundInternalContact) {
              recipients.push(foundInternalContact);
            }
          }
        });

        setSelectedCommentRecipients(recipients);
      }

      setCommentObj({
        id: loanComments[index].id,
        commentCategoryId: handleGetIdFromValue(applicationMetadata.commentCategories, loanComments[index].category),
        commentSubjectId: handleGetIdFromValue(applicationMetadata.commentSubjects, loanComments[index].subject),
        description: loanComments[index].description,
        isShowCommentExternal: loanComments[index].isExternal ? true : undefined,
        isExternal: loanComments[index].isExternal ? true : undefined,
        isSendNotification: isEmailed ? true : undefined
      });

      setCommentBreadcrumb("Comment");
    }
  };

  const handleReturnToComments = () => {
    setCommentBreadcrumb("");
    setCommentObj({ id: guid() });
    setIsCommentFormChanged(false);
    setIsRecipientModalOpen(false);
    setSelectedCommentRecipients([]);
    setIsRecipientSearchOpen(true);
    setRecipientInvalidProps([]);
  };

  const handleTryReturnToComments = () => {
    if (isCommentFormChanged) {
      setIsRecipientModalOpen(true);
    }
    else {
      handleReturnToComments();
    }
  };

  const handleCommentFormChange = (value, field, type = GlobalConstants.InputTypes.STRING, charLimit: number | undefined = undefined) => {
    if (field === "isShowCommentExternal" && !value) {
      commentObj.isExternal = undefined;
    }

    handleFormChange(value, field, commentObj, setCommentObj, type, undefined, charLimit);
    setIsCommentFormChanged(true);
  };

  const handleSubmitLoanComment = async () => {
    setRecipientInvalidProps([]);
    let notValidProps = validateObj(commentObj, [RecipientValidationProps.description]);
    if (!user.isExternalUser) {
      notValidProps = notValidProps.concat(validateObj(commentObj, [
        RecipientValidationProps.commentCategoryId,
        RecipientValidationProps.commentSubjectId
      ]));

      if (commentObj.isShowCommentExternal && commentObj.isExternal === undefined) {
        notValidProps.push(RecipientValidationProps.isExternal);
      }
    }
    else {
      notValidProps = notValidProps.concat(validateObj(commentObj, [RecipientValidationProps.subject]));
    }

    if (commentObj.isSendNotification && selectedCommentRecipients.length === 0) {
      notValidProps.push(RecipientValidationProps.emailToList);
    }

    if (notValidProps.length === 0) {
      if (borrowerApplicationInfo.borrowerOrganizationId) {
        commentObj.loanId = applicationId;
        commentObj.borrowerOrganizationId = borrowerApplicationInfo.borrowerOrganizationId;
        commentObj.isExternal = user.isExternalUser ? true : commentObj.isExternal ? commentObj.isExternal : false;
        commentObj.isEmailed = (commentObj.isSendNotification && selectedCommentRecipients.length > 0) ? true : false;
        if (commentObj.isSendNotification && selectedCommentRecipients.length > 0) {
          commentObj.emailToList = selectedCommentRecipients;
        }

        setIsInteriorCardLoading(true);
        let isApiSuccess = true;
        if (commentBreadcrumb === "Add Comment") {
          isApiSuccess = await submitLoanCommentAsync(commentObj);
        }
        else if (commentBreadcrumb === "Comment") {
          const commentsObj = [commentObj];
          isApiSuccess = await patchLoanCommentsAsync(commentsObj);
        }

        if (isApiSuccess) {
          await getLoanCommentsAsync(applicationId);
          handleReturnToComments();
        }

        setIsInteriorCardLoading(false);
      }
    }
    else {
      setTimeout(() => {
        setRecipientInvalidProps(notValidProps);
      }, 50);
    }
  };

  const formatLoanComments = (loanComments) => {
    const formattedProperties = formatDataProperties(loanComments, [{ action: "remove", field: "emailToList" }]);
    formattedProperties.forEach((formattedProperty, i) => {
      delete formattedProperty["Is Emailed"];
      delete formattedProperty["Is External"];
      if (user.isExternalUser) {
        delete formattedProperty["Category"];
      }
      else {
        formattedProperty["Notified"] = (loanComments[i].emailToList && loanComments[i].emailToList.length > 0) ? "Yes" : "No";
        formattedProperty["External"] = loanComments[i].isExternal ? "Yes" : "No";
      }

      delete formattedProperty["Full Name"];
      delete formattedProperty["Created By"];
      delete formattedProperty["Created On"];
      formattedProperty["Created By"] = loanComments[i].fullName;
      formattedProperty["Created On"] = loanComments[i].createdOn ? convertToDateString(loanComments[i].createdOn, "fulldatetime") : "";
    });

    return formattedProperties;
  };

  const handleCommentRecipientSearchChange = (value, field) => {
    const searchValue = handleInputType(GlobalConstants.InputTypes.STRING, value);
    setInvalidProps([]);
    setCommentRecipientSearch(searchValue);
    setIsRecipientSearchOpen(false);
    if (searchValue !== "" && organizationContacts && organizationContacts.length > 0) {
      const filteredRecipients = organizationContacts.filter(x => ((x.name && ((x.name).toLowerCase().includes(searchValue.toLowerCase()))) ||
        (x.email && (x.email).toLowerCase().includes(searchValue.toLowerCase()))));
      setFilteredCommentRecipients(filteredRecipients);
    }
    else {
      setFilteredCommentRecipients([]);
    }
  };

  const handleCommentRecipientSuggestions = () => {
    const results = [] as any[];
    let resultLimit = 3;
    let recipients = [] as IRecipientEntity[];
    if (commentRecipientSearch !== "") {
      recipients = filteredCommentRecipients;
    }
    else if (commentRecipientSearch === "" && loanInfo && loanInfo.entities) {
      recipients = loanInfo.entities;
    }

    if (recipients && recipients.length > 0) {
      recipients.forEach((entity, i) => {
        const foundRecipientIndex = selectedCommentRecipients.findIndex(x => x.email === entity.email);
        if (resultLimit > 0 && foundRecipientIndex === -1) {
          results.push({
            key: `${entity.id}${i}`,
            title: `${entity.name}${(entity.title && entity.title !== "") ? ` - ${entity.title}` : ""}`,
            description: entity.email,
            value: entity
          });

          resultLimit--;
        }
      });
    }

    return results;
  };

  const handleCommentRecipientSelect = (result) => {
    if (result && result !== "") {
      setInvalidProps([]);
      const foundRecipientIndex = selectedCommentRecipients.findIndex(x => x.id === result.key);
      if (foundRecipientIndex === -1 && result.value) {
        selectedCommentRecipients.push({
          id: result.value.id,
          name: result.value.name,
          email: result.value.email,
          title: result.value.title,
          department: result.value.department
        });

        setSelectedCommentRecipients([...selectedCommentRecipients]);
      }

      setCommentRecipientSearch("");
      setIsRecipientSearchOpen(true);
    }
  };

  const handleCommentRecipientKeyDown = (e) => {
    if (e.keyCode === 27) {
      handleCommentRecipientClear();
    }
  };

  const handleCommentRecipientClear = () => {
    setIsRecipientSearchOpen(true);
    setCommentRecipientSearch("");
  };

  const handleDeleteRecipient = (index) => {
    if (selectedCommentRecipients[index]) {
      selectedCommentRecipients.splice(index, 1);
      setSelectedCommentRecipients([...selectedCommentRecipients]);
    }
  };

  const formatSelectedCommentRecipients = (recipients) => {
    const formattedRecipients = formatDataProperties(recipients);
    formattedRecipients.map((formattedRecipient, i) => {
      if (commentBreadcrumb === "Add Comment") {
        formattedRecipient[""] = <React.Fragment>
          <Button
            className="table-button"
            icon
            color="red"
            inverted
            onClick={() => handleDeleteRecipient(i)}
          >
            <div className="gmr-button-container">
              <Icon name='trash' />
              {isGreaterThanMobile && <div className="table-button-text">Delete</div>}
            </div>
          </Button>
        </React.Fragment>;
      }
    });

    return formattedRecipients;
  };

  const handleGameChangerTabs = () => {
    const tabs = Object.values(BrokerConstants.InteriorCardTabs);
    if (!FeatureFlags.IS_GAME_CHANGERS && !(FeatureFlags.IS_BC_PRICING || loanInfo.isProforma)) {
      tabs.splice(0, 3);
    }
    else if (!FeatureFlags.IS_GAME_CHANGERS) {
      tabs.splice(0, 2);
    }
    else if (!(FeatureFlags.IS_BC_PRICING || loanInfo.isProforma)) {
      // tabs.splice(1, 2); TODO: Put back when milestones returns
      tabs.splice(1, 2); 
    }
    else if (FeatureFlags.IS_GAME_CHANGERS) {
      tabs.splice(1, 1);
    }

    if (pricingInfo && !loanInfo) {
      return tabs.splice(0, 1);
    }
    else if (borrowerApplicationInfo && borrowerApplicationInfo.submittedOn) {
      return tabs;
    }
    
    return tabs.splice(0, 5);
  };

  const handleBrokerGuarantorInviteAsync = async (guarantorInviteObj) => {
    try {
      const response = FeatureFlags.IS_MOCK ? await resendMockGuarantorInvite(guarantorInviteObj) : await resendGuarantorInvite(guarantorInviteObj, proxyUser.id) as any;
      if (response && response.ok) {
        if (response.status === 204) {
          return false;
        }

        return true;
      }
      else {
        await handleErrorResponse(response, setIsMessage, setErrorResponse);
        setIsLoading(false);
      }
    }
    catch (error) {
      setIsMessage(false);
    }

    return false;
  };

  const handleGetGuarantorExistsAsync = async (email) => {
    try {
      const response = FeatureFlags.IS_MOCK ? await getMockGuarantorExists(email) : await getGuarantorExists(email, proxyUser.id) as any;
      if (response && response.ok) {
        setIsMessage(false);
        if (response.status === 204) {
          return undefined;
        }
        else {
          const apiFoundGuarantor = await response.json();
          const foundGuarantorIndex = selectedBrokerGuarantors.findIndex(x => x.email === apiFoundGuarantor.email);
          if (foundGuarantorIndex === -1) {
            selectedBrokerGuarantors.push({
              id: apiFoundGuarantor.id,
              email: apiFoundGuarantor.email,
              firstName: apiFoundGuarantor.firstName,
              lastName: apiFoundGuarantor.lastName,
              accessLevelId: apiFoundGuarantor.accessLevelId,
              status: apiFoundGuarantor.status
            });

            setSelectedBrokerGuarantors([...selectedBrokerGuarantors]);
          }

          return apiFoundGuarantor;
        }
      }
      else {
        await handleErrorResponse(response, setIsMessage, setErrorResponse);
      }
    }
    catch (error) {
      setIsMessage(false);
    }

    return undefined;
  };

  const handlePatchApplicationGuarantor = async () => {
    const borrowerEntities = await getBorrowerEntitiesAsync();
    if (borrowerEntities) {
      await handlePatchEntities(borrowerEntities);
    }
  };

  const handlePatchEntities = (borrowerEntities) => {
    const selectedBrokerGuarantorIds = Array.from(new Set(Array.from(selectedBrokerGuarantors, x => x.id)));
    const entityPatch = selectedBrokerGuarantorIds.map(selectedBrokerGuarantorId => {
      const foundEntity = borrowerEntities.find(x => x.organizationContactId === selectedBrokerGuarantorId);
      const firstFoundSelectedBrokerGuarantor = selectedBrokerGuarantors.find(x => x.id === selectedBrokerGuarantorId);
      return (
        {
          id: foundEntity ? foundEntity.id : guid(),
          borrowerApplicationId: applicationId,
          organizationContactId: selectedBrokerGuarantorId,
          roleOption: "Guarantor",
          confirmationStatus: foundEntity ? foundEntity.confirmationStatus : "BrokerInitiated",
          accessLevelId: firstFoundSelectedBrokerGuarantor.accessLevelId,
          isActive: true
        }
      );
    });

    return patchEntitiesAsync(entityPatch, true);
  };

  const getBorrowerEntitiesAsync = async () => {
    try {
      const response = FeatureFlags.IS_MOCK ? await getMockBorrowerApplicationEntities(applicationId) : await getBorrowerApplicationEntities(applicationId, proxyUser.id) as any;
      if (response && response.ok) {        
        return await response.json();
      }
      else {
        await handleErrorResponse(response, setIsMessage, setErrorResponse);
      }
    }
    catch (error) {
      setIsMessage(false);
    }

    return false;
  };

  const patchEntitiesAsync = async (patchObj, isUpsert) => {
    try {
      const response = FeatureFlags.IS_MOCK ? await patchMockBorrowerApplicationEntities(patchObj, isUpsert) : await patchBorrowerApplicationEntities(patchObj, isUpsert, proxyUser.id) as any;
      if (response && response.ok) {        
        return true;
      }
      else {
        await handleErrorResponse(response, setIsMessage, setErrorResponse);
      }
    }
    catch (error) {
      setIsMessage(false);
    }

    return false;
  };

  const handleUpsertGuarantorAsync = async (newGuarantor) => {
    try {
      if (borrowerApplicationInfo.borrowerOrganizationId) {
        newGuarantor.borrowerOrganizationId = borrowerApplicationInfo.borrowerOrganizationId;
      }
      
      const response = FeatureFlags.IS_MOCK ? await upsertMockGuarantor() : await upsertGuarantor(convertGuarantor(newGuarantor), proxyUser.id);
      if (response && response.ok) {
        const guarantorFull = await response.json();
        return guarantorFull;
      }
      else {
        await handleErrorResponse(response, setIsMessage, setErrorResponse);
      }
    }
    catch (error) {
      setIsMessage(false);
    }

    return false;
  };

  const getBorrowerEntityAsync = async (applicationId, borrowerOrganizationId) => {
    try {
      const response = FeatureFlags.IS_MOCK ? await getMockBorrowerEntity(applicationId, borrowerOrganizationId) : await getBorrowerEntity(applicationId, borrowerOrganizationId, proxyUser.id) as any;
      if (response && response.ok) {
        const borrowerEntity = await response.json();
        setBorrowerPatchObj({ id: borrowerEntity.id });
        setBorrowerInfo(deepCopy({...borrowerEntity}));
        return borrowerEntity;
      }
      else {
        await handleErrorResponse(response, setIsMessage, setErrorResponse);
      }
    }
    catch (error) {
      setIsMessage(false);
    }
  };

  const getGuarantorsAsync = async (applicationId) => {
    try {
      const response = FeatureFlags.IS_MOCK ? await getMockGuarantors(applicationId) : await getGuarantors(applicationId, proxyUser.id) as any;
      if (response && response.ok) {
        const guarantorList = await response.json();
        if (getIsWhiteLabeled() && guarantorList && guarantorList.length > 0) {
          const foundUserIsGuarantor = guarantorList.find(x => x.id === user.organizationContactId);
          if (foundUserIsGuarantor && !foundUserIsGuarantor.disclosureCompletedOn) {
            handleEditApplication(applicationId);
          }
        }
        setGuarantorsInfo(deepCopy(guarantorList));
        setGuarantorsEditArray(deepCopy(guarantorList));
        buildGuarantorAccordions(deepCopy(guarantorList));
      }
      else {
        await handleErrorResponse(response, setIsMessage, setErrorResponse);
      }
    }
    catch (error) {
      setIsMessage(false);
    }
  };

  const getApplicationDocuments = async (loanId) => {
    try {
      const response = FeatureFlags.IS_MOCK ? await getMockLoanDocuments(loanId) : await getLoanDocuments(loanId, proxyUser.id) as any;
      if (response && response.ok) {
        await getApplicationDocumentsMetadata();
        setDocumentsInfolist(await response.json());
      }
      else {
        await handleErrorResponse(response, setIsMessage, setErrorResponse);
      }
    }
    catch (error) {
      setIsMessage(false);
    }
  };

  const getApplicationDocumentsMetadata = async () => {
    try {
      const response = FeatureFlags.IS_MOCK ? await getMockLoanDocumentsMetadata() : await getLoanDocumentsMetadata(proxyUser.id) as any;
      if (response && response.ok) {
        setDocumentMetadata(await response.json());
        setIsLoading(false);
      }
      else {
        await handleErrorResponse(response, setIsMessage, setErrorResponse);
        setIsLoading(false);
      }
    }
    catch (error) {
      setIsMessage(false);
      setIsLoading(false);
    }
  };

  const getPayeezyLoanInvoicesAsync = async (loanId) => {
    try {
      const response = FeatureFlags.IS_MOCK ? await getMockPayeezyLoanInvoices(loanId) : await getPayeezyLoanInvoices(loanId, proxyUser.id) as any;
      if (response && response.ok) {
        const loanInvoices = await response.json();
        setPayeezyLoanInvoices(loanInvoices);
      }
      else {
        await handleErrorResponse(response, setIsMessage, setErrorResponse);
      }
    }
    catch (error) {
      setIsMessage(false);
    }
  };

  const createLoanDocumentAsync = async (documentFile, documentObj) => {
    try {
      const response = FeatureFlags.IS_MOCK ? await createMockLoanDocument(documentFile, documentObj) : await createLoanDocument(documentFile, documentObj, proxyUser.id) as any;
      if (response && response.ok) {
        const documentInfo = {
          "id": documentObj.id,
          "organizationContactId": "",
          "display": documentFile.name,
          "documentMasterId": documentObj.documentMasterId,
          "createdOn": new Date().toLocaleDateString(),
          "updatedOn": new Date().toLocaleDateString(),
          "createdBy": user.email,
          "description": documentObj.description,
          "loanId": loanInfo.id,
          "metadata": ""
        } as ILoanDocumentInfo;

        documentsInfolist?.push(documentInfo);
        setDocumentsInfolist(documentsInfolist);
        handleResetStageUpload();
        setIsInteriorCardLoading(false);
      }
      else {
        await handleErrorResponse(response, setIsMessage, setErrorResponse);
        setIsInteriorCardLoading(false);
      }
    }
    catch (error) {
      setIsMessage(false);
      setIsInteriorCardLoading(false);
    }
  };

  const getLoanDocumentAsync = async (documentId, isDownload = false) => {
    try {
      const response = FeatureFlags.IS_MOCK ? await downloadMockLoanDocument(documentId) : await downloadLoanDocument(documentId, proxyUser.id) as any;
      if (response && response.ok) {
        setIsMessage(false);
        const data = await response.blob();
        const downloadedFile = await createFile(data, documentId, data.type);
        if (isDownload) {
          setDocumentDownloadUrl(URL.createObjectURL(downloadedFile));
          if (documentDownloadRef.current) {
            documentDownloadRef.current.click();
          }
        }

        if (isDownload === false) {
          if (data.type === "image/jpeg" || data.type === "image/png") {
            return downloadedFile;
          }
        }

        setIsInteriorCardLoading(false);
      }
      else {
        await handleErrorResponse(response, setIsMessage, setErrorResponse);
        setIsInteriorCardLoading(false);
      }
    }
    catch (error) {
      setIsMessage(false);
      setIsInteriorCardLoading(false);
    }
  };

  const updateLoanDocumentAsync = async (documentObj) => {
    try {
      const response = FeatureFlags.IS_MOCK ? await updateMockLoanDocument(documentObj) : await updateLoanDocument(documentObj, proxyUser.id) as any;
      if (response && response.ok) {
        const foundDocumentInfoIndex = documentsInfolist?.findIndex(x => x.id === documentObj.id);
        if ((foundDocumentInfoIndex === 0 || foundDocumentInfoIndex) && foundDocumentInfoIndex !== -1 && documentsInfolist) {
          documentsInfolist[foundDocumentInfoIndex].documentMasterId = documentObj.documentMasterId;
          documentsInfolist[foundDocumentInfoIndex].updatedOn = new Date().toLocaleDateString();
          documentsInfolist[foundDocumentInfoIndex].createdBy = user.email;
          documentsInfolist[foundDocumentInfoIndex].description = documentObj.description;
          setDocumentsInfolist([...documentsInfolist]);
        }

        setIsInteriorCardLoading(false);
        setDocumentModalObject({});
        handleDocumentModalClose();
      }
      else {
        await handleErrorResponse(response, setIsMessage, setErrorResponse);
        setIsInteriorCardLoading(false);
      }
    }
    catch (error) {
      setIsMessage(false);
      setIsInteriorCardLoading(false);
    }
  };

  const deleteLoanDocumentAsync = async (documentId) => {
    try {
      const response = FeatureFlags.IS_MOCK ? await deleteMockLoanDocument(documentId) : await deleteLoanDocument(documentId, proxyUser.id) as any;
      if (response && response.ok) {
        const foundDocumentInfoIndex = documentsInfolist?.findIndex(x => x.id === documentId);
        if ((foundDocumentInfoIndex || foundDocumentInfoIndex === 0) && documentsInfolist) {
          documentsInfolist.splice(foundDocumentInfoIndex, 1);
          setDocumentsInfolist([...documentsInfolist]);
        }
      }
      else {
        await handleErrorResponse(response, setIsMessage, setErrorResponse);
        setIsInteriorCardLoading(false);
      }
    }
    catch (error) {
      setIsMessage(false);
      setIsInteriorCardLoading(false);
    }
  };

  const deleteGuarantorAsync = async (guarantorDeleteObj) => {
    try {
      const response = FeatureFlags.IS_MOCK ? await deleteMockGuarantor(guarantorDeleteObj) : await deleteGuarantor(guarantorDeleteObj, proxyUser.id);
      if (response && response.ok) {
        const foundGuarantorIndex = guarantorsInfo?.findIndex(x => x.id === guarantorDeleteObj.organizationContactId) as number;
        if (foundGuarantorIndex !== -1) {
          guarantorsInfo?.splice(foundGuarantorIndex, 1);
          if (guarantorsInfo) {
            setGuarantorsInfo([...guarantorsInfo]);
          }
        }

        return true;
      }
      else {
        await handleErrorResponse(response, setIsMessage, setErrorResponse);
      }

      setIsInteriorCardLoading(false);
      return false;
    }
    catch (error) {
      setIsMessage(false);
      handleError();
    }
  };

  const formatGmrSummaryResponse = (gmrSummary) => {
    if (gmrSummary.gmrUnitDrawMonths && gmrSummary.gmrUnitDrawMonths.length > 1) {
      gmrSummary.gmrUnitDrawMonths.sort((a, b) => {
        return a.unitNo - b.unitNo;
      });
    }

    gmrSummary.interestRate = gmrSummary.interestRate ? gmrSummary.interestRate * 100 : undefined;
    gmrSummary.originationFeeRate = gmrSummary.originationFeeRate ? gmrSummary.originationFeeRate * 100 : undefined;
    gmrSummary.estimatedClosingDate = gmrSummary.estimatedClosingDate ? convertToDateString(new Date(gmrSummary.estimatedClosingDate)) : undefined;
    gmrSummary.estimatedMaturityDate = gmrSummary.estimatedMaturityDate ? convertToDateString(new Date(gmrSummary.estimatedMaturityDate)) : undefined;
    gmrSummary.ltv = gmrSummary.ltv ? gmrSummary.ltv * 100 : undefined;
    gmrSummary.ltc = gmrSummary.ltc ? gmrSummary.ltc * 100 : undefined;
    if (FeatureFlags.IS_BROKER_FEE_ALLIANCE) {
      gmrSummary.brokerFeeRate = gmrSummary.brokerFeeRate ? roundNumber(gmrSummary.brokerFeeRate) : undefined;
      gmrSummary.wlbrokerFeeRate = gmrSummary.wlbrokerFeeRate ? roundNumber(gmrSummary.wlbrokerFeeRate) : undefined;
    }
    else {
      if (gmrSummary?.wlbrokerFeeRate > 0) {
        let displayBrokerFeeRate = gmrSummary.wlbrokerFeeRate;
        if (gmrSummary?.brokerFeeRate > 0) {
          displayBrokerFeeRate = displayBrokerFeeRate + gmrSummary.brokerFeeRate;
        }

        gmrSummary.brokerFeeRate = displayBrokerFeeRate;
        gmrSummary.isCombineOriginationFee = true;
      } 
      else if (gmrSummary?.wlbrokerFeeRate || gmrSummary?.brokerFeeRate) {
        gmrSummary.brokerFeeRate = gmrSummary.brokerFeeRate ? roundNumber(gmrSummary.brokerFeeRate) : undefined;
        gmrSummary.wlbrokerFeeRate = 0;
        gmrSummary.isCombineOriginationFee = false;
      }
    }

    return gmrSummary;
  };

  const getGmrSummaryAsync = async (gmrId) => {
    try {
      const response = FeatureFlags.IS_MOCK ? await getMockGMRSummary(gmrId) : await getGMRSummary(gmrId, proxyUser.id);
      if (response && response.ok) {
        const gmrSummaryResponse = await response.json();
        setPricingInfo(formatGmrSummaryResponse(gmrSummaryResponse));
        setIsMessage(false);
      }
      else {
        await handleErrorResponse(response, setIsMessage, setErrorResponse);
      }
    }
    catch (error) {
      setIsMessage(false);
      handleError();
    }
  };

  const getBorrowerApplicationInfoAsync = async (id) => {
    try {
      const response = FeatureFlags.IS_MOCK ? await getMockApplicationInfo(id) : await getBorrowerApplicationInfo(id, proxyUser.id);
      if (response && response.ok) {
        const applicationInfoData = await response.json();
        setBorrowerApplicationInfo(applicationInfoData);
        if (applicationInfoData.applicationGmrId) {
          await getGmrSummaryAsync(applicationInfoData.applicationGmrId);
        }

        setIsMessage(false);
      }
      else {
        await handleErrorResponse(response, setIsMessage, setErrorResponse);
      }
    }
    catch (error) {
      setIsMessage(false);
      handleError();
    }
  };

  const getBorrowerApplicationBuilderAsync = async (builderId) => {
    try {
      const response = FeatureFlags.IS_MOCK ? await getMockBrokerBuilder(builderId) : await getBrokerBuilder(builderId, proxyUser.id);
      if (response && response.ok) {
        const builderInfoData = await response.json();
        setBorrowerApplicationBuilderInfo(builderInfoData);

        setIsMessage(false);
      }
      else {
        await handleErrorResponse(response, setIsMessage, setErrorResponse);
      }
    }
    catch (error) {
      setIsMessage(false);
      handleError();
    }
  };

  const getLoanInfoAsync = async (id) => {
    try {
      const response = FeatureFlags.IS_MOCK ? await getMockLoanInfo(id) : await getLoanInfo(id, proxyUser.id);
      if (response && response.ok) {
        const loanInfoData = await response.json();
        setIsLoanApplication(true);
        setLoanInfo(loanInfoData);
        if (loanInfoData.loanProperties) {
          setInitialLoanProperties(deepCopy(loanInfoData.loanProperties));
          setLoanProperties(deepCopy(loanInfoData.loanProperties));
        }
        
        setIsMessage(false);
      }
      else {
        await handleErrorResponse(response, setIsMessage, setErrorResponse);
      }
    }
    catch (error) {
      setIsMessage(false);
      handleError();
    }
  };

  const sendApplicationToPrescreenerAsync = async () => {
    try {
      const response = FeatureFlags.IS_MOCK ? await sendMockApplicationToPrescreener(applicationId) : await sendApplicationToPrescreener(applicationId, proxyUser.id);
      if (response && response.ok) {
        setInteriorCardSuccessMessage("Application has been sent for prescreening.");
        setTimeout(() => {
          setInteriorCardSuccessMessage("");
        }, 5000);
        setIsMessage(false);
      }
      else {
        await handleErrorResponse(response, setIsMessage, setErrorResponse);
      }
    }
    catch (error) {
      setIsMessage(false);
      handleError();
    }
  };

  const requestApplicationRevisionAsync = async () => {
    try {
      const response = FeatureFlags.IS_MOCK ? await requestMockApplicationRevision(applicationId, revisionObject) : await requestApplicationRevision(applicationId, revisionObject, proxyUser.id);
      if (response && response.ok) {
        setInteriorCardSuccessMessage("An revision has been requested for the application.");
        setTimeout(() => {
          setInteriorCardSuccessMessage("");
        }, 5000);
        setIsMessage(false);
        setIsModalOpen(false);
        setRevisionObject({});
      }
      else {
        await handleErrorResponse(response, setIsMessage, setErrorResponse);
      }
    }
    catch (error) {
      setIsMessage(false);
      handleError();
    }
  };

  const submitForReviewAsync = async () => {
    try {
      const response = FeatureFlags.IS_MOCK ? await submitMockApplicationForReview(applicationId) : await submitApplicationForReview(applicationId, proxyUser.id) as any;
      if (response && response.ok) {
        setInteriorCardSuccessMessage("The application has been submitted for review.");
        setTimeout(() => {
          setInteriorCardSuccessMessage("");
        }, 5000);
        setIsMessage(false);
        return true;
      }
      else {
        await handleErrorResponse(response, setIsMessage, setErrorResponse);
      }
    }
    catch (error) {
      setIsMessage(false);
      handleError();
    }

    return false;
  };

  const getPayeezyPaymentPageAsync = async (invoiceId) => {
    try {
      const response = FeatureFlags.IS_MOCK ? await getMockPayeezyPaymentPage(invoiceId) : await getPayeezyPaymentPage(invoiceId, proxyUser.id) as any;
      if (response && response.ok) {
        const paymentPageObj = await response.json();
        paymentPageObj.invoiceId = invoiceId;
        setPayeezyObject(paymentPageObj);
        return true;
      }
      else {
        await handleErrorResponse(response, setIsMessage, setErrorResponse);
      }
    }
    catch (error) {
      setIsMessage(false);
      handleError();
    }

    return false;
  };

  const downloadPayeezyInvoiceAsync = async (invoiceId) => {
    try {
      const response = FeatureFlags.IS_MOCK ? await downloadMockPayeezyInvoice(invoiceId) : await downloadPayeezyInvoice(invoiceId, proxyUser.id) as any;
      if (response && response.ok) {
        const data = await response.blob();
        const payeezyInvoiceFile = await createFile(data, "payeezy-invoice", data.type);
        setPayeezyFileUrl(URL.createObjectURL(payeezyInvoiceFile));
        if (payeezyFileRef.current) {
          payeezyFileRef.current.click();
        }
      }
      else {
        await handleErrorResponse(response, setIsMessage, setErrorResponse);
      }
    }
    catch (error) {
      setIsMessage(false);
      handleError();
    }

    return false;
  };

  const submitLoanCommentAsync = async (loanCommentObj) => {
    try {
      const response = FeatureFlags.IS_MOCK ? await createMockLoanComment(loanCommentObj) : await createLoanComment(loanCommentObj, proxyUser.id) as any;
      if (response && response.ok) {
        setLoanCommentSubmissionType("create");
        return true;
      }
      else {
        await handleErrorResponse(response, setIsMessage, setErrorResponse);
      }
    }
    catch (error) {
      setIsMessage(false);
      handleError();
    }

    return false;
  };

  const patchLoanCommentsAsync = async (loanCommentObj) => {
    try {
      const response = FeatureFlags.IS_MOCK ? await patchMockLoanComments(loanCommentObj) : await patchLoanComments(loanCommentObj, proxyUser.id) as any;
      if (response && response.ok) {
        setLoanCommentSubmissionType("edit");
        return true;
      }
      else {
        await handleErrorResponse(response, setIsMessage, setErrorResponse);
      }
    }
    catch (error) {
      setIsMessage(false);
      handleError();
    }

    return false;
  };

  const getLoanCommentsAsync = async (applicationId) => {
    try {
      const response = FeatureFlags.IS_MOCK ? await getMockLoanComments(applicationId) : await getLoanComments(applicationId, proxyUser.id);
      if (response && response.ok) {
        const loanComments = await response.json();
        setLoanComments(loanComments);
      }
      else {
        await handleErrorResponse(response, setIsMessage, setErrorResponse);
      }
    }
    catch (error) {
      setIsMessage(false);
    }
  };

  useEffect(() => {
    const getGmrMetadataAsync = async () => {
      try {
        const response = FeatureFlags.IS_MOCK ? await getMockGMRMetadata() : await getGMRMetadata(proxyUser.id);
        if (response && response.ok) {
          setGmrMetadata(await response.json());
        }
        else {
          setIsMessage(true);
        }
      }
      catch (error) {
        handleError();
      }
    };

    const getGmrScenariosAsync = async (scenariosNameIds) => {
      try {
        const response = FeatureFlags.IS_MOCK ? await getMockGmrScenarios(scenariosNameIds) : await getGmrScenarios(scenariosNameIds, proxyUser.id);
        if (response && response.ok) {
          const scenarioResponses = await response.json();
          scenarioResponses.sort((a, b) => {
            return a.sortOrder - b.sortOrder;
          });

          const gmrScenarios = [] as any[];
          let scenarioLimit = 2;
          scenarioResponses.forEach(scenarioResponse => {
            if (scenarioLimit > 0) {
              gmrScenarios.push(formatGmrSummaryResponse(scenarioResponse));
              scenarioLimit--;
            }
          });

          return gmrScenarios;
        }
        else {
          await handleErrorResponse(response, setIsMessage, setErrorResponse);
        }
      }
      catch (error) {
        handleError();
      }

      return [];
    };

    const getGmrSummaryAsync = async (gmrId) => {
      try {
        const response = FeatureFlags.IS_MOCK ? await getMockGMRSummary(gmrId) : await getGMRSummary(gmrId, proxyUser.id);
        if (response && response.ok) {
          const gmrSummaryObject = await response.json();
          setPricingInfo(formatGmrSummaryResponse(gmrSummaryObject));
          let gmrScenarioResponses = [] as any[];
          const gmrScenarios = gmrSummaryObject.scenarios.filter(x => x.gmrId !== gmrId);
          if (gmrScenarios.length > 0) {
            const gmrScenarioIdPairs = [] as any[];
            let scenarioLimit = 2;
            gmrScenarios.forEach(gmrScenario => {
              if (scenarioLimit > 0 && gmrScenario.id !== gmrSummaryObject.id) {
                gmrScenarios.sort((a, b) => {
                  return a.sortOrder - b.sortOrder;
                });

                gmrScenarioIdPairs.push({
                  id: gmrScenario.id,
                  name: gmrScenario.name
                });

                scenarioLimit--;
              }
            });

            gmrScenarioResponses = await getGmrScenariosAsync(gmrScenarioIdPairs);
          }

          setIsMessage(false);
          setGmrScenarios(gmrScenarioResponses);
        }
        else {
          await handleErrorResponse(response, setIsMessage, setErrorResponse);
        }
      }
      catch (error) {
        setIsMessage(false);
        handleError();
      }
    };

    const getApplicationDocumentsMetadata = async () => {
      try {
        const response = FeatureFlags.IS_MOCK ? await getMockLoanDocumentsMetadata() : await getLoanDocumentsMetadata(proxyUser.id) as any;
        if (response && response.ok) {
          setDocumentMetadata(await response.json());
          setIsLoading(false);
        }
        else {
          await handleErrorResponse(response, setIsMessage, setErrorResponse);
          setIsLoading(false);
        }
      }
      catch (error) {
        setIsMessage(false);
        setIsLoading(false);
      }
    };

    const getApplicationDocuments = async (loanId) => {
      try {
        const response = FeatureFlags.IS_MOCK ? await getMockLoanDocuments(loanId) : await getLoanDocuments(loanId, proxyUser.id) as any;
        if (response && response.ok) {
          await getApplicationDocumentsMetadata();
          setDocumentsInfolist(await response.json());
        }
        else {
          await handleErrorResponse(response, setIsMessage, setErrorResponse);
        }
      }
      catch (error) {
        setIsMessage(false);
      }
    };

    const getPayeezyLoanInvoicesAsync = async (loanId) => {
      try {
        const response = FeatureFlags.IS_MOCK ? await getMockPayeezyLoanInvoices(loanId) : await getPayeezyLoanInvoices(loanId, proxyUser.id) as any;
        if (response && response.ok) {
          const loanInvoices = await response.json();
          setPayeezyLoanInvoices(loanInvoices);
        }
        else {
          await handleErrorResponse(response, setIsMessage, setErrorResponse);
        }
      }
      catch (error) {
        setIsMessage(false);
      }
    };

    const handleGetBrokerGuarantorsAsync = async (borrowerOrganizationId, applicationId) => {
      try {
        const response = FeatureFlags.IS_MOCK ? await getMockBrokerGuarantors(borrowerOrganizationId, applicationId) : await getBrokerGuarantors(borrowerOrganizationId, applicationId, proxyUser.id);
        if (response && response.ok) {
          setIsMessage(false);
          const apiBrokerGuarantors = await response.json();
          setBrokerGuarantors(apiBrokerGuarantors);
          setIsBrokerGuarantorsLoading(false);
        }
        else {
          await handleErrorResponse(response, setIsMessage, setErrorResponse);
        }
      }
      catch (error) {
        setIsMessage(false);
      }
    };

    const getBorrowerApplicationInfoAsync = async (id, interiorTab) => {
      try {
        const response = FeatureFlags.IS_MOCK ? await getMockApplicationInfo(id) : await getBorrowerApplicationInfo(id, proxyUser.id);
        if (response && response.ok) {
          const applicationInfoData = await response.json();
          if (interiorTab) {
            setIsInteriorCardLoading(true);
            if (interiorTab === BrokerConstants.InteriorCardTabs.Borrower.name && applicationInfoData && applicationInfoData.borrowerOrganizationId) {
              await getBorrowerEntityAsync(applicationInfoData.id, applicationInfoData.borrowerOrganizationId);
              setIsBorrowerLoaded(true);
            }
            else if (interiorTab.name === BrokerConstants.InteriorCardTabs.Guarantors.name && applicationInfoData && applicationInfoData.id) {
              // TODO: Put back after refactor
              // await getBorrowerEntityAsync(applicationInfoData.id, applicationInfoData.borrowerOrganizationId);
              // await getGuarantorsAsync(applicationInfoData.id);
              setIsBorrowerLoaded(true);
              setIsGuarantorsLoaded(true);
            }
            else if (interiorTab.name === BrokerConstants.InteriorCardTabs.Documents.name && applicationInfoData && applicationInfoData.id) {
              await getApplicationDocuments(applicationInfoData.id);
              setIsDocumentsLoaded(true);
            }
            else if (interiorTab.name === BrokerConstants.InteriorCardTabs.Payments.name && applicationInfoData && applicationInfoData.id) {
              await getBorrowerEntityAsync(applicationInfoData.id, applicationInfoData.borrowerOrganizationId);
              await getPayeezyLoanInvoicesAsync(applicationInfoData.id);
              setIsBorrowerLoaded(true);
              setIsPayeezyLoaded(true);
            }

            // TODO: Remove during refactor
            await getBorrowerEntityAsync(applicationInfoData.id, applicationInfoData.borrowerOrganizationId);
            await getGuarantorsAsync(applicationInfoData.id);
            setIsBorrowerLoaded(true);
            setIsGuarantorsLoaded(true);
          }

          setBorrowerApplicationInfo(applicationInfoData);
          if (applicationInfoData && applicationInfoData.applicationGmrId) {
            await getGmrSummaryAsync(applicationInfoData.applicationGmrId);
          }

          if (applicationInfoData && applicationInfoData.borrowerApplicationProperties) {
            setBorrowerApplicationProperties([...applicationInfoData.borrowerApplicationProperties]);
          }

          if (applicationInfoData && applicationInfoData.borrowerOrganizationId) {
            await handleGetBrokerGuarantorsAsync(applicationInfoData.borrowerOrganizationId, applicationId);
          }

          if (applicationInfoData && applicationInfoData.builderOrganizationId) {
            await getBorrowerApplicationBuilderAsync(applicationInfoData.builderOrganizationId);
          }
          else if (applicationInfoData && applicationInfoData.borrowerOrganizationId) {
            await getBorrowerApplicationBuilderAsync(applicationInfoData.borrowerOrganizationId);
          }

          if (applicationInfoData.guarantors) {
            const selectedGuarantors = [] as any[];
            applicationInfoData.guarantors.forEach((guarantor) => {
              selectedGuarantors.push({
                id: guarantor.id,
                firstName: guarantor.firstName,
                lastName: guarantor.lastName,
                email: guarantor.email,
                accessLevelId: guarantor.accessLevelId,
                status: guarantor.status
              });
            });

            setSelectedBrokerGuarantors(selectedGuarantors);
          }

          setIsInteriorCardLoading(false);
          setIsMessage(false);
        }
        else {
          await handleErrorResponse(response, setIsMessage, setErrorResponse);
        }
      }
      catch (error) {
        setIsMessage(false);
        handleError();
      }
    };

    const getApplicationMetadataAsync = async () => {
      try {
        const response = FeatureFlags.IS_MOCK ? await getMockApplicationMetadata() : await getApplicationMetadata(proxyUser.id);
        if (response && response.ok) {
          const applicationMetdata = await response.json();
          setApplicationMetadata(applicationMetdata);
        }
        else {
          await handleErrorResponse(response, setIsMessage, setErrorResponse);
        }
      }
      catch (error) {
        setIsMessage(false);
      }
    };

    const getLoanCommentsAsync = async (applicationId) => {
      try {
        const response = FeatureFlags.IS_MOCK ? await getMockLoanComments(applicationId) : await getLoanComments(applicationId, proxyUser.id);
        if (response && response.ok) {
          const loanComments = await response.json();
          setLoanComments(loanComments);
        }
        else {
          await handleErrorResponse(response, setIsMessage, setErrorResponse);
        }
      }
      catch (error) {
        setIsMessage(false);
      }
    };

    const getInternalContactsAsync = async () => {
      try {
        const response = FeatureFlags.IS_MOCK ? await getMockInternalContacts() : await getInternalContacts(proxyUser.id);
        if (response && response.ok) {
          const contactDirectory = await response.json();
          setOrganizationContacts(contactDirectory);
        }
        else {
          await handleErrorResponse(response, setIsMessage, setErrorResponse);
        }
      }
      catch (error) {
        setIsMessage(false);
      }
    };

    const getAllDetailsAsync = async (applicationId, interiorTab) => {
      try {
        await getApplicationMetadataAsync();
        await getGmrMetadataAsync();
        await getBorrowerApplicationInfoAsync(applicationId, interiorTab);
        await getLoanInfoAsync(applicationId);
        await getLoanCommentsAsync(applicationId);
        await getInternalContactsAsync();
        setIsLoading(false);
      }
      catch (error) {
        setIsLoading(false);
      }
    };

    const getPricingDetailsAsync = async (gmrId) => {
      await getGmrSummaryAsync(gmrId);
      setIsLoading(false);
    };

    const setAuthTokenAsync = async () => {
      const authTokenResponse = await getAuthToken();
      setAuthToken(authTokenResponse);
    };

    if (applicationId && window.location && window.location.pathname) {
      const windowPathname = window.location.pathname.toLocaleLowerCase();
      if (isPricing) {
        getPricingDetailsAsync(borrowerApplicationInfo.applicationGmrId);
        setIsGmrInteriorCardView(true);
      }
      else {
        setAuthTokenAsync();
        const foundInteriorTab = Object.values(BrokerConstants.InteriorCardTabs).find(x => windowPathname.includes(x.name.toLocaleLowerCase()));
        if (foundInteriorTab) {
          setActiveTab(foundInteriorTab.name.toLocaleUpperCase());
        }

        getAllDetailsAsync(applicationId, foundInteriorTab);
      }
    }
    else {
      setIsLoading(false);
    }
  }, [setIsMessage, setErrorResponse, handleError, proxyUser, applicationId, isPricing]);

  const AccordionProps = {
    loanInfo,
    applicationMetadata,
    pricingInfo,
    isGreaterThanMobile,
    activeAccordions,
    handleActiveAccordions,
    handleFormChange,
    handleEditApplication,
    brokerButtonOverrideCSS,
    setLoanProperties,
    isLoanApplication,
    borrowerApplicationInfo
  };

  const LoaderLayout = [
    [
      {
        size: 16,
        content: <Loader active inline="centered" size={"big"} />
      }
    ]
  ];

  const handleGeneratePricingCards = () => {
    const pricingCards = [
      [
        {
          title: BrokerConstants.InteriorCardTabs.Pricing.name,
          size: isPricing ? 16 : 11,
          content: <React.Fragment>
            <Form className="primary-form" autoComplete="off">
              {window.location.pathname.includes("pricing") && <Button
                className={getIsWhiteLabeled() ? `details-button ${brokerButtonOverrideCSS}` : "bp-button details-button"}
                icon
                basic
                onClick={() => handleExportOnClick()}
              >
                <div className="gmr-button-container">
                  <Icon name='share square' size="large" />
                  <div className="gmr-button-icon-text">Export Quote</div>
                </div>
              </Button>}
              {(pricingInfo && !isGmrInteriorCardView && window.location.pathname.includes("pricing")) ? <React.Fragment>
                {false && <React.Fragment>
                  <Button
                    className={getIsWhiteLabeled() ? `details-button ${brokerButtonOverrideCSS}` : "bp-button details-button"}
                    icon
                    basic
                    onClick={() => handleEditMode(setIsEditMode)}
                    disabled={isEditMode}
                  >
                    <div className="gmr-button-container">
                      <Icon name='edit' size="large" />
                      <div className="gmr-button-icon-text">Edit Pricing</div>
                    </div>
                  </Button>
                  <Button
                    className={getIsWhiteLabeled() ? `details-button ${brokerButtonOverrideCSS}` : "bp-button details-button"}
                    icon
                    basic
                    floated='right'
                    onClick={() => handleSavePricingChanges()}
                    disabled={!isEditMode}
                  >
                    <div className="gmr-button-container">
                      <Icon name='save outline' size="large" />
                      <div className="gmr-button-icon-text">Save Changes</div>
                    </div>
                  </Button>
                  <Button
                    className={getIsWhiteLabeled() ? `details-button ${brokerButtonOverrideCSS}` : "bp-button details-button"}
                    icon
                    basic
                    floated='right'
                    onClick={() => handleDiscardChanges({}, setPricingEditObject, setIsEditMode)}
                    disabled={!isEditMode}
                  >
                    <div className="gmr-button-container">
                      <Icon name='edit' size="large" />
                      <div className="gmr-button-icon-text">Discard Changes</div>
                    </div>
                  </Button>
                </React.Fragment>}
                <ApplicationDetailSection
                  title={BPApplicationAccordions.PricingLoanSummary.name}
                  accordionId={BPApplicationAccordions.PricingLoanSummary.id}
                  accordionObject={pricingEditObject}
                  isEditMode={isEditMode}
                  setAccordionObject={setPricingEditObject}
                  {...AccordionProps}
                  inputs={[
                    {
                      value: pricingInfo.loanCommitment,
                      label: "Total Loan Commitment:",
                      size: 8,
                      unitType: "$",
                      field: "loanCommitment"
                    },
                    {
                      value: pricingInfo.requestedLoanTermInMonths,
                      label: "Loan Term:",
                      size: 8,
                      unitType: (pricingInfo.requestedLoanTermInMonths && pricingInfo.requestedLoanTermInMonths > 1) ? "Months" : "Month",
                      field: "requestedLoanTermInMonths",
                      inputType: GlobalConstants.InputTypes.INT
                    },
                    {
                      value: pricingInfo.cashDown,
                      label: "Requested Down Payment:",
                      size: 8,
                      unitType: "$",
                      field: "cashDown"
                    },
                    {
                      value: loanInfo ? convertToDateString(loanInfo.requestedClosingDate) : null,
                      label: "Estimated Closing Date:",
                      size: 8
                    },
                    {
                      value: pricingInfo.wipatClosing,
                      label: "WIP at Closing:",
                      size: 8,
                      unitType: "$"
                    },
                    {
                      value: loanInfo ? handleEstimatedMaturityDate(loanInfo.requestedClosingDate, pricingInfo.requestedLoanTermInMonths) : null,
                      label: "Estimated Maturity Date:",
                      size: 8,
                      readonly: true
                    },
                    {
                      value: pricingInfo.requiredCashDown,
                      label: "Cash Required to Close:",
                      size: 8,
                      unitType: "$"
                    },
                    {
                      value: convertToMinFraction(pricingInfo.ltv, 3, 3),
                      label: "LTV:",
                      size: 8,
                      unitType: "%"
                    },
                    {
                      value: convertToMinFraction(pricingInfo.ltc, 3, 3),
                      label: "LTC:",
                      size: 8,
                      unitType: "%"
                    }
                  ]}
                />
                <ApplicationDetailSection
                  title={BPApplicationAccordions.PricingLoanDetails.name}
                  accordionId={BPApplicationAccordions.PricingLoanDetails.id}
                  accordionObject={pricingInfo}
                  isEditMode={isEditMode}
                  setAccordionObject={setPricingInfo}
                  {...AccordionProps}
                  inputs={[
                    {
                      value: "Principal",
                      label: "Interest Charged On:",
                      size: 8
                    },
                    {
                      value: pricingInfo.processingFee,
                      label: "Processing:",
                      size: 8,
                      unitType: "$"
                    },
                    {
                      value: pricingInfo.interestRate,
                      label: "Interest Rate:",
                      size: 8,
                      unitType: "%",
                      field: "interestRate"
                    },
                    {
                      value: pricingInfo.estimatedTitleAndEscrowFee,
                      label: "Est. Title and Escrow:",
                      size: 8,
                      unitType: "$"
                    },
                    {
                      value: pricingInfo.appraisalFee,
                      label: "Appraisal:",
                      size: 8,
                      unitType: "$"
                    },
                    {
                      value: pricingInfo.floodFee,
                      label: "Flood Certificate:",
                      size: 8,
                      unitType: "$"
                    },
                    {
                      value: pricingInfo.interestReserveCurrent,
                      label: "Interest Reserve:",
                      size: 8,
                      unitType: "$"
                    },
                    {
                      value: pricingInfo.creditReportFee,
                      label: "Credit Report:",
                      size: 8,
                      unitType: "$"
                    },
                    {
                      value: pricingInfo.numberOfExtensions,
                      label: "Number of Extensions:",
                      size: 8
                    },
                    {
                      value: pricingInfo.propertyBudgetSetupFee,
                      label: "Property Budget Setup Fee:",
                      size: 8,
                      unitType: "$"
                    },
                    {
                      value: convertToPercent(pricingInfo.extensionRateChangePercentage),
                      label: "Extension Rate Bump:",
                      size: 8,
                      unitType: "%"
                    },
                    {
                      value: pricingInfo.legalFee,
                      label: "Legal:",
                      size: 8,
                      unitType: "$"
                    },
                    {
                      value: pricingInfo.extensionDays,
                      label: "Days of Each Extension:",
                      size: 8,
                      unitType: (pricingInfo.extensionDays && pricingInfo.extensionDays > 1) ? "Days" : "Day"
                    },
                    {
                      value: pricingInfo.drawAdministrationFee,
                      label: "Draw Administration:",
                      size: 8,
                      unitType: "$"
                    },
                    {
                      value: convertToPercent(pricingInfo.extensionFeePercentage),
                      label: "Extension Fee:",
                      size: 8,
                      unitType: "%"
                    },
                    {
                      value: roundNumber(pricingInfo.originationFeeRate),
                      label: "Origination Fee Percentage:",
                      size: 8,
                      unitType: "%",
                      condition: isValidPermission(permissions, "BrokerBorrowerApplication", "read")
                    },
                    {
                      value: roundNumber(pricingInfo.brokerFeeRate),
                      label: "Standard Broker Fee:",
                      size: 8,
                      unitType: "%",
                      condition: persona !== Personas.WL_GUARANTOR
                    },
                    {
                      value: convertToYesNo(pricingInfo.isCombineOriginationFee),
                      label: BPQuestionLabels.CombineOriginationFeeRate,
                      size: 8,
                      condition: (persona !== Personas.WL_GUARANTOR && !FeatureFlags.IS_BROKER_FEE_ALLIANCE)
                    },
                    {
                      value: roundNumber(pricingInfo.wlbrokerFeeRate),
                      label: "Whitelabeled Broker Fee:",
                      size: 8,
                      unitType: "%",
                      condition: (persona !== Personas.WL_GUARANTOR && FeatureFlags.IS_BROKER_FEE_ALLIANCE)
                    },
                    {
                      value: minMandatoryBrokerFee,
                      label: `${BPQuestionLabels.MinMandatoryBrokerFeeRate}:`,
                      size: 8,
                      unitType: "%",
                      condition: (persona !== Personas.WL_GUARANTOR && FeatureFlags.IS_BROKER_FEE_ALLIANCE)
                    },
                    {
                      value: totalBrokerFee,
                      label: `${BPQuestionLabels.TotalBrokerFeeRate}:`,
                      size: 8,
                      unitType: "%",
                      condition: (persona !== Personas.WL_GUARANTOR && FeatureFlags.IS_BROKER_FEE_ALLIANCE)
                    },
                    {
                      value: !(totalBrokerFee && pricingInfo.wlbrokerFeeRate) ? null : roundNumber((totalBrokerFee - (roundNumber(pricingInfo.wlbrokerFeeRate) + minMandatoryBrokerFee)) > 2) ? 
                        2 : roundNumber(totalBrokerFee - (roundNumber(pricingInfo.wlbrokerFeeRate) + minMandatoryBrokerFee)),
                      label: "Broker Fee (Shown to Borrower):",
                      size: 8,
                      unitType: "%",
                      condition: persona !== Personas.WL_GUARANTOR
                    },
                    {
                      value: pricingInfo.originationFee,
                      label: "Origination Fee Amount:",
                      size: 8,
                      unitType: "$",
                      condition: isValidPermission(permissions, "BrokerBorrowerApplication", "read")
                    },
                    {
                      value: pricingInfo.brokerFee + pricingInfo.wlbrokerFee,
                      label: "Broker Fee Amount:",
                      size: 8,
                      unitType: "$",
                      condition: isValidPermission(permissions, "BrokerBorrowerApplication", "read")
                    },
                    {
                      value: pricingInfo.otherFee1Amount,
                      label: `Other Fee 1 - ${pricingInfo.otherFee1Name}`,
                      size: 8,
                      unitType: "$"
                    },
                    {
                      value: pricingInfo.otherFee2Amount,
                      label: `Other Fee 1 - ${pricingInfo.otherFee2Name}`,
                      size: 8,
                      unitType: "$"
                    }
                  ]}
                />
                <ApplicationDetailSection
                  title={BPApplicationAccordions.PricingProjectDetails.name}
                  accordionId={BPApplicationAccordions.PricingProjectDetails.id}
                  accordionObject={pricingInfo}
                  isEditMode={isEditMode}
                  setAccordionObject={setPricingInfo}
                  {...AccordionProps}
                  inputs={[
                    {
                      value: pricingInfo.refinancePayoff,
                      label: "Refinance Payoff:",
                      size: 8,
                      unitType: "$"
                    },
                    {
                      value: pricingInfo.afterRepairValue,
                      label: "Total Finished Value:",
                      size: 8,
                      unitType: "$"
                    },
                    {
                      value: pricingInfo.totalCostsPaidToDate,
                      label: "Costs Paid to Date:",
                      size: 8,
                      unitType: "$"
                    },
                    {
                      value: operationOfNumberArray("product", [pricingInfo.afterRepairValue, pricingInfo.realEstateCostsFeePercentage]),
                      label: "Estimated Resale Cost:",
                      size: 8,
                      unitType: "$"
                    },
                    {
                      value: pricingInfo.numberOfPropertiesOrUnits,
                      label: "Number of Vertical Units:",
                      size: 8,
                      unitType: (pricingInfo.numberOfPropertiesOrUnits && pricingInfo.numberOfPropertiesOrUnits > 1) ? "Units" : "Unit"
                    },
                    {
                      value: handleEstimatedNetSaleProceeds(pricingInfo.afterRepairValue, pricingInfo.realEstateCostsFeePercentage),
                      label: "Estimated Net Sale Proceeds:",
                      size: 8,
                      unitType: "$"
                    },
                    {
                      value: pricingInfo.budget,
                      label: "Construction Budget:",
                      size: 8,
                      unitType: "$"
                    }
                  ]}
                />
                <ApplicationDetailSection
                  title={BPApplicationAccordions.PricingProjectBreakdown.name}
                  accordionId={BPApplicationAccordions.PricingProjectBreakdown.id}
                  accordionObject={pricingInfo}
                  isEditMode={isEditMode}
                  setAccordionObject={setPricingInfo}
                  {...AccordionProps}
                  inputs={[
                    {
                      value: pricingInfo.loanCommitment,
                      label: "Total Loan Commitment:",
                      size: 8,
                      unitType: "$"
                    },
                    {
                      value: handleEstimatedNetSaleProceeds(pricingInfo.afterRepairValue, pricingInfo.realEstateCostsFeePercentage),
                      label: "Estimated Net Sale Proceeds:",
                      size: 8,
                      unitType: "$"
                    },
                    {
                      value: pricingInfo.interestPaidByBorrower,
                      label: "Borrower Paid Interests:",
                      size: 8,
                      unitType: "$"
                    },
                    {
                      value: handleEstimatedTotalCosts(pricingInfo.loanCommitment, pricingInfo.interestPaidByBorrower, pricingInfo.requiredCashDown, pricingInfo.totalCostsPaidToDate, pricingInfo.subordinatedDebtAmount),
                      label: "Estimated Total Costs:",
                      size: 8,
                      unitType: "$"
                    },
                    {
                      value: operationOfNumberArray("difference", [pricingInfo.requiredCashDown, pricingInfo.wipatClosing]),
                      label: "Cash to Close:",
                      size: 8,
                      unitType: "$"
                    },
                    {
                      value: handleEstimatedBorrowerProfit(pricingInfo),
                      label: "Estimated Borrower Profit:",
                      size: 8,
                      unitType: "$"
                    },
                    {
                      value: pricingInfo.totalCostsPaidToDate,
                      label: "Costs Paid to Date:",
                      size: 8,
                      unitType: "$"
                    },
                    {
                      value: operationOfNumberArray("difference", [handleEstimatedBorrowerProfit(pricingInfo), operationOfNumberArray("difference", [pricingInfo.requiredCashDown, pricingInfo.wipatClosing])]),
                      label: "Cash on Cash Return:",
                      size: 8,
                      unitType: "$"
                    },
                    {
                      value: pricingInfo.partialDeedReleaseAmount,
                      label: "Estimated Price Release Per Unit:",
                      size: 8,
                      unitType: "$"
                    },
                    {
                      value: operationOfNumberArray("sum", [
                        pricingInfo.loanCommitment,
                        pricingInfo.subordinatedDebtAmount,
                        pricingInfo.totalCostsPaidToDate,
                        pricingInfo.partialDeedReleaseAmount,
                      ]),
                      label: "Estimated Total Costs:",
                      size: 8,
                      unitType: "$"
                    }
                  ]}
                />
              </React.Fragment> : (pricingInfo && isGmrInteriorCardView) ? <BPPricingScenario
                isGreaterThanMobile={isGreaterThanMobile}
                isGreaterThanTablet={isGreaterThanTablet}
                isSidebar={isSidebar}
                scenarioMessage={isMessage}
                setScenarioMessage={setIsMessage}
                proxyUser={proxyUser}
                permissions={permissions}
                brokerColor={brokerColor}
                gmrObject={pricingInfo}
                setGmrObject={setPricingInfo}
                gmrMetadata={gmrMetadata}
                gmrScenarios={gmrScenarios}
                setGmrScenarios={setGmrScenarios} />
                : <Grid>
                  <Grid.Row className="details-table-row">
                    <Grid.Column width={16}>
                      <BCEmptyState
                        emptyStateClass="application-details-empty-state"
                        icon="dollar"
                        brokerColor={getIsWhiteLabeled() ? brokerColor : void 0}
                        className={getIsWhiteLabeled() ? brokerIconColorOverride : ""}
                        text={window.location.pathname.includes("pricing") ? "Looks like you don’t have any pricing information. Please contact us for assistance." : "We are working on delivering a creative pricing solution for you."}
                      />
                    </Grid.Column>
                  </Grid.Row>
                </Grid>}
            </Form>
          </React.Fragment>
        }
      ]
    ];

    if (!isPricing) {
      pricingCards[0].push({
        title: user.isExternalUser ? "Contact Us" : "Comments",
        size: 5,
        content: <React.Fragment>
          {user.isExternalUser ? <React.Fragment>
            {(loanInfo && loanInfo.loanOfficer) && <BCContactUsInfo
              title={loanInfo.loanOfficer.name}
              subtitle="Loan Officer"
              phone={handleFormatContactPhone(loanInfo.loanOfficer.phone.toString())}
              email={loanInfo.loanOfficer.email}
            />}
            {(loanInfo && loanInfo.portfolioManager) && <BCContactUsInfo
              title={loanInfo.portfolioManager.name}
              subtitle="Portfolio Manager"
              phone={handleFormatContactPhone(loanInfo.portfolioManager.phone.toString())}
              email={loanInfo.portfolioManager.email}
            />}
            <BCContactUsInfo
              title="Sales Team"
              phone="(888) 991-1257 Option 2"
              email="wholesale@constructionloanservices.com"
            />
            <BCContactUsInfo
              title="Processing Team"
              phone="(888) 991-1257 Option 3"
              email="wholesaleProcessing@constructionloanservices.com"
            />
            <BCContactUsInfo
              title="Servicing Team"
              phone="(888) 991-1257 Option 3"
              email="wholesaleProcessing@constructionloanservices.com"
            />
          </React.Fragment> : <React.Fragment>
            {(loanComments && loanComments.length > 0) ? loanComments.map((loanComment, i) => {
              return (
                <div key={`loanComment-${i}`} className="loan-comment-container">
                  <div className="loan-comment-owner">{loanComment.fullName ? loanComment.fullName : loanComment.createdBy} on {convertToDateString(loanComment.createdOn, "fulldatetime")}</div>
                  <div>{loanComment.description}</div>
                </div>
              );
            }) : <div className="loan-comment-container">
              <div>No comments have been left yet.</div>
            </div>}
            {(loanComments && loanComments.length > 0) && <div className="pricing-comment-button-container">
              <Button
                className="bp-button pricing-comment-button"
                style={getIsWhiteLabeled() ? setBackgroundColor(brokerColor ? brokerColor : "#000000") : void 0}
                onClick={() => handleActiveTabAsync(BrokerConstants.InteriorCardTabs.Comments.name.toLocaleUpperCase())}
              >
                See All
              </Button>
            </div>}
          </React.Fragment>}
        </React.Fragment>
      });
    }

    return pricingCards;
  };

  const TasksLayout = [
    [
      {
        title: BrokerConstants.InteriorCardTabs.Tasks.name,
        size: 16,
        content: <Form className="primary-form" autoComplete="off">
          {(borrowerApplicationInfo && authToken) && <iframe 
            id={`${BrokerConstants.InteriorCardTabs.Tasks.name}-iframe`}
            src={`${getGameChangerIframeSource()}?application=${borrowerApplicationInfo.applicationNumber}&module=Todos&JWT=${authToken}${proxyUser.id ? `&uid=${proxyUser.id}` : ""}`}
            title="Tasks"
            width="100%"
            height="700px"
          />}
        </Form>
      }
    ]
  ];

  const MilestonesLayout = [
    [
      {
        title: BrokerConstants.InteriorCardTabs.Milestones.name,
        size: 16,
        content: <Form className="primary-form" autoComplete="off">
          {(borrowerApplicationInfo && authToken) && <iframe 
            id={`${BrokerConstants.InteriorCardTabs.Milestones.name}-iframe`}
            src={`${getGameChangerIframeSource()}?application=${borrowerApplicationInfo.applicationNumber}&module=Milestone&JWT=${authToken}${proxyUser.id ? `&uid=${proxyUser.id}` : ""}`}
            title="Timeline"
            width="100%"
            height="700px"
          />}
        </Form>
      }
    ]
  ];

  const PricingLayout = handleGeneratePricingCards();
  const ProjectLayout = [
    [
      {
        title: BrokerConstants.InteriorCardTabs.Project.name,
        size: 16,
        content: <React.Fragment>
          {(loanInfo && borrowerApplicationInfo && applicationMetadata) && <Form className="primary-form" autoComplete="off">
            {handleIsChangeInteriorCard() && <BPLoanDetailEditButtons 
              brokerColor={brokerColor}
              isEditMode={isProjectEditMode}
              setIsEditMode={setIsProjectEditMode}
              editDetailsHandler={handleEditMode}
              saveChangesHandler={handleSaveLoanProjectChanges}
              discardChangesHandler={handleDiscardLoanProjectChanges}
            />}
            <BPLoanProjectContent 
              accordionProps={{...AccordionProps}}
              applicationMetadata={applicationMetadata}
              brokerColor={brokerColor}
              isEditMode={isProjectEditMode}
              isLoanInfo={isLoanApplication}
              projectInfo={isLoanApplication ? loanInfo : formatOldProjectInfo()}
              projectPatchObj={projectPatchObj}
              setProjectPatchObj={setProjectPatchObj}
              propertiesCopy={isLoanApplication ? loanProperties : borrowerApplicationProperties}
              propertiesPatchArray={propertiesPatchArray}
              setPropertiesPatchArray={setPropertiesPatchArray}
              setActiveTab={setActiveTab}
              borrowerApplicationInfo={borrowerApplicationInfo}
              handleDeleteCostsPaidsAsync={handleDeleteCostsPaidsAsync}
              handleUnfocus={handleUnfocus}
              invalidProps={invalidProps}
            />
          </Form>}
        </React.Fragment>
      }
    ]
  ];

  const PropertiesLayout = [
    [
      {
        title: `${BrokerConstants.InteriorCardTabs.Properties.name}`,
        size: 16,
        content: <React.Fragment>
          {(loanInfo && applicationMetadata) && <Form className="primary-form" autoComplete="off">
            {handleIsChangeInteriorCard() && <div className='application-properties'>
              {FeatureFlags.IS_UNIT_PROPERTY_REDESIGN ? <React.Fragment>
                <Button
                  className="bp-button interior-card-button"
                  icon
                  basic
                  onClick={() => handleEditMode(setIsPropertyEditMode)}
                  disabled={isPropertyEditMode}
                  >
                  <div className="gmr-button-container">
                    <Icon name='pencil' size="large" />
                    <div className="gmr-button-icon-text">Edit</div>
                  </div>
                </Button>
                {(isAddPropertyButtonDisplay && isPropertyEditMode) && <Button
                  className="bp-button interior-card-button"
                  icon
                  basic
                  onClick={() => handleAddNewProperty()}
                  disabled={!isPropertyEditMode}
                  >
                  <div className="gmr-button-container">
                    <Icon name='add' size="large" />
                    <div className="gmr-button-icon-text">Add Property</div>
                  </div>
                </Button>}
                <Button
                  className="bp-button interior-card-button"
                  icon
                  basic
                  onClick={() => isAllPropertyAccordionExpanded ? handleCollapseAllPropertyAccordions(BrokerConstants.InteriorCardTabs.Properties) : handleExpandAllPropertyAccordions(BrokerConstants.InteriorCardTabs.Properties)}
                  >
                  <div className="gmr-button-container">
                    <Icon name='caret down' size="large" />
                    <div className="gmr-button-icon-text">{isAllPropertyAccordionExpanded ? "Collapse All" : "Expand All"}</div>
                  </div>
                </Button>
                <Button
                  className="bp-button interior-card-button"
                  icon
                  basic
                  floated='right'
                  onClick={() => handleSaveLoanPropertiesChanges()}
                  disabled={!isPropertyEditMode}
                  >
                  <div className="gmr-button-container">
                    <Icon name='save outline' size="large" />
                    <div className="gmr-button-icon-text">Save</div>
                  </div>
                </Button>
                <Button
                  className="bp-button interior-card-button"
                  icon
                  basic
                  floated='right'
                  onClick={() => handleDiscardLoanPropertiesChanges()}
                  disabled={!isPropertyEditMode}
                  >
                  <div className="gmr-button-container">
                    <Icon name='trash alternate outline' size="large" />
                    <div className="gmr-button-icon-text">Cancel</div>
                  </div>
                </Button>
              </React.Fragment>
              : <BPLoanDetailEditButtons 
                brokerColor={brokerColor}
                isEditMode={isPropertyEditMode}
                setIsEditMode={setIsPropertyEditMode}
                editDetailsHandler={handleEditMode}
                saveChangesHandler={handleSaveLoanPropertiesChanges}
                discardChangesHandler={handleDiscardLoanPropertiesChanges}
              />}
            </div>}
            {(FeatureFlags.IS_UNIT_PROPERTY_REDESIGN && !handleIsChangeInteriorCard()) && <div className='application-properties'>
              <Button
                className="bp-button interior-card-button"
                icon
                basic
                onClick={() => isAllPropertyAccordionExpanded ? handleCollapseAllPropertyAccordions(BrokerConstants.InteriorCardTabs.Properties) : handleExpandAllPropertyAccordions(BrokerConstants.InteriorCardTabs.Properties)}
                >
                <div className="gmr-button-container">
                  <Icon name='caret down' size="large" />
                  <div className="gmr-button-icon-text">{isAllPropertyAccordionExpanded ? "Collapse All" : "Expand All"}</div>
                </div>
              </Button>
            </div>}
            <BCMessage
              animation={"fly down"}
              duration={750}
              visible={errorPropertyIds.size > 0}
              transitionOnMount
              styles="full-width"
              color="red"
              header={`The following ${errorPropertyIds.size > 1 ? "properties" : "property"} need more information before you can save:`}
              text={handleDisplayErrorProperties()}
            />
            <BPLoanPropertiesContent
              handleAddNewProperty={handleAddNewProperty}
              newPropertyFocusRef={newPropertyFocusRef}
              accordionProps={{...AccordionProps}}
              applicationMetadata={applicationMetadata}
              brokerColor={brokerColor}
              brokerButtonOevrrideCSS={brokerButtonOverrideCSS}
              brokerIconColorOverride={brokerIconColorOverride}
              isEditMode={isPropertyEditMode}
              invalidProps={invalidProps}
              setInvalidProps={setInvalidProps}
              isLoanInfo={isLoanApplication}
              loanProgramId={loanInfo.loanProgramId}
              loanInfo={{ 
                "loanProgramId": loanInfo.loanProgramId,
                "existingStructurePropertyTypeId": loanInfo.existingStructurePropertyTypeId,
                "borrowerApplicationId": loanInfo.id,
                "loanProperties": loanProperties
              }}
              propertiesCopy={isLoanApplication ? loanProperties : borrowerApplicationProperties}
              propertiesPatchArray={propertiesPatchArray}
              newLoanUnits={newLoanUnits}
              setNewLoanUnits={setNewLoanUnits}
              setPropertiesPatchArray={setPropertiesPatchArray}
              handleDeletePropertyAsync={handleDeletePropertyAsync}
              handleUnitDeleteAsync={handleUnitDeleteAsync}
              setInteriorCardSuccessMessage={setInteriorCardSuccessMessage}
              errorPropertyIds={errorPropertyIds}
            />
          </Form>}
        </React.Fragment>
      }
    ]
  ];

  const BorrowerLayout = [
    [
      {
        title: `${BrokerConstants.InteriorCardTabs.Borrower.name}`,
        size: 16,
        content: <React.Fragment>
          {(borrowerInfo && applicationMetadata) ? <Form className="primary-form" autoComplete="off">
            {handleIsChangeInteriorCard() && <BPLoanDetailEditButtons 
              brokerColor={brokerColor}
              isEditMode={isBorrowerEditMode}
              setIsEditMode={setIsBorrowerEditMode}
              editDetailsHandler={handleEditMode}
              saveChangesHandler={handleSaveBorrowerChanges}
              discardChangesHandler={handleDiscardBorrower}
            />}
            <BPLoanBorrowerContent 
              accordionProps={{...AccordionProps}}
              applicationMetadata={applicationMetadata}
              borrowerApplicationInfo={borrowerApplicationInfo}
              brokerColor={brokerColor}
              proxyUserId={proxyUser.id}
              isEditMode={isBorrowerEditMode}
              isLoanInfo={isLoanApplication}
              invalidProps={invalidProps}
              borrower={borrowerInfo}
              borrowerPatchObj={borrowerPatchObj}
              setBorrowerPatchObj={setBorrowerPatchObj}
              handleALDeleteAsync={handleALDeleteAsync}
              handleREODeleteAsync={handleREODeleteAsync}
            />
          </Form> : <Grid>
            <Grid.Row className="details-table-row">
              <Grid.Column width={16}>
                <BCEmptyState
                  emptyStateClass="application-details-empty-state"
                  icon="user"
                  brokerColor={getIsWhiteLabeled() ? brokerColor : void 0}
                  className={getIsWhiteLabeled() ? brokerIconColorOverride : ""}
                  text="Looks like there isn't any borrowers. Click here to edit your application."
                  button={<Button className={getIsWhiteLabeled() ? `primary-under-table-button ${brokerButtonOverrideCSS}` : "bp-button primary-under-table-button"} icon onClick={() => handleEditApplication(loanInfo.id)}>Add Borrower</Button>}
                />
              </Grid.Column>
            </Grid.Row>
          </Grid>}
        </React.Fragment>
      }
    ]
  ];

  const handleGenerateGuarantorCards = () => {
    const guarantorCards = [
      [
        {
          size: 16,
          content: <React.Fragment>
            <BPLoanGuarantorListContent 
              applicationId={applicationId}
              applicationMetadata={applicationMetadata}
              brokerColor={brokerColor}
              borrowerApplicationInfo={borrowerApplicationInfo}
              permissions={permissions}
              allowEdit={handleIsChangeInteriorCard()}
              organizationContactId={organizationContactId}
              selectedBrokerGuarantors={selectedBrokerGuarantors}
              setSelectedBrokerGuarantors={setSelectedBrokerGuarantors}
              invalidProps={invalidProps}
              setInvalidProps={setInvalidProps}
              setIsInteriorCardLoading={setIsInteriorCardLoading}
              brokerGuarantors={brokerGuarantors}
              setBrokerGuarantors={setBrokerGuarantors}
              isBrokerGuarantorSelected={isBrokerGuarantorSelected}
              setIsBrokerGuarantorSelected={setIsBrokerGuarantorSelected}
              getGuarantorsAsync={getGuarantorsAsync}
              guarantorSearch={guarantorSearch}
              setGuarantorSearch={setGuarantorSearch}
              isGreaterThanMobile={isGreaterThanMobile}
              setSelectedGuarantorId={setSelectedGuarantorId}
              setIsLoading={setIsLoading}
              handleBrokerGuarantorDelete={handleBrokerGuarantorDelete}
              handleBrokerGuarantorInvite={handleBrokerGuarantorInvite}
              handleBrokerGuarantorModal={handleBrokerGuarantorModal}
              handlePatchApplicationGuarantor={handlePatchApplicationGuarantor}
            />
          </React.Fragment>
        }
      ]
    ] as any[];

    if (guarantorsEditArray && guarantorsEditArray.length > 0 && applicationMetadata) {
      if (!selectedGuarantorId) {
        setSelectedGuarantorId(guarantorsEditArray[0].id);
      }
      
      const guarantor = guarantorsEditArray.find(guarantor => guarantor.id === selectedGuarantorId);
      if (loanInfo) {
        guarantorCards.push([
          {
            title: `${guarantor.firstName} ${guarantor.lastName}`,
            size: 16,
            content: <Form className="primary-form" autoComplete="off">
              {handleIsChangeInteriorCard(guarantor) && <BPLoanDetailEditButtons 
                brokerColor={brokerColor}
                isEditMode={isGuarantorEditMode}
                setIsEditMode={setIsGuarantorEditMode}
                editDetailsHandler={handleEditMode}
                saveChangesHandler={handleSaveGuarantorChanges}
                discardChangesHandler={handleDiscardGuarantor}
              />}
              <BPLoanGuarantorInfoContent 
                accordionProps={{...AccordionProps}}
                applicationMetadata={applicationMetadata}
                borrowerApplicationId={borrowerApplicationInfo.id}
                brokerColor={brokerColor}
                permissions={permissions}
                proxyUserId={proxyUser.id}
                isEditMode={isGuarantorEditMode}
                isLoanInfo={isLoanApplication}
                isGuarantor={isShowGuarantorSection}
                invalidProps={invalidProps}
                guarantorAccordions={guarantorAccordions}
                guarantor={guarantor}
                guarantorPatchObj={guarantorPatchObj}
                setGuarantorPatchObj={setGuarantorPatchObj}
                handleALDeleteAsync={handleALDeleteAsync}
                handleREODeleteAsync={handleREODeleteAsync}
              />
            </Form>
          }
        ]);
      }
    }

    return guarantorCards;
  };

  const GuarantorsLayout = handleGenerateGuarantorCards();
  const GuarantorsEmptyLayout = [
    [
      {
        title: BrokerConstants.InteriorCardTabs.Guarantors.name,
        size: 16,
        content: <Grid>
          <Grid.Row className="details-table-row">
            <Grid.Column width={16}>
              <BCEmptyState
                emptyStateClass="application-details-empty-state"
                icon="users"
                brokerColor={getIsWhiteLabeled() ? brokerColor : void 0}
                className={getIsWhiteLabeled() ? brokerIconColorOverride : ""}
                text="Looks like there isn't any guarantors. Click here to edit your application."
                button={<Button className={getIsWhiteLabeled() ? `primary-under-table-button ${brokerButtonOverrideCSS}` : "bp-button primary-under-table-button"} icon onClick={() => handleEditApplication(loanInfo.id)}>Add Guarantor</Button>}
              />
            </Grid.Column>
          </Grid.Row>
        </Grid>
      }
    ]
  ];

  const DocumentsLayout = [
    [
      {
        title: BrokerConstants.InteriorCardTabs.Documents.name,
        size: 16,
        content: <React.Fragment>
          {loanInfo && <Form className="primary-form" autoComplete="off">
            <Grid>
              {(documentsInfolist && documentMetadata && documentsInfolist.length > 0) && <Grid.Row className="details-table-row">
                <Grid.Column width={16}>
                  <BCTable
                    data={formatApplicationDocumentInfoList(documentsInfolist)}
                    dataRules={[{ field: "id", rule: "hide" }]}
                    thin
                    dataSingleLine
                    unstackable
                    ellipsis
                    ellipsisHandlers={[
                      {
                        action: (item) => getLoanDocumentAsync(item.id, true),
                        text: "Download"
                      },
                      {
                        action: (item) => deleteLoanDocumentAsync(item.id),
                        text: "Delete"
                      }
                    ]}
                    selectable
                    handleClick={(index) => handleDocumentModalOpenAsync("documentInfo", documentsInfolist[index], handleGetValueFromId(documentMetadata.documentMaster, documentsInfolist[index].documentMasterId), loanInfo.name)}
                  />
                </Grid.Column>
              </Grid.Row>}
              <Grid.Row className={(documentsInfolist && documentsInfolist.length > 0) ? "details-row" : "details-table-row"}>
                <Grid.Column width={16}>
                  {stagedDocumentFile ? <div className="upload-stage-default">
                    <Container className="vertical-center" fluid>
                      <div className="upload-stage-container">
                        {stagedDocumentPreviewUrl ? <Image
                          className="upload-stage-preview"
                          src={stagedDocumentPreviewUrl}
                        /> : <Icon name="file alternate" className="upload-stage-preview" size="massive" />}
                        <Grid className="upload-stage-grid">
                          <Grid.Row className="details-row">
                            <Grid.Column width={16}>
                              <BCFormInput
                                labelClass="primary-title-label form-input-header form-input-border"
                                label="Upload Confirmation"
                              />
                            </Grid.Column>
                            <Grid.Column width={16}>
                              <BCFormInput
                                labelClass="gmr-background-label"
                                type="input"
                                label="Document Name:"
                                value={stagedDocumentFile.name}
                                disabled
                              />
                            </Grid.Column>
                            <Grid.Column width={16}>
                              <BCFormInput
                                labelClass="gmr-background-label"
                                type="dropdown"
                                label="Document Type:"
                                placeholder="Please Select"
                                obj={stagedDocumentObject}
                                field="documentMasterId"
                                dropdownOptions={getDropdownOptions(documentMetadata.documentMaster, ["id"], "name")}
                                handleFormChange={(value, field) => handleFormChange(value, field, stagedDocumentObject, setStagedDocumentObject)}
                                required
                              />
                              {applicationValidationMessage("documentMasterId")}
                            </Grid.Column>
                            <Grid.Column width={16}>
                              <BCFormInput
                                labelClass="gmr-background-label"
                                type="textarea"
                                label="Description"
                                placeholder="Write your description here..."
                                obj={stagedDocumentObject}
                                field="description"
                                handleFormChange={(value, field) => handleFormChange(value, field, stagedDocumentObject, setStagedDocumentObject)}
                              />
                            </Grid.Column>
                          </Grid.Row>
                          <Grid.Row className="details-row">
                            <Grid.Column width={16}>
                              <Grid>
                                <Grid.Row>
                                  <Grid.Column width={8}>
                                    <Button
                                      fluid
                                      onClick={() => handleResetStageUpload()}
                                    >
                                      <div className="gmr-button-container">
                                        <div className="gmr-button-text">Cancel</div>
                                      </div>
                                    </Button>
                                  </Grid.Column>
                                  <Grid.Column width={8}>
                                    <Button
                                      className="bp-button"
                                      fluid
                                      onClick={() => handleStageUploadSubmit()}
                                    >
                                      <div className="gmr-button-container">
                                        <div className="gmr-button-text">Submit</div>
                                      </div>
                                    </Button>
                                  </Grid.Column>
                                </Grid.Row>
                              </Grid>
                            </Grid.Column>
                          </Grid.Row>
                        </Grid>
                      </div>
                    </Container>
                  </div> : <BCUploadBox
                    uploadTitle={`${(documentsInfolist && documentsInfolist.length === 0) ? "Looks like there isn't any uploaded documents. " : ""}Drag your ${BrokerConstants.InteriorCardTabs.Documents.name.toLocaleLowerCase()} here or browse`}
                    uploadText="JPEGs, PDFs, Excel and Word Documents accepted"
                    handleUploadFiles={handleStageUpload}
                    uploadBoxClass={(documentsInfolist && documentsInfolist.length === 0) ? "application-details-upload-empty" : "application-details-upload"}
                  />}
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </Form>}
        </React.Fragment>
      }
    ]
  ];

  const PaymentsLayout = [
    [
      {
        title: BrokerConstants.InteriorCardTabs.Payments.name,
        size: 16,
        content: <React.Fragment>
          <div>We recommend paying as soon as possible. Once paid, it can take up to 10 days to receive 3rd party services. A delay in pre-paying could delay closing of the loan.</div>
          <div className={(payeezyLoanInvoices && payeezyLoanInvoices.length > 0) ? "interior-card-table" : "interior-card-table-empty"}>
            {(payeezyLoanInvoices && payeezyLoanInvoices.length > 0) ? <BCTable
              data={formatPayeezyLoanInvoices(payeezyLoanInvoices)}
              dataRules={[{ field: "Id", rule: "hide" }]}
              thin
              dataSingleLine
              unstackable
              ellipsis
              ellipsisHandlers={[
                {
                  action: (index) => (payeezyLoanInvoices[index] && payeezyLoanInvoices[index].id) ? downloadPayeezyInvoiceAsync(payeezyLoanInvoices[index].id) : void 0,
                  text: "Download"
                }
              ]}
              editMode={true}
            /> : <BCEmptyState
              emptyStateClass="application-details-empty-state"
              icon="credit card outline"
              brokerColor={getIsWhiteLabeled() ? brokerColor : void 0}
              className={getIsWhiteLabeled() ? brokerIconColorOverride : ""}
              text="Your wallet can take a break for now."
            />}
          </div>
        </React.Fragment>
      }
    ]
  ];

  const CommentsLayout = [
    [
      {
        title: <Breadcrumb size={"huge"}>
          {commentBreadcrumb === "" ? <Breadcrumb.Section className="comment-breadcrumb">{BrokerConstants.InteriorCardTabs.Comments.name}</Breadcrumb.Section> : <React.Fragment>
            <Breadcrumb.Section
              className="comment-breadcrumb"
              link
              onClick={handleTryReturnToComments}
            >
              {BrokerConstants.InteriorCardTabs.Comments.name}
            </Breadcrumb.Section>
            <Breadcrumb.Divider icon='right chevron' />
            <Breadcrumb.Section className="comment-breadcrumb" active>
              {(isValidPermission(permissions, "GlobalAdminAccess", "read") && commentBreadcrumb === "Comment") ? "Edit Comment" :
                commentBreadcrumb === "Comment" ? "View Comment" : "Add Comment"}
            </Breadcrumb.Section>
          </React.Fragment>}
        </Breadcrumb>,
        size: 16,
        content: <React.Fragment>
          {commentBreadcrumb === "" ? <React.Fragment>
            <Button
              className="bp-button comment-button"
              style={getIsWhiteLabeled() ? setBackgroundColor(brokerColor ? brokerColor : "#000000") : void 0}
              onClick={() => setCommentBreadcrumb("Add Comment")}
            >
              <div className="gmr-button-container">
                <Icon name="plus" size="large" />
                <div className="gmr-button-icon-text">Add Comment</div>
              </div>
            </Button>
            <div className={(loanComments && loanComments.length > 0) ? "interior-card-table" : "interior-card-table-empty"}>
              {(loanComments && loanComments.length > 0) ? <BCTable
                data={formatLoanComments(loanComments)}
                dataRules={[{ field: "Id", rule: "hide" }]}
                sortable={["Category", "Subject", "Comment", "Created By", "Created On"]}
                thin
                unstackable
                dataSingleLine
                multiline
                overflowX={isGreaterThanMobile ? false : true}
                handleClick={(i) => !user.isExternalUser ? handleCommentClick(i) : void 0}
                selectable={user.isExternalUser ? false : true}
              /> : <BCEmptyState
                emptyStateClass="application-details-empty-state"
                icon="comment outline"
                brokerColor={getIsWhiteLabeled() ? brokerColor : void 0}
                className={getIsWhiteLabeled() ? brokerIconColorOverride : ""}
                text="No comment."
              />}
            </div>
          </React.Fragment> : <React.Fragment>
            <Form className="primary-form" autoComplete="off">
              <Grid className="comment-grid">
                {!user.isExternalUser && <Grid.Row className="application-row">
                  <Grid.Column width={isGreaterThanMobile ? 8 : 16}>
                    <BCFormInput
                      labelClass="gmr-background-label"
                      type="dropdown"
                      label="Category"
                      field="commentCategoryId"
                      value={commentObj.commentCategoryId}
                      dropdownOptions={getDropdownOptions(applicationMetadata.commentCategories, ["id"], "name")}
                      handleFormChange={(value, field) => handleCommentFormChange(value, field)}
                      required
                      disabled={!isValidPermission(permissions, "GlobalAdminAccess", "read") && commentBreadcrumb === "Comment"}
                    />
                    <BCValidationMessage invalidProps={recipientInvalidProps} prop={RecipientValidationProps.commentCategoryId} />
                  </Grid.Column>
                </Grid.Row>}
                <Grid.Row className="application-row">
                  <Grid.Column width={isGreaterThanMobile ? 8 : 16}>
                    {user.isExternalUser ? <React.Fragment>
                      {(commentBreadcrumb !== "Comment" || (commentBreadcrumb === "Comment" && commentObj.subject)) && <BCFormInput
                        labelClass="gmr-background-label"
                        type="input"
                        label="Comment Subject"
                        value={commentObj.subject}
                        field="subject"
                        inputType="text"
                        handleFormChange={(value, field) => handleCommentFormChange(value, field, GlobalConstants.InputTypes.STRING, 50)}
                        required
                        disabled={!isValidPermission(permissions, "GlobalAdminAccess", "read") && commentBreadcrumb === "Comment"}
                        charLimit={50}
                      />}
                      <BCValidationMessage invalidProps={recipientInvalidProps} prop={RecipientValidationProps.subject} />
                    </React.Fragment> : <React.Fragment>
                      <BCFormInput
                        labelClass="gmr-background-label"
                        type="dropdown"
                        label="Comment Subject"
                        field="commentSubjectId"
                        value={commentObj.commentSubjectId}
                        dropdownOptions={getDropdownOptions(applicationMetadata.commentSubjects.filter(x => x.commentCategoryId === commentObj.commentCategoryId), ["id"], "name")}
                        handleFormChange={(value, field) => handleCommentFormChange(value, field, GlobalConstants.InputTypes.STRING, 50)}
                        required
                        disabled={(!isValidPermission(permissions, "GlobalAdminAccess", "read") && commentBreadcrumb === "Comment") ||
                          !commentObj.commentCategoryId}
                      />
                      <BCValidationMessage invalidProps={recipientInvalidProps} prop={RecipientValidationProps.commentSubjectId} />
                    </React.Fragment>}
                  </Grid.Column>
                </Grid.Row>
                <Grid.Row className="application-row">
                  <Grid.Column width={16}>
                    <BCFormInput
                      labelClass="gmr-background-label"
                      type="textarea"
                      label="Comment"
                      placeholder="Write your comment here..."
                      field="description"
                      value={commentObj.description}
                      handleFormChange={(value, field) => handleCommentFormChange(value, field, GlobalConstants.InputTypes.STRING, 500)}
                      charLimit={500}
                      required
                      disabled={!isValidPermission(permissions, "GlobalAdminAccess", "read") && commentBreadcrumb === "Comment"}
                    />
                    <BCValidationMessage invalidProps={recipientInvalidProps} prop={RecipientValidationProps.description} />
                  </Grid.Column>
                  {!user.isExternalUser && <React.Fragment>
                    <Grid.Column width={16}>
                      <BCFormInput
                        labelClass="comment-toggle-label"
                        type="toggle"
                        label="Show comment externally?"
                        field="isShowCommentExternal"
                        value={commentObj.isShowCommentExternal}
                        handleFormChange={(value, field) => handleCommentFormChange(value, field)}
                        disabled={!isValidPermission(permissions, "GlobalAdminAccess", "read") && commentBreadcrumb === "Comment"}
                      />
                    </Grid.Column>
                    {commentObj.isShowCommentExternal && <Grid.Column width={16}>
                      <BCFormInput
                        labelClass="comment-checkbox-label"
                        type="checkbox"
                        label={<span><Icon name="warning sign" color="yellow" />
                          <span>Once saved, this action cannot be reversed. Please check the box to show this comment externally</span>
                        </span>}
                        field="isExternal"
                        value={commentObj.isExternal}
                        handleFormChange={(value, field) => handleCommentFormChange(value, field)}
                        required
                        disabled={!isValidPermission(permissions, "GlobalAdminAccess", "read") && commentBreadcrumb === "Comment"}
                      />
                      <BCValidationMessage invalidProps={recipientInvalidProps} prop={RecipientValidationProps.isExternal} />
                    </Grid.Column>}
                  </React.Fragment>}
                  {!getIsWhiteLabeled() && <React.Fragment>
                    <Grid.Column width={16}>
                      <BCFormInput
                        labelClass="comment-toggle-label"
                        type="toggle"
                        label="Send notification?"
                        field="isSendNotification"
                        value={commentObj.isSendNotification}
                        handleFormChange={(value, field) => handleCommentFormChange(value, field)}
                        required={commentObj.isSendNotification ? true : false}
                        disabled={commentBreadcrumb === "Comment"}
                      />
                    </Grid.Column>
                    {commentObj.isSendNotification && <React.Fragment>
                      <Grid.Column width={isGreaterThanMobile ? 8 : 16}>
                        <BCFormInput
                          type={GlobalConstants.FormInputTypes.SEARCH_FILTER}
                          onSearchChange={(value, field) => handleCommentRecipientSearchChange(value, field)}
                          value={commentRecipientSearch}
                          renderSuggestions={handleCommentRecipientSuggestions()}
                          handleSearchSelect={(e, data) => handleCommentRecipientSelect(data.result)}
                          isSearchOpen={!isRecipientSearchOpen}
                          onSearchFocus={() => setIsRecipientSearchOpen(false)}
                          noSearchResultsMessage="To notify a person, type their email address or name and press enter."
                          searchClass="bc-search-input-full"
                          handleSearchKeyDown={handleCommentRecipientKeyDown}
                          placeholder="Search recipients"
                          disabled={commentBreadcrumb === "Comment"}
                        />
                      </Grid.Column>
                      <Grid.Column width={16}>
                        <div className={selectedCommentRecipients.length > 0 ? "recipient-table-container" : "recipient-table-empty-container"}>
                          {selectedCommentRecipients.length > 0 ? <BCTable
                            data={formatSelectedCommentRecipients(selectedCommentRecipients)}
                            dataRules={[{ field: "Id", rule: "hide" }]}
                            thin
                            unstackable
                            dataSingleLine
                          /> : <BCEmptyState
                            emptyStateClass="application-details-empty-state"
                            icon="user circle"
                            brokerColor={getIsWhiteLabeled() ? brokerColor : void 0}
                            className={getIsWhiteLabeled() ? brokerIconColorOverride : ""}
                            text="You haven't selected any recipients yet. Type a name or an email in the search bar above to get started!"
                          />}
                        </div>
                        <div className="recipient-validation">
                          <BCValidationMessage
                            invalidProps={recipientInvalidProps}
                            prop={RecipientValidationProps.emailToList}
                            propText="You must select at least one recipient."
                          />
                        </div>
                      </Grid.Column>
                    </React.Fragment>}
                  </React.Fragment>}
                </Grid.Row>
              </Grid>
            </Form>
            <Grid>
              <Grid.Row>
                <Grid.Column width={8}>
                  <Button
                    onClick={handleTryReturnToComments}
                    fluid
                  >
                    Cancel
                  </Button>
                </Grid.Column>
                <Grid.Column width={8}>
                  <Button
                    className="bp-button"
                    style={getIsWhiteLabeled() ? setBackgroundColor(brokerColor ? brokerColor : "#000000") : void 0}
                    onClick={handleSubmitLoanComment}
                    fluid
                  >
                    Save
                  </Button>
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </React.Fragment>}
        </React.Fragment>
      }
    ]
  ];

  return (
    <div className={(isGreaterThanTablet && isSidebar) ? "landing-page hide-sidebar" : "landing-page sidebar"}>
      {isValidPermission(permissions, "BrokerBorrowerApplication", "read") && <a className={"export-link"} href={documentDownloadUrl} download ref={documentDownloadRef as any}>0</a>}
      {isValidPermission(permissions, "BrokerGMRPricingInfo", "export") && <a className={"export-link"} href={exportURL} download ref={exportRef as any}>0</a>}
      {isValidPermission(permissions, "BrokerGMRPricingInfo", "export") && <a className={"export-link"} href={originalScenarioURL} download ref={originalScenarioRef as any}>1</a>}
      {isValidPermission(permissions, "BrokerGMRPricingInfo", "export") && <a className={"export-link"} href={scenario1URL} download ref={scenario1Ref as any}>2</a>}
      {isValidPermission(permissions, "BrokerGMRPricingInfo", "export") && <a className={"export-link"} href={scenario2URL} download ref={scenario2Ref as any}>3</a>}
      <a className={"export-link"} href={payeezyFileUrl} download ref={payeezyFileRef as any}>4</a>
      {isLoading ? <Loader active inline="centered" size={"big"} /> : <div>
        <div className="payeezyFormContainer">
          <form target="payeezy-iframe" action={payeezyObject.payeezyGatewayPaymentUrl} method="post">
            <input name="x_login" value={payeezyObject.x_login} type="hidden" />
            <input name="x_amount" value={payeezyObject.x_amount} type="hidden" />
            <input name="x_fp_hash" value={payeezyObject.x_fp_hash} type="hidden" />
            <input name="x_fp_sequence" value={payeezyObject.x_fp_sequence} type="hidden" />
            <input name="x_fp_timestamp" value={payeezyObject.x_fp_timestamp} type="hidden" />
            <input name="x_receipt_link_method" value={payeezyObject.x_receipt_link_method} type="hidden" />
            <input name="x_receipt_link_url" value={payeezyObject.x_receipt_link_url} type="hidden" />
            <input name="x_show_form" value={payeezyObject.x_show_form} type="hidden" />
            <input name="merchant_cookie_1" value={payeezyRedirectToken} type="hidden" />
            <input ref={payeezySubmitRef} value="." type="submit" />
          </form>
        </div>
        <BCMessage
          animation={"fly down"}
          duration={750}
          visible={isMessage}
          transitionOnMount
          styles="full-width"
          onDismiss={() => setIsMessage(false)}
          errorResponse={errorResponse}
        />
        <BCMessage
          animation={"fly down"}
          duration={750}
          visible={isBrokerGuarantorInvited}
          transitionOnMount
          styles="full-width"
          color="green"
          onDismiss={() => setIsBrokerGuarantorInvited(false)}
          header={"Success!"}
          text={`${brokerGuarantorInvitedName} has been sent an invitation.`}
        />
        <BCMessage
          animation={"fly down"}
          duration={750}
          visible={loanCommentSubmissionType !== ""}
          transitionOnMount
          styles="full-width"
          color="green"
          onDismiss={() => setLoanCommentSubmissionType("")}
          header={"Success!"}
          text={loanCommentSubmissionType === "edit" ? "Your comment has been edited!" : "Your comment has been submitted!"}
        />
        <BCModal
          isModalOpen={isModalOpen}
          onClose={() => handleDocumentModalClose()}
          onOpen={() => setIsModalOpen(true)}
          header={handleApplicationDetailModal(modalType).header && handleApplicationDetailModal(modalType).header}
          content={handleApplicationDetailModal(modalType).content && handleApplicationDetailModal(modalType).content}
          actions={handleApplicationDetailModal(modalType).actions && handleApplicationDetailModal(modalType).actions}
        />
        <BCModal isModalOpen={isScenarioExportModal}
          size="large"
          onClose={() => handleScenarioModalClose()}
          onOpen={() => setIsScenarioExportModal(true)}
          actions={<Grid>
            <Grid.Row columns={2}>
              <Grid.Column>
                <Button icon fluid onClick={() => handleScenarioModalExportIndividually()}>
                  <div className="gmr-button-container">
                    <div className="gmr-button-text">Export Individually</div>
                  </div>
                </Button>
              </Grid.Column>
              <Grid.Column>
                <Button
                  className="bp-button"
                  style={getIsWhiteLabeled() ? setBackgroundColor(brokerColor ? brokerColor : "#000000") : void 0}
                  fluid
                  onClick={() => handleScenarioModalExportComparison()}
                  disabled={handleExportComparisonDisabled()}
                >
                  <div className="gmr-button-container">
                    <div className="gmr-button-text">Export Comparison</div>
                  </div>
                </Button>
              </Grid.Column>
            </Grid.Row>
          </Grid>}
          header="Which would you like to export?"
          content={<React.Fragment>
            <BCFormInput
              labelClass="gmr-background-label"
              type="checkbox"
              checkboxText="Original"
              obj={scenarioModalObj}
              field="isScenarioOriginal"
              value={scenarioModalObj.isScenarioOriginal}
              handleFormChange={(value, field) => handleScenarioModalChange(value, field, scenarioModalObj, setScenarioModalObj)}
            />
            {(gmrScenarios && gmrScenarios.length > 0) && gmrScenarios.map((gmrScenario, i) => {
              return (
                <BCFormInput
                  key={`gmrIsScenarioCheckbox-${i}`}
                  labelClass="gmr-background-label"
                  type="checkbox"
                  checkboxText={gmrScenario.name ? gmrScenario.name : ""}
                  obj={scenarioModalObj}
                  field={`isScenario${i + 1}`}
                  value={scenarioModalObj[`isScenario${i + 1}`]}
                  handleFormChange={(value, field) => handleScenarioModalChange(value, field, scenarioModalObj, setScenarioModalObj)}
                />
              );
            })}
          </React.Fragment>}
        />
        <BCModal isModalOpen={isPayeezyModal}
          size="large"
          onClose={() => setIsPayeezyModal(false)}
          onOpen={() => setIsPayeezyModal(true)}
          contentClass="payeezy-modal-content"
          content={PayeezyForm()}
        />
        <BCModal isModalOpen={isInvoiceModal}
          size="large"
          onClose={() => setIsInvoiceModal(false)}
          onOpen={() => setIsInvoiceModal(true)}
          content={InvoiceModalContent()}
        />
        <BCModal
          size="large"
          isModalOpen={isGuarantorModalOpen}
          onClose={() => modalType.includes("guarantor") ? void 0 : handleModalClose()}
          onOpen={() => setIsGuarantorModalOpen(true)}
          header={handleGuarantorModal(modalType).header && handleGuarantorModal(modalType).header}
          content={handleGuarantorModal(modalType).content && handleGuarantorModal(modalType).content}
          actions={handleGuarantorModal(modalType) && handleGuarantorModal(modalType).actions}
          brokerColor={getIsWhiteLabeled() ? brokerColor : void 0}
        />
        <BCModal
          size="tiny"
          isModalOpen={isRecipientModalOpen}
          onOpen={() => setIsRecipientModalOpen(true)}
          headerClass="recipient-modal-header"
          header={<div className="recipient-modal-title">Warning!</div>}
          content="If you proceed your data will be lost"
          actions={<Grid>
            <Grid.Row>
              <Grid.Column width={8}>
                <Button
                  onClick={() => handleReturnToComments()}
                  fluid
                >
                  Continue
                </Button>
              </Grid.Column>
              <Grid.Column width={8}>
                <Button
                  style={getIsWhiteLabeled() ? setBackgroundColor(brokerColor ? brokerColor : "#000000") : void 0}
                  onClick={() => setIsRecipientModalOpen(false)}
                  fluid
                  color="yellow"
                >
                  Keep me here!
                </Button>
              </Grid.Column>
            </Grid.Row>
          </Grid>}
          brokerColor={getIsWhiteLabeled() ? brokerColor : void 0}
        />
        <BCMessage
          animation={"fly down"}
          duration={750}
          visible={interiorCardSuccessMessage !== ""}
          transitionOnMount
          styles="full-width"
          negative
          color="green"
          onDismiss={() => setInteriorCardSuccessMessage("")}
          header={"Success!"}
          text={interiorCardSuccessMessage}
        />
        <input className="application-unfocus-input" ref={unfocusRef as any} />
        {(pricingInfo || loanInfo) && <React.Fragment>
          <BCMessage
            animation={"fly down"}
            duration={750}
            visible={isUnitWarningMessage}
            transitionOnMount
            styles="full-width"
            negative
            color="yellow"
            onDismiss={() => setIsUnitWarningMessage(false)}
            header={"Oops!"}
            text={"Please remove any duplicate unit numbers within the same property before saving!"}
          />
          <BCTabMenuBar
            title={handleInfoTitle(pricingInfo, loanInfo)}
            subtitle={handleInfoSubtitle(pricingInfo, loanInfo)}
            tabs={handleGameChangerTabs()}
            activeTab={activeTab}
            setActiveTab={handleActiveTabAsync}
            isGreaterThanMobile={isGreaterThanMobile}
            brokerColor={getIsWhiteLabeled() ? brokerColor : void 0}
            dropdown={<Dropdown className="tab-menubar-subtitle" selection defaultValue={versionOptions[1].value} onChange={async () => isLoanApplication ? await changeApplicationVersion(false, activeTab, "PRICING") : await changeApplicationVersion(true, activeTab, "PRICING")} options={versionOptions} />}
            menubarButton={(isAdminPersona && window.location.pathname.includes("application") && borrowerApplicationInfo.statusLookupName === "Submitted") ? <BCButtonDropdown
              buttonGroupText="Submit Options"
              buttonGroupClass="bc-button-group prescreen-button-group"
              handleOptionClick={handleSubmitOptionsChange}
              options={BPRevisionSubmitOptions}
            /> : (!isValidPermission(permissions, "GlobalAdminAccess", "read") && !getIsWhiteLabeled()
              && window.location.pathname.includes("application") && borrowerApplicationInfo.statusLookupName === "Revision") ? <Button
                className="bp-button details-button submit-for-review-button"
                icon
                onClick={handleSubmitForReview}
              >Submit</Button> : null}
          />
          <BCDashboard
            DashboardLayout={isInteriorCardLoading ? LoaderLayout :
              activeTab === BrokerConstants.InteriorCardTabs.Tasks.name.toLocaleUpperCase() ? TasksLayout :
                activeTab === BrokerConstants.InteriorCardTabs.Milestones.name.toLocaleUpperCase() ? MilestonesLayout :
                  activeTab === BrokerConstants.InteriorCardTabs.Pricing.name.toLocaleUpperCase() ? PricingLayout :
                    activeTab === BrokerConstants.InteriorCardTabs.Project.name.toLocaleUpperCase() ? ProjectLayout :
                      activeTab === BrokerConstants.InteriorCardTabs.Properties.name.toLocaleUpperCase() ? PropertiesLayout :
                        activeTab === BrokerConstants.InteriorCardTabs.Borrower.name.toLocaleUpperCase() ? BorrowerLayout :
                          activeTab === BrokerConstants.InteriorCardTabs.Guarantors.name.toLocaleUpperCase() ? ((guarantorsInfo && guarantorsInfo.length > 0 && applicationMetadata) ? GuarantorsLayout : GuarantorsEmptyLayout) :
                            activeTab === BrokerConstants.InteriorCardTabs.Documents.name.toLocaleUpperCase() ? DocumentsLayout :
                              activeTab === BrokerConstants.InteriorCardTabs.Payments.name.toLocaleUpperCase() ? PaymentsLayout :
                                activeTab === BrokerConstants.InteriorCardTabs.Comments.name.toLocaleUpperCase() ? CommentsLayout : []}
            isGreaterThanMobile={isGreaterThanMobile}
            brokerColor={getIsWhiteLabeled() ? brokerColor : void 0}
          />
          {FeatureFlags.IS_DEBUG && <React.Fragment>
            <button onClick={() => console.log(loanInfo)}>loanInfo</button>
            <button onClick={() => console.log(borrowerApplicationInfo)}>borrowerApplicationInfo</button>
            <button onClick={() => console.log(borrowerApplicationBuilderInfo)}>borrowerApplicationBuilderInfo</button>
            <button onClick={() => console.log(borrowerApplicationProperties)}>borrowerApplicationProperties</button>
            <button onClick={() => console.log(Object.values(BrokerConstants.InteriorCardTabs))}>BrokerConstants.InteriorCardTabs values</button>
            <button onClick={() => console.log(pricingInfo)}>pricingInfo</button>
            <button onClick={() => console.log(pricingEditObject)}>pricingEditObject</button>
            <button onClick={() => console.log(borrowerInfo)}>borrowerInfo</button>
            <button onClick={() => console.log(guarantorsInfo)}>guarnatorsInfo</button>
            <button onClick={() => console.log(guarantorsEditArray)}>guarantorsEditArray</button>
            <button onClick={() => console.log(selectedBrokerGuarantors)}>selectedBrokerGuarantors</button>
            <button onClick={() => console.log(brokerGuarantors)}>brokerGuarantors</button>
            <button onClick={() => console.log(applicationMetadata)}>applicationMetadata</button>
            <button onClick={() => console.log(activeAccordions)}>activeAccordions</button>
            <button onClick={() => console.log(loanComments)}>loanComments</button>
            <button onClick={() => console.log(filteredCommentRecipients)}>filteredCommentRecipients</button>
            <button onClick={() => console.log(recipientInvalidProps)}>recipientInvalidProps</button>
            <button onClick={() => console.log(commentObj)}>commentObj</button>
            <button onClick={() => console.log(projectPatchObj)}>projectPatchObj</button>
            <button onClick={() => console.log(propertiesPatchArray)}>propertiesPatchArray</button>
            <button onClick={() => console.log(loanProperties)}>loanProperties</button>
            <button onClick={() => console.log(newLoanUnits)}>newLoanUnits</button>
            <button onClick={() => console.log(invalidProps)}>invalidProps</button>
            <button onClick={() => console.log(authToken)}>authToken</button>
          </React.Fragment>}
        </React.Fragment>}
      </div>}
    </div>
  );
};

export default BPApplication;
